var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
  allowTouchMove: el => {
    // Allow touch move on elements with data-scrollable attribute and their children
    // This is critical - must check for data-scrollable FIRST before any other conditions
    while (el && el !== document.body) {
      // Always allow touch on elements explicitly marked as scrollable
      if (el.getAttribute && el.getAttribute('data-scrollable') !== null) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();
window.scrollListener = scrollListener;

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

//use this for all popups
class Popup {
  constructor() {
    this.delegateBody = new Delegate(document.body);
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
    this.languageOverlayElements = document.querySelectorAll(".localizationOverlay");
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    this.delegateBody.on(
      "drawer:close-other",
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      "edit-img:open-popup",
      this.handleOpenOptions.bind(this)
    );

    this.delegateBody.on("keydown", this.handleEscape.bind(this));

    this.delegateBody.on(
      "click",
      ".localizationOverlay",
      this.handleLocalizationOverlayClick.bind(this)
    );

    // Fix: bind close-localization separately with direct DOM listener
    document.addEventListener("click", (e) => {
      const btn = e.target.closest('[data-action="close-localization"]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        this.closeLocalizationPopups();
      }
    });
  }

  closeLocalizationPopups() {
    // Hide overlays
    this.languageOverlayElements.forEach((el) => el.classList.remove("is-visible"));

    // Close any localization popup in the active stack
    const localizationPopups = this.activePopups.filter(
      (p) =>
        p.classList.contains("country-selector__popup") ||
        p.querySelector("localization-modal") ||
        p.id === "modal-country-mobile" ||
        p.id === "modal-country-desktop"
    );

    localizationPopups.forEach((popup) => this.closePopup(popup));

    // Fallback: if not in activePopups, force close by ID
    ["modal-country-mobile", "modal-country-desktop"].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.getAttribute("aria-hidden") !== "true") {
        this._closePopup(el);
        const idx = this.activePopups.indexOf(el);
        if (idx !== -1) this.activePopups.splice(idx, 1);
      }
    });
  }

  handleLocalizationOverlayClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.closeLocalizationPopups();
  }

  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      const controlsId = toggleButton.getAttribute("aria-controls");
      const isLang = controlsId === "modal-country-mobile" || controlsId === "modal-country-desktop";
      if (controlsId === "modal-country-desktop") {
        document.body.dispatchEvent(new CustomEvent("desktop-menus:close", { bubbles: true }));
      }
      if (isLang) {
        const modalEl = document.getElementById(controlsId);
        const show = modalEl && modalEl.getAttribute("aria-hidden") === "true";
        this.languageOverlayElements.forEach((el) => {
          if (show) el.classList.add("is-visible");
          else el.classList.remove("is-visible");
        });

        const btns = document.querySelectorAll(
          '[data-action="toggle-popup"][aria-controls="modal-country-desktop"], [data-action="toggle-popup"][aria-controls="modal-country-mobile"]'
        );
        [...btns, ...this.languageOverlayElements].forEach(el => el.style.pointerEvents = "none");
        setTimeout(() => {
          [...btns, ...this.languageOverlayElements].forEach(el => el.style.pointerEvents = "");
        }, 500);
      }

      setTimeout(() => {
        this.togglePopup(toggleButton);
      }, 50);
      return;
    }

    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }
    }
  }

  togglePopup(button) {
    const popupId = button.getAttribute("aria-controls");
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    const isChild = button.getAttribute("data-child-popup") === "true";

    if (popupElement.getAttribute("aria-hidden") === "false") {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  openPopup(popupElement, isChild = false) {
    popupElement._isChild = isChild;
    popupElement.style.display = "";

    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.setAttribute("aria-hidden", "false");
    popupElement.removeAttribute("inert");

    const popupId = popupElement.id;
    const controlButtons = document.querySelectorAll(`[aria-controls="${popupId}"]`);
    controlButtons.forEach(button => {
      button.setAttribute("aria-expanded", "true");
    });

    requestAnimationFrame(() => {
      popupElement.setAttribute("aria-expanded", "true");
      if (typeof this.onPopupOpen === "function") {
        this.onPopupOpen(popupElement);
      }
      document.body.dispatchEvent(new CustomEvent("header-popup:opened", {
        bubbles: true,
        detail: { popup: popupElement }
      }));
    });

    const focus = popupElement.querySelector("[data-scrollable]");
    if (focus) {
      popupElement._scrollableElement = focus;
      if (typeof bodyScrollLock !== 'undefined') {
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        requestAnimationFrame(() => {
          const paddingValue = document.body.style.paddingRight || '0px';
          document.documentElement.style.setProperty('--body-padding-right', paddingValue);
        });
      }
    }

    trapFocus(popupElement);

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add("is-visible");
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener("click", handleOverlayClick);
    }

    this.activePopups.push(popupElement);
  }

  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement && typeof bodyScrollLock !== 'undefined') {
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
        }
      } else {
        if (closedScrollEl && typeof bodyScrollLock !== 'undefined') {
          bodyScrollLock.enableBodyScroll(closedScrollEl, bodyScrollLockOptions);
          document.documentElement.style.setProperty('--body-padding-right', '0px');
        }
      }
    }
  }

  _closePopup(popupElement) {
    popupElement.setAttribute("aria-expanded", "false");

    const popupId = popupElement.id;
    const controlButtons = document.querySelectorAll(`[aria-controls="${popupId}"]`);
    controlButtons.forEach(button => {
      button.setAttribute("aria-expanded", "false");
    });

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove("is-visible");
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener("click", popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    const isLocalizationPopup =
      popupElement.classList.contains("country-selector__popup") ||
      popupElement.querySelector("localization-modal") ||
      popupElement.id === "modal-country-mobile" ||
      popupElement.id === "modal-country-desktop";

    const transitionEndHandler = () => {
      popupElement.setAttribute("aria-hidden", "true");
      popupElement.setAttribute("inert", "");
      popupElement.removeEventListener("transitionend", transitionEndHandler);
      if (typeof this.onPopupClose === "function") {
        this.onPopupClose(popupElement);
      }
      document.body.dispatchEvent(new CustomEvent("header-popup:closed", {
        bubbles: true,
        detail: { popup: popupElement }
      }));
    };

    if (isLocalizationPopup) {
      const transitionDuration = responsive.matchesBreakpoint("pocket") ? 800 : 400;
      setTimeout(() => {
        popupElement.setAttribute("aria-hidden", "true");
        popupElement.setAttribute("inert", "");
        if (typeof this.onPopupClose === "function") {
          this.onPopupClose(popupElement);
        }
        document.body.dispatchEvent(new CustomEvent("header-popup:closed", {
          bubbles: true,
          detail: { popup: popupElement }
        }));
      }, transitionDuration);
    } else {
      setTimeout(() => {
        popupElement.setAttribute("aria-hidden", "true");
        popupElement.setAttribute("inert", "");
        popupElement.removeEventListener("transitionend", transitionEndHandler);
        document.body.dispatchEvent(new CustomEvent("header-popup:closed", {
          bubbles: true,
          detail: { popup: popupElement }
        }));
      }, 500);

      popupElement.addEventListener("transitionend", transitionEndHandler);
    }
  }

  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute("data-overlay");
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();

class dynamicVariables {
  constructor() {
    this.syncWidth();
    this.syncHeight();

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.thumbnailContainer = document.getElementById("pswp-thumbnails-inside");
    this.imageElements = Array.from(this.element.querySelectorAll(".ProductSliderCell--Zoom img, .product-module__product-slider-cell--zoom img"));
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on("click", '[data-action="open-product-zoom"]', this.initPhotoSwipe.bind(this));
    this.delegateElement.on("click", ".ProductSliderCell--Zoom, .product-module__product-slider-cell--zoom", this.initPhotoSwipeFromImageClick.bind(this));
    // Use click event instead of pswpTap for more reliable closing
    this.delegateRoot.on("click", ".pswp__button--close", this.handleCloseClick.bind(this));
  }

  handleCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close();
    }
  }

  photoswiperClose() {
    // Clean up our custom classes when PhotoSwipe closes
    document.body.classList.remove("scrollLock");
    
    // Remove iOS specific class if present
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
    
    // Ensure PhotoSwipe is properly hidden
    setTimeout(() => {
      const pswp = document.querySelector('.pswp');
      if (pswp) {
        // Force hide by setting aria-hidden and removing open classes
        pswp.setAttribute('aria-hidden', 'true');
        pswp.classList.remove('pswp--open', 'pswp--visible', 'pswp--animated-in', 'pswp--has_mouse');
      }
    }, 100);
  }

  initPhotoSwipe() {
    // Ensure we can reinitialize by clearing any existing instance
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance = null;
    }
    
    var images = [], index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom") || item.classList.contains("product-module__product-slider-cell--zoom")) {
          if (item.querySelector("img")) images.push(item.querySelector("img"));
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      var element = this.slideshow.swiperElement.slides[index_currentSlide].querySelector(".ProductSlider--Element, .product-module__product-slider-element");
      if (element) element.getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), parseInt(index));
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Ensure we can reinitialize by clearing any existing instance
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance = null;
    }
    
    const images = [];
    const siblings = Array.from(target.parentElement.children);
    siblings.forEach((item) => {
      if ((item.classList.contains("ProductSliderCell--Zoom") || item.classList.contains("product-module__product-slider-cell--zoom")) && item.querySelector("img")) {
        images.push(item.querySelector("img"));
      }
    });
    const element = target.querySelector(".ProductSlider--Element, .product-module__product-slider-element");
    const imagePosition = element ? parseInt(element.getAttribute("data-image-position")) : 0;
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      // Get the actual image dimensions
      const maxWidth = parseInt(image.getAttribute("data-max-width")) || image.naturalWidth || window.innerWidth;
      const maxHeight = parseInt(image.getAttribute("data-max-height")) || image.naturalHeight || window.innerHeight;
      
      // Calculate dimensions to fit screen while maintaining aspect ratio
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      
      // Calculate aspect ratio
      const imageAspectRatio = maxWidth / maxHeight;
      const screenAspectRatio = screenWidth / screenHeight;
      
      let displayWidth, displayHeight;
      
      // Fit to screen height (full height)
      if (imageAspectRatio > screenAspectRatio) {
        // Image is wider than screen ratio, fit to height
        displayHeight = screenHeight;
        displayWidth = screenHeight * imageAspectRatio;
      } else {
        // Image is taller than screen ratio, fit to height
        displayHeight = screenHeight;
        displayWidth = screenHeight * imageAspectRatio;
      }
      
      return {
        msrc: image.currentSrc || image.src,
        w: Math.round(displayWidth),
        h: Math.round(displayHeight),
        initialZoomLevel: 1,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    
    // Ensure container is ready for reuse
    if (photoswipeContainer) {
      photoswipeContainer.classList.remove('pswp--open', 'pswp--visible', 'pswp--animated-in', 'pswp--has_mouse');
      photoswipeContainer.setAttribute('aria-hidden', 'true');
      photoswipeContainer.removeAttribute('style');
    }
    this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
      index: selectedImageIndex,
      showHideOpacity: true,
      showAnimationDuration: 300,
      hideAnimationDuration: 200,
      loop: false, // Explicitly disable loop
      history: false,
      closeOnVerticalDrag: true,
      closeOnScroll: false,
      allowPanToNext: true,
      pinchToClose: false,
      errorMsg: '<p class="pswp__error-msg"></p>',
      scaleMode: "fit",
      maxSpreadZoom: 3,
      // Fade effect settings - enable drag but intercept it
      spacing: 0,
      // Enable PhotoSwipe's drag but we'll intercept it
      allowPanToNext: true,
      preventSwipeToClose: false,
      // Allow some friction to detect drag completion
      mainScrollEndFriction: 0.35,
      panEndFriction: 0.35,
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        // Allow more zoom for full-screen images
        if (isMouseClick) return 2;
        return item.initialZoomLevel < 1 ? 1.5 : 2;
      },
      getThumbBoundsFn: function getThumbBoundsFn(index) {
        var allThumbnail = _this.element.querySelectorAll(".mainSwiper .ProductSliderCell--Zoom img, .product-module__main-swiper .product-module__product-slider-cell--zoom img"),
          thumbnail = allThumbnail[index];
        
        if (!thumbnail) return { x: 0, y: 0, w: 0 };
        
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    });

    this.photoSwipeInstance.listen("beforeChange", this.onslideChanged.bind(this));
    this.photoSwipeInstance.listen("destroy", this.destroyPhotoSwipe.bind(this));
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen("initialZoomIn", this.onInitialZoomIn.bind(this));
    this.photoSwipeInstance.listen("initialZoomOut", this.onInitialZoomOut.bind(this));
    
    // Use PhotoSwipe's built-in drag events for better compatibility
    this.photoSwipeInstance.listen("releasePointsOutside", this.handleSwipeNavigation.bind(this));
    this.photoSwipeInstance.listen("dragRelease", this.handleDragRelease.bind(this));

    this.delegateRoot.on("pswpTap", ".pswp__scroll-wrap", this.onSingleTap.bind(this));
    this.delegateRoot.on("pswpTap", ".pswp__button--prev", this.photoSwipeInstance.prev.bind(this.photoSwipeInstance));
    this.delegateRoot.on("pswpTap", ".pswp__button--next", this.photoSwipeInstance.next.bind(this.photoSwipeInstance));
    
    // Listen for PhotoSwipe's close event for cleanup
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    // Listen for destroy event for final cleanup
    this.photoSwipeInstance.listen("destroy", this.destroyPhotoSwipe.bind(this));

    this.createPager(items);

    this.renderModalThumbnails(items);
    this.photoSwipeInstance.init();
    
    // Wait for PhotoSwipe to be fully initialized
    this.photoSwipeInstance.listen('afterInit', () => {
      // Add fade effect class after initialization
      photoswipeContainer.classList.add('pswp--fade-active');
      
      // Set initial slide as current
      this.updateSlideVisibility(selectedImageIndex);
      
      // PhotoSwipe drag events are now handled via native listeners
      
      // Listen for slide changes (from next/prev calls)
      this.photoSwipeInstance.listen("afterChange", () => {
        const currentIndex = this.photoSwipeInstance.getCurrentIndex();
        this.updateSlideVisibility(currentIndex);
        
        // Update button states after animation completes
        setTimeout(() => {
          this.updateButtonStates(currentIndex);
        }, 50);
      });
      
      // Ensure buttons are not disabled during initialization
      this.initializeButtonStates();
    });
    
    document.body.classList.add("scrollLock");
    // Add iOS specific class if on iOS device
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.enableThumbnailScroll();
  }

  enableThumbnailScroll() {
    const thumbs = document.getElementById("pswp-thumbnails-inside");
    if (thumbs) {
      thumbs.addEventListener("wheel", (e) => { e.stopPropagation(); }, { passive: true });
    }
  }

  renderModalThumbnails(items) {
    const container = document.getElementById("pswp-thumbnails-inside");
    if (!container) return;
    container.innerHTML = "";
    items.forEach((item, index) => {
      const thumb = document.createElement("img");
      thumb.src = item.msrc;
      thumb.className = "pswp-modal-thumb";
      thumb.dataset.index = index;
      thumb.addEventListener("click", () => {
        if (this.photoSwipeInstance) this.photoSwipeInstance.goTo(index);
      });
      container.appendChild(thumb);
    });
    this.updateActiveModalThumbnail(0);
  }

  updateActiveModalThumbnail(index) {
    const thumbs = document.querySelectorAll("#pswp-thumbnails-inside .pswp-modal-thumb");
    thumbs.forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });
  }

  onslideChanged() {
    const currentIndex = this.photoSwipeInstance.getCurrentIndex();
    this.updateActiveModalThumbnail(currentIndex);
    
    // Handle fade transitions
    this.updateSlideVisibility(currentIndex);
    
    // Delay button state updates to prevent premature disabling during fade animation
    setTimeout(() => {
      this.updateButtonStates(currentIndex);
    }, 350); // Wait for fade animation to complete (300ms + buffer)
  }
  
  updateButtonStates(currentIndex) {
    const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
    const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");
    const totalItems = this.photoSwipeInstance.options.getNumItemsFn();
    
    if (!prevBtn || !nextBtn) return;
    
    // Only disable if actually at boundaries
    if (currentIndex === 0) {
      prevBtn.setAttribute("disabled", "disabled");
    } else {
      prevBtn.removeAttribute("disabled");
    }
    
    if (currentIndex + 1 === totalItems) {
      nextBtn.setAttribute("disabled", "disabled"); 
    } else {
      nextBtn.removeAttribute("disabled");
    }
  }
  
  initializeButtonStates() {
    // Ensure buttons are enabled initially and not disabled during transitions
    setTimeout(() => {
      const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
      const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");
      
      if (prevBtn && nextBtn) {
        // Remove any disabled state initially 
        prevBtn.removeAttribute("disabled");
        nextBtn.removeAttribute("disabled");
        
        // Add CSS to prevent premature visual disabled state
        prevBtn.style.pointerEvents = 'auto';
        nextBtn.style.pointerEvents = 'auto';
      }
    }, 100);
  }

  updateSlideVisibility(currentIndex) {
    const items = this.photoSwipeInstance.scrollWrap.querySelectorAll('.pswp__item');
    const totalItems = items.length;
    
    // Normalize the index to handle loop scenarios
    const normalizedIndex = currentIndex % totalItems;
    
    items.forEach((item, index) => {
      if (index === normalizedIndex) {
        item.classList.add('pswp__item--current');
      } else {
        item.classList.remove('pswp__item--current');
      }
    });
  }
  
  handleSwipeNavigation() {
    // This gets called when PhotoSwipe detects a swipe
    // We can use this to trigger our fade transitions
  }
  
  handleDragRelease(e) {
    // PhotoSwipe provides drag information in the event
    if (!e.deltaX && !e.deltaY) {
      return;
    }
    
    const deltaX = e.deltaX || 0;
    const deltaY = e.deltaY || 0;
    const threshold = 50;
    
    // Check if it's a horizontal swipe
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
      const currentIndex = this.photoSwipeInstance.getCurrentIndex();
      const totalItems = this.photoSwipeInstance.options.getNumItemsFn();
      
      // Prevent PhotoSwipe's default slide change
      e.prevent = true;
      
      if (deltaX > 0) {
        // Swiped right - go to previous slide
        if (currentIndex > 0) {
          this.photoSwipeInstance.prev();
        }
      } else {
        // Swiped left - go to next slide
        if (currentIndex < totalItems - 1) {
          this.photoSwipeInstance.next();
        }
      }
    }
  }
  


  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) return;
      event.target.closest(".pswp").querySelector(".pswp__ui").classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
    // Ensure current slide is visible when zooming in
    setTimeout(() => {
      const currentIndex = this.photoSwipeInstance.getCurrentIndex();
      this.updateSlideVisibility(currentIndex);
    }, 50);
  }

  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }

  destroyPhotoSwipe() {
    // Clean up event listeners
    this.delegateRoot.off("pswpTap", ".pswp__scroll-wrap");
    this.delegateRoot.off("pswpTap", ".pswp__button--prev");
    this.delegateRoot.off("pswpTap", ".pswp__button--next");
    
    // Remove fade effect class
    const pswp = document.querySelector('.pswp');
    if (pswp) {
      pswp.classList.remove('pswp--fade-active');
      // Remove all current slide classes
      const items = pswp.querySelectorAll('.pswp__item');
      items.forEach(item => item.classList.remove('pswp__item--current'));
    }
    
    // Clean up our custom classes and state
    document.body.classList.remove("scrollLock");
    
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
    
    // Clear the instance reference
    this.photoSwipeInstance = null;
  }

  ensureCleanup() {
    // Force cleanup of PhotoSwipe container
    const pswp = document.querySelector('.pswp');
    if (pswp) {
      // Remove all open state classes
      pswp.classList.remove('pswp--open', 'pswp--visible', 'pswp--animated-in', 'pswp--has_mouse');
      pswp.setAttribute('aria-hidden', 'true');
    }
    
    // Remove body classes
    document.body.classList.remove("scrollLock");
    
    // Remove iOS specific class if present
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  createPager(items) {
    const ui = document.querySelector('.pswp__ui');
    if (!ui) return;
    ui.querySelector('.pswp__pager')?.remove();
    const pager = document.createElement('div');
    pager.className = 'pswp__pager u-p1';
    ui.appendChild(pager);
    const width = String(items.length).length;
    const pad = (n) => String(n).padStart(width, '0');
    const update = () => {
      const i = this.photoSwipeInstance.getCurrentIndex() + 1;
      pager.textContent = `${pad(i)}/${pad(items.length)}`;
    };
    update();
    this.photoSwipeInstance.listen('beforeChange', update);
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    // Prevent duplicate initialization
    if (element._revolutionSelectboxInitialized) {
      return element._revolutionSelectboxInstance;
    }
    
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    
    // Mark element as initialized and store instance
    element._revolutionSelectboxInitialized = true;
    element._revolutionSelectboxInstance = this;

    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(".RevolutionSelectbox--Content");
    this.marketSelector = this.element.classList.contains("rs-country__selectbox");
    this.languageSelector = this.element.classList.contains("rs-language__selectbox");
    this.mainDropdownContent = this.element.querySelector(".RevolutionSelectbox--InnerContent");
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");
    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector("[name=" + this.connectedSelect + "]");
    
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(".localizationOverlay");
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {

    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on("click", "[data-action=toggle-selectbox]", this.toggleDropdown.bind(this));
    this.domDelegate.on("click", "[data-action=selectbox-change]", this.selectboxChange.bind(this));
    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.delegateBody.on("topbar:slideoff", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "[data-action=selectbox-submit]", this.selectboxSubmit.bind(this));
    this.domDelegate.on("keypress", "[data-action=selectbox-submit]", this.selectboxSubmit.bind(this));
    
    // Listen for events to close this selector when the other one opens
    if (this.marketSelector || this.languageSelector) {
      this.delegateBody.on("close:marketSelector", () => {
        if (this.marketSelector && this.isOpen) {
          this.closeDropdown(this.element);
        }
      });
      this.delegateBody.on("close:languageSelector", () => {
        if (this.languageSelector && this.isOpen) {
          this.closeDropdown(this.element);
        }
      });
    }
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;

    var selEl = this.element.querySelector("#" + selectboxID);


    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }


    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;

    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );
    }
    if (event.target.dataset.selectboxid == 'language_code') {
      this.element.dispatchEvent(
        new CustomEvent("change:languageSelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.closeDropdown(this.element);

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    // Submit only if there is a real form and we're not inside compare-section
    const formEl = this.selectbox?.closest('form');
    if (formEl && !this.element.closest('compare-section')) {
      formEl.submit();
    }
  }

  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }
    // Only trap focus for popover-style selectboxes (e.g., modal/overlays)
    if (this.popover) {
      trapFocus(this.element);
    }
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    event.stopPropagation(); // Prevent event bubbling to parent handlers

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Prevent duplicate calls if already open
    if (this.isOpen) {
      return;
    }

    // Set the flag immediately to prevent race conditions
    this.isOpen = true;

    // Close the other selector (market or language) when one opens
    if (this.marketSelector) {
      document.body.dispatchEvent(
        new CustomEvent("close:languageSelector", { bubbles: true })
      );
    } else if (this.languageSelector) {
      document.body.dispatchEvent(
        new CustomEvent("close:marketSelector", { bubbles: true })
      );
    }

    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'true')
    }
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    // Consolidated body scroll lock logic - only call ONCE
    // Check if we need to disable body scroll (for overlays, mobile scrollable content, or country selector)
    const shouldDisableScroll = this.changeOverlay || 
                                this.element.closest(".focusable.country-selector") ||
                                (this.element.querySelector('[data-scrollable]') && responsive.matchesBreakpoint('pocket'));

    if (shouldDisableScroll) {
      const focus = this.element.querySelector("[data-scrollable]");
      
      if (focus && typeof bodyScrollLock !== 'undefined') {
        // Ensure the scrollable element has proper touch scrolling enabled
        focus.style.webkitOverflowScrolling = 'touch';
        focus.style.touchAction = 'pan-y';
        focus.style.overflowY = 'auto';
        
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      contentElement.style.overflow = 'hidden';
      const height = contentElement.offsetHeight;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';
      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
        // Reset overflow after animation starts to allow scrolling if needed
        setTimeout(() => {
          if (contentElement.offsetHeight > 0) {
            contentElement.style.overflow = '';
          }
        }, 300);
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    if (!this.isOpen) return;

    // Set the flag immediately to prevent stuck state
    this.isOpen = false;

    const el = this.element;
    const scrollable = el.querySelector('[data-scrollable]');

    const dropdownRoot   = target.closest('.RevolutionSelectbox')
                           || el.querySelector("[aria-expanded='true']")?.parentElement;
    if (!dropdownRoot) return;

    const button  = dropdownRoot.querySelector('.RevolutionSelectbox--Button');
    const content = dropdownRoot.querySelector('.RevolutionSelectbox--Content');

    if (this.changeOverlay || (el.querySelector('[data-scrollable]') && responsive.matchesBreakpoint('pocket'))) {
      if (scrollable && typeof bodyScrollLock !== 'undefined') {
        bodyScrollLock.enableBodyScroll(scrollable, bodyScrollLockOptions);
      }
    }
  
    dropdownRoot?.setAttribute('aria-expanded', 'false');
    button?.setAttribute('aria-expanded', 'false');
    content?.setAttribute('aria-hidden', 'true');
    
    // Animate height to 0 for smooth closing
    if (content) {
      const currentHeight = content.offsetHeight;
      content.style.height = `${currentHeight}px`;
      content.style.overflow = 'hidden';
      
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    }
  
    const OnTransitionEnd = (e) => { 
      if (e.target === content && e.propertyName === 'height') {
        content.style.display = 'none';
        content.style.height = '';
        content.style.overflow = '';
        content.removeEventListener('transitionend', OnTransitionEnd);
      }
    };

    if (content) {
      content.addEventListener('transitionend', OnTransitionEnd);
    }

    // Fallback timeout in case transition doesn't fire
    setTimeout(() => {
      if (content) {
        content.style.display = 'none';
        content.style.height = '';
        content.style.overflow = '';
        content.removeEventListener('transitionend', OnTransitionEnd);
      }
    }, 350);
  
    if (this.keydownListener) {
      window.removeEventListener('keydown', this.keydownListener);
      this.keydownListener = null;
    }
    window.removeEventListener('click', this.onClickOutsideListener);
  
    if (this.popover) {
      this.pageOverlayElement.classList.remove('is-visible');
      document.querySelector('.header-overlay')?.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener(
        'click',
        this.onClickOutsideListener
      );
    }
  
    removeTrapFocus(this.mainDropdownContent);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}


class CollectionTabs extends HTMLElement {
    constructor() {
        super();
        this.element = this;
    }

    connectedCallback() {
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
        // Initialize active states on page load
        this.initializeActiveStates();
    }

    bindEvents() {
        this.delegateElement.on('click', '[data-action="apply-type-filter"]', this.applyTypeFilter.bind(this));
        this.delegateElement.on('keydown', '[data-action="apply-type-filter"]', this.handleKeydown.bind(this));
    }

    handleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.applyTypeFilter(e);
        }
    }

     initializeActiveStates() {
        const currentUrl = new URL(window.location);
        const searchParams = new URLSearchParams(currentUrl.search);
        const typeFilterValue = searchParams.get('filter.p.m.custom.connected_product_title');
        
        if (typeFilterValue) {
            // A type filter is active, set the matching filter as active
            this.updateActiveStates('filter.p.m.custom.connected_product_title', typeFilterValue);
        } else {
            // No type filter active, set "Show All" as active
            this.updateActiveStatesForShowAll();
        }
    }

applyTypeFilter(e) {
    e.preventDefault();
    
    const filterElement = e.target.closest('[data-action="apply-type-filter"]');
    if (!filterElement) return;
    
    const filterParam = filterElement.dataset.filterParam;
    const filterValue = filterElement.dataset.filterValue;

    // Get current URL parameters
    const currentUrl = new URL(window.location);
    const searchParams = new URLSearchParams(currentUrl.search);
    
    // Check if this is the "Show All" option (empty or undefined filter param and value)
    if (!filterParam || filterParam === '' || !filterValue || filterValue === '') {
        // Remove all type filters for "Show All"
        searchParams.delete('filter.p.m.custom.connected_product_title');
        this.updateActiveStatesForShowAll();
    } else {
        // Handle regular type filter
        const isActive = filterElement.dataset.active === 'true';
        
        if (isActive) {
            searchParams.delete(filterParam);
            this.updateActiveStatesForShowAll();
        } else {
            searchParams.delete(filterParam);
            searchParams.set(filterParam, filterValue);
            this.updateActiveStates(filterParam, filterValue);
        }
    }

    // Clean up any empty or malformed parameters
    const cleanedParams = new URLSearchParams();
    for (const [key, value] of searchParams.entries()) {
        if (key && key.trim() !== '' && value && value.trim() !== '') {
            cleanedParams.set(key, value);
        }
    }

    // Update the URL and trigger the existing filter system
    const collectionFiltersForm = document.querySelector('collection-filters-form');
    if (collectionFiltersForm) {
        const loader = collectionFiltersForm.querySelector('.spinningLoader');
        if (loader) {
            loader.classList.add('is-visible');
        }
        
        collectionFiltersForm.renderPage(cleanedParams.toString(), e);
    }
}

    // Method to update visual active states
updateActiveStates(filterParam, activeValue) {
    const typeFilters = this.element.querySelectorAll('[data-action="apply-type-filter"]');
    
    typeFilters.forEach(filter => {
        const slide = filter.closest('.swiper-slide');
        const filterValue = filter.dataset.filterValue;
        const filterParamElement = filter.dataset.filterParam;
        
        if (activeValue && filterValue === activeValue) {
            // Set the matching filter as active
            filter.dataset.active = 'true';
            slide.classList.add('type-filter-active');
        } else {
            // Set all others as inactive (including "Show All")
            filter.dataset.active = 'false';
            slide.classList.remove('type-filter-active');
        }
    });
}

updateActiveStatesForShowAll() {
    const typeFilters = this.element.querySelectorAll('[data-action="apply-type-filter"]');
    
    typeFilters.forEach(filter => {
        const slide = filter.closest('.swiper-slide');
        const filterParam = filter.dataset.filterParam;
        const filterValue = filter.dataset.filterValue;
        
        // If it's the "Show All" option (empty param and value), set as active
        if (!filterParam && !filterValue) {
            filter.dataset.active = 'true';
            slide.classList.add('type-filter-active');
        } else {
            // All other filters become inactive
            filter.dataset.active = 'false';
            slide.classList.remove('type-filter-active');
        }
    });
}

clearAllActiveStates() {
    const typeFilters = this.element.querySelectorAll('[data-action="apply-type-filter"]');
    
    typeFilters.forEach(filter => {
        const slide = filter.closest('.swiper-slide');
        const filterParam = filter.dataset.filterParam;
        const filterValue = filter.dataset.filterValue;
        
        // Set "Show All" as active, others as inactive
        if (!filterParam && !filterValue) {
            filter.dataset.active = 'true';
            slide.classList.add('type-filter-active');
        } else {
            filter.dataset.active = 'false';
            slide.classList.remove('type-filter-active');
        }
    });
}
}

customElements.define('collection-tabs', CollectionTabs);

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action=add-to-cart]", this.addToCart.bind(this));
  }

  addToCart(event) {
    event.preventDefault();
    var _this = this;

    var addToCartButton = event.target;
    this.pageLoader.style.width = "100%";
    addToCartButton.setAttribute("disabled", "disabled");

    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");

    var formHelper = new Form();
    const mainItem = formHelper.serialize(formElement);

    const qty = Math.max(1, parseInt(mainItem.quantity || 1, 10) || 1);

    const items = [{
      id: mainItem.id,
      quantity: qty,
      properties: mainItem.properties || {}
    }];

    const addonInputs = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked');
    addonInputs.forEach(input => {
      items.push({
        id: input.dataset.productid,
        quantity: qty
      });
    });

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify({ items }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variants: items.map(item => item.id),
              total_quantity: items.reduce((sum, item) => sum + parseInt(item.quantity, 10), 0)
            }
          })
        );
      } else {
        response.json().then(function (content) {
          const errorContainer = _this.element.querySelector(".ProductForm--Error");
          if (errorContainer) {
            errorContainer.classList.add("visible");
            setTimeout(() => errorContainer.classList.remove("visible"), 2500);
          } else {
            const errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
            setTimeout(() => errorMessageElement.remove(), 2500);
          }

          _this.pageLoader.style.left = "unset";
          _this.pageLoader.style.right = "0px";
          _this.pageLoader.style.width = "0%";
          setTimeout(() => {
            _this.pageLoader.style.left = "0px";
            _this.pageLoader.style.right = "unset";
          }, 550);
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle - ALWAYS bind this regardless of breakpoint
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    // ADDITIONAL: Bind specifically for info__dropdown-button class used in PDP
    this.domDelegate.on(
      "click",
      ".info__dropdown-button[data-action='toggle-dropdown']",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    
    // Skip if the dropdown is inside a product-component (handled by ProductElement)
    if (target.closest('product-component')) {
      return;
    }
    
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.headerEl = document.body.querySelector('#header');
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    // Detect iOS devices for scroll lock
    this.isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
    
    // Initialize scroll lock tracking
    this._lockedElement = null;

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    // Bind transition events for menu optimization
    this._onTransitionStart = this.onTransitionStart.bind(this);
    this._onTransitionEnd = this.onTransitionEnd.bind(this);
    // Generic end handler to ensure aria-hidden is toggled after close animations
    this._onAnyEnd = (e) => {
      // Only react for our drawer element
      if (e && e.target !== this.element) return;
      // Hide only when collapsed
      const isCollapsed = this.element.getAttribute('aria-expanded') === 'false';
      if (isCollapsed) {
        // For menu, also ensure it's fully hidden for layout
        if (this.element.getAttribute('id') === 'menu') {
          this.element.style.display = 'none';
          this.element.classList.add('menu-fully-hidden');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
    };

    // Static property to track all drawer instances
    if (!Drawer.instances) {
      Drawer.instances = [];
    }
    Drawer.instances.push(this);

    this.bindEvents();

  // Always observe transitions/animations ending on the drawer for proper aria-hidden sync
  this.element.addEventListener('transitionend', this._onAnyEnd);
  this.element.addEventListener('animationend', this._onAnyEnd);
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.closeDrawerEsc.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);

    // Listen for the custom event to close the drawer
    document.body.addEventListener('drawer:close-other', () => {
      if (this.isOpen) {
        this.closeDrawer();
      }
    });
  }

  closeDrawerEsc(e) {
    if (e.key !== "Escape") return;

    if (this.isOpen) {
      this.closeDrawer(e);
    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  // New method to close all other open drawers
  closeOtherDrawers() {    
    if (!Drawer.instances || Drawer.instances.length <= 1) return;
    
    for (let i = 0; i < Drawer.instances.length; i++) {
      const drawer = Drawer.instances[i];
      if (drawer !== this && drawer.isOpen) {
        drawer.closeDrawer();
      }
    }
  }

  openDrawer(event, isUserAction = true) {
    // Close all other open drawers before opening this one
    this.closeOtherDrawers();

    if (this.element.getAttribute("id") == "cart-drawer") {
       // GTM tracking for cart icon click
     if (isUserAction && typeof dataLayer !== 'undefined') {
       dataLayer.push({
         event: 'cart_icon',
         location: 'header'
       });
       console.log("dataLayer push -> cart_icon");
     }
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }

    // Add custom event for account drawer
    if (this.element.getAttribute("id") == "accountDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("account-drawer:open", { bubbles: true })
      );
    }

    // Generic drawer open event for HeaderTransparencyController
    this.element.dispatchEvent(
      new CustomEvent("drawer:open", { bubbles: true, detail: { drawerId: this.element.id } })
    );

    if (this.isOpen) {
      return;
    }

    dynamicVars.syncHeight();


    if(this.element.getAttribute("id") === "collection__filter-drawer") {
       this.element.classList.add("is-active");
    }


    if (this.element.getAttribute("id") == "menu" || this.element.getAttribute("id") == "Drawer") {

      this.hamburger = document.body.querySelector(".header-hamburger");
      this.hamburgerButton = document.body.querySelector(".header-hamburger-btn");
      if (this.hamburger) {
        this.hamburger.classList.add("is-active");
        this.hamburger.setAttribute("aria-label", "Close main menu");
      }
      if (this.hamburgerButton) {
        this.hamburgerButton.setAttribute("aria-expanded", "true");
      }
      document.querySelector(".Drawer--Close")?.style.setProperty("display", "block");
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
      
      // Prepare menu for opening animation
      this.prepareMenuForOpening();
      
      // Set aria attributes with slight delay for animation
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
        this.element.setAttribute("aria-expanded", "true");
      });
    } else {
      // Prepare any non-menu drawer (e.g., search, cart, favorites) for opening with animation
      // 1) Make it visible but keep collapsed state to get starting transform
      this.element.style.display = 'block';
      // Force reflow so initial state (aria-expanded="false") is applied while visible
      this.element.offsetHeight;
      // 2) Next frame, flip aria to open to animate transform
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
        this.element.setAttribute("aria-expanded", "true");
      });
    }

    if (this.element.getAttribute("id") == "accountDrawer" || this.element.classList.contains("customerAccount--Popup")) {
      this.element.setAttribute("aria-hidden", "false");
      this.element.classList.add("is-active");
      this.element.dispatchEvent(new CustomEvent("desktop-menus:close", { bubbles: true }));
      setTimeout(() => {
        this.element.setAttribute("aria-expanded", "true");
      }, 0);
    } else {
      this.element.setAttribute("aria-expanded", "true");
    }

    // Condition where overlay should show over ann bar and top bar
    if (responsive.matchesBreakpoint("lap_and_up") && (this.element.classList.contains("customerAccount--Popup")) || this.element.getAttribute("id") == "accountDrawer" || this.element.getAttribute("id") === "collection__filter-drawer" || this.element.getAttribute("id") === "cart-drawer") {
      this.pageOverlayElement.classList.add("overlay-over-header");
    }

    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    this.isOpen = true;
    
    // Call onOpen first (which may set display: block)
    this.onOpen();
    
    // Apply comprehensive scroll lock
    this.lockBodyScroll();
    
    // Apply trapFocus
    setTimeout(() => {
      trapFocus(this.element);
    }, 300);

    return false;
  }
  
  // Simple scroll lock method
  lockBodyScroll() {
    // Find scrollable element within drawer
    const scrollableElement = this.element.querySelector("[data-scrollable]") || this.element;
    
    // Store reference for cleanup
    this._lockedElement = scrollableElement;
    
    // Add scrollLock class
    // document.body.classList.add('scrollLock');
    // document.documentElement.classList.add('scrollLock');
    
    // Use bodyScrollLock library for proper touch handling
    if (typeof bodyScrollLock !== 'undefined') {
      try {
        bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
      } catch (e) {
        console.warn('bodyScrollLock error:', e);
      }
    }
  }
  
  // Simple scroll unlock method
  unlockBodyScroll() {
    // Remove scrollLock class
    // document.body.classList.remove('scrollLock');
    // document.documentElement.classList.remove('scrollLock');
    
    // bodyScrollLock library cleanup
    if (typeof bodyScrollLock !== 'undefined') {
      try {
        if (this._lockedElement) {
          bodyScrollLock.enableBodyScroll(this._lockedElement);
        }
        bodyScrollLock.clearAllBodyScrollLocks();
      } catch (e) {
        console.warn('bodyScrollLock cleanup error:', e);
      }
    }
    
    // Clear reference
    this._lockedElement = null;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }


    this.element.setAttribute("aria-expanded", "false");

    if (this.element.getAttribute("id") == "menu" || this.element.getAttribute("id") == "Drawer") {

      this.hamburger = document.body.querySelector(".header-hamburger");
      this.hamburgerButton = document.body.querySelector(".header-hamburger-btn");
      if (this.hamburger) {
        this.hamburger.classList.remove("is-active");
        this.hamburger.setAttribute("aria-label", "Open main menu");
      }
      if (this.hamburgerButton) {
        this.hamburgerButton.setAttribute("aria-expanded", "false");
      }
        this.element.dispatchEvent(
          new CustomEvent("menu-drawer:closed", { bubbles: true })
        );
        
        // Prepare menu for closing animation
        this.prepareMenuForClosing();
    }

    // Clear form on button cancel -> account new address form
    if (this.element.getAttribute("id") === "modal-address-new") {
      document.querySelector('account-component-inner').style.zIndex = '';
      const formInputs = this.element.querySelectorAll("input.input-placeholder");
      const selectInput = this.element.querySelector(".custom-select-wrapper #AddressCountryNew");
      const checkboxInput = this.element.querySelector(".customerAddress--defaultCheckbox #address[default]");

      formInputs.forEach((input) => (input.value = ""));// Clear text inputs
      if (selectInput) selectInput.selectedIndex = 0; // Reset select input (fallback to first option)
      if (checkboxInput) checkboxInput.checked = false; // Uncheck checkbox
    }

    // Unlock body scroll
    this.unlockBodyScroll();

    if (this.element.getAttribute("id") == "cart-drawer") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:closed", { bubbles: true })
      );
    }

    // Add custom event for account drawer
    if (this.element.getAttribute("id") == "accountDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("account-drawer:closed", { bubbles: true })
      );
    }

    // Generic drawer close event for HeaderTransparencyController
    this.element.dispatchEvent(
      new CustomEvent("drawer:closed", { bubbles: true, detail: { drawerId: this.element.id } })
    );
    
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }
    this.element.setAttribute("aria-expanded", "false");
    if (this.element.getAttribute("id") == "accountDrawer" || this.element.classList.contains("customerAccount--Popup") || this.element.getAttribute("id") == "cart-drawer" || this.element.getAttribute("id") == "collection__filter-drawer") {
      this.element.classList.remove("is-active");
      
      // Disable cart button during animation if this is cart drawer
      if (this.element.getAttribute("id") == "cart-drawer") {
        const cartBtn = document.querySelector(".header-cart-btn");
        if (cartBtn) cartBtn.disabled = true;
      }
      
      // Wait for the clip-path transition to complete
      const onTransitionEnd = (e) => {
        // Only react to clip-path transitions on this element
        if (e.target === this.element && e.propertyName === 'clip-path') {
          // Clean up event listener
          this.element.removeEventListener('transitionend', onTransitionEnd);
          
          // Hide only if still collapsed
          if (this.element.getAttribute('aria-expanded') === 'false') {
            this.element.setAttribute("aria-hidden", "true");
            // For cart drawer, also hide with display none
            if (this.element.getAttribute("id") == "cart-drawer") {
              this.element.style.display = "none";
            }
          }
        }
      };

      // Add event listener for transition end
      this.element.addEventListener('transitionend', onTransitionEnd);

      // Fallback timeout in case transition doesn't fire (safety net)
      setTimeout(() => {
        this.element.removeEventListener('transitionend', onTransitionEnd);
        if (this.element.getAttribute('aria-expanded') === 'false') {
          this.element.setAttribute("aria-hidden", "true");
          // For cart drawer, also hide with display none
          if (this.element.getAttribute("id") == "cart-drawer") {
            this.element.style.display = "none";
          }
        }
      }, 800); // Slightly longer than animation duration as fallback
    }

    // Defer aria-hidden until transition/animation finishes to preserve close animation
    // Skip this for drawers that have specific handling above
    if (this.element.getAttribute("id") !== "accountDrawer" && 
        !this.element.classList.contains("customerAccount--Popup") && 
        this.element.getAttribute("id") !== "cart-drawer" &&
        this.element.getAttribute("id") !== "collection__filter-drawer") {
      
      const el = this.element;
      const onDone = () => {
        // Only hide if still collapsed
        if (el.getAttribute('aria-expanded') === 'false') {
          // For menu, also fully hide (display none) for layout correctness
          if (el.getAttribute('id') === 'menu') {
            el.style.display = 'none';
            el.classList.add('menu-fully-hidden');
          }
          // Clear display inline style for other drawers so CSS can control visibility
          if (el.getAttribute('id') !== 'menu') {
            el.style.display = '';
          }
          el.setAttribute('aria-hidden', 'true');
        }
        cleanup();
      };

      const onTransitionEnd = (e) => {
        // React on the primary animated properties
        if (!e || ['transform', 'clip-path', 'opacity', 'height'].includes(e.propertyName)) {
          onDone();
        }
      };

      const onAnimationEnd = () => onDone();

      const cleanup = () => {
        el.removeEventListener('transitionend', onTransitionEnd);
        el.removeEventListener('animationend', onAnimationEnd);
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
      };

      // Attach listeners
      el.addEventListener('transitionend', onTransitionEnd);
      el.addEventListener('animationend', onAnimationEnd);

      // Fallback in case no events fire (e.g., reduced motion, zero duration)
      const cs = window.getComputedStyle(el);
      const td = (cs.transitionDuration || '0s').split(',').map(s => parseFloat(s) || 0);
      const ad = (cs.animationDuration || '0s').split(',').map(s => parseFloat(s) || 0);
      const maxDur = Math.max(...td, ...ad) || 0;
      let fallbackTimer = null;
      if (maxDur === 0) {
        // No transition; hide on next frame
        requestAnimationFrame(onDone);
      } else {
        fallbackTimer = setTimeout(onDone, (maxDur * 1000) + 50);
      }
    }

    


    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.classList.remove("overlay-over-header");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    if(this.pageOverlayElement.classList.contains("is-search-drawer")) {
      this.pageOverlayElement.classList.remove("is-search-drawer");
    }

    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
  }

  // Prepare menu for opening
  prepareMenuForOpening() {
    if (this.element.getAttribute("id") !== "menu" && !this.element.classList.contains('mobile-menu')) return;

    if(this.element.classList.contains('mobile-menu') && document.querySelector('newsletter-popup[aria-hidden="false"]')) {
      document.querySelector('newsletter-popup').setAttribute('aria-hidden', 'true');
      document.querySelector('newsletter-popup').setAttribute('aria-expanded', 'false');
    }

    // Remove fully hidden class and set display: block
    this.element.classList.remove('menu-fully-hidden');
    this.element.style.display = 'block';
    
    // Force browser reflow to apply display: block before animation
    this.element.offsetHeight;
    
    // Recalculate heights now that menu is visible
    const mainMenuDropdown = this.element.closest('main-menu-dropdown');
    if (mainMenuDropdown && mainMenuDropdown.updateHeights) {
      mainMenuDropdown.updateHeights();
    }
    
    // Add transition event listeners
    this.element.addEventListener('transitionstart', this._onTransitionStart);
    this.element.addEventListener('transitionend', this._onTransitionEnd);
  }

  // Handle transition start event
  onTransitionStart(event) {
    if (this.element.getAttribute("id") !== "menu") return;
    if (event.propertyName === 'clip-path') {
      // Additional logic can be added here if needed
    }
  }

  // Handle transition end event
  onTransitionEnd(event) {
    if (this.element.getAttribute("id") !== "menu") return;
  if (event.propertyName === 'clip-path' || event.propertyName === 'transform' || event.propertyName === 'opacity') {
      const isExpanded = this.element.getAttribute('aria-expanded') === 'true';
      
      if (!isExpanded) {
        // Menu is closed - hide it completely
        this.hideMenuCompletely();
      }
      
      // Remove event listeners
      this.element.removeEventListener('transitionstart', this._onTransitionStart);
      this.element.removeEventListener('transitionend', this._onTransitionEnd);
    }
  }

  // Completely hide menu
  hideMenuCompletely() {
    if (this.element.getAttribute("id") !== "menu") return;
    
    // Set display: none and add class
    this.element.style.display = 'none';
    this.element.classList.add('menu-fully-hidden');
    
    // Set aria-hidden to true
    this.element.setAttribute("aria-hidden", "true");
  }

  // Prepare menu for closing
  prepareMenuForClosing() {
    if (this.element.getAttribute("id") !== "menu") return;
    
    // Add transition event listeners for closing
    this.element.addEventListener('transitionstart', this._onTransitionStart);
    this.element.addEventListener('transitionend', this._onTransitionEnd);
  }
}


class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
    
    var _this = this;
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.display = "none";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };
    
    this.element.addEventListener("transitionend", transitionEnded);
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    // Ensure element is displayed before animating
    if (this.element.style.display === "none" || window.getComputedStyle(this.element).display === "none") {
      this.element.style.display = "block";
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    // Force reflow before setting height
    this.element.offsetHeight;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "scale(96%)", opacity: "0" },
            { transform: "scale(100%)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration * 2,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateY(-30px)", opacity: "0" },
            { transform: "translateY(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateY(30px)", opacity: "0" },
            { transform: "translateY(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateX(30px)", opacity: "0" },
            { transform: "translateX(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateX(-30px)", opacity: "0" },
            { transform: "translateX(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateX(120px)", opacity: "0" },
            { transform: "translateX(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateX(-120px)", opacity: "0" },
            { transform: "translateX(0px)", opacity: "1" },
          ],
          {
            duration: window.theme.animationDuration,
            fill: "forwards",
          }
        );
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([{ opacity: "0" }, { opacity: "1" }], {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Text animation from bottom with rotation - like your TitleAnimation
  elementAnimTxt(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { 
              transform: "translateY(110%) rotate(10deg)", 
              opacity: "0" 
            },
            { 
              transform: "translateY(0%) rotate(0deg)", 
              opacity: "1" 
            },
          ],
          {
            duration: 1000, // 1s kao u tvojoj animaciji
            easing: "ease",
            fill: "forwards",
          }
        );
      }, 100 * i); // 0.1s delay between elements
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          elementFadeIn: "elementFadeIn",
          elementAnimTxt: "elementAnimTxt",
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class cartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isAnimating = false; // lock flag
  }

  connectedCallback() {
    this.element = this;
    this.element.style.display = "none";
    this.delegateElement = new Delegate(this.element);

    requestAnimationFrame(() => this.recheckHeights());
    window.addEventListener("resize", () => this.recheckHeights());

    this.overlay = document.querySelector(".pageOverlay");

    this.drawer = new Drawer(this.element, {
      onOpen: () => {
        if (this.isAnimating) return; 
        this.isAnimating = true;

        this.isOpen = true;
        this.alreadyEntered = true;

        this.element.style.display = "block";
        void this.element.offsetWidth;
        this.element.classList.add("is-active");

        if (this.overlay) {
          this.overlay.classList.add("is-visible");
        }

        const closeBtn = this.element.querySelector(".cart-drawer__close-button");
        if (closeBtn) closeBtn.disabled = true;

        setTimeout(() => {
          if (closeBtn) closeBtn.disabled = false;
          this.isAnimating = false; 
          this.recheckHeights();
        }, 600);
      },
      onClose: () => {
        // Simple cart-specific cleanup, no animation handling
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.isAnimating = false;

        // Re-enable cart button
        const cartBtn = document.querySelector(".header-cart-btn");
        if (cartBtn) cartBtn.disabled = false;
      }
    });

    this.loader = this.element.querySelector(".spinningLoader");
    this.loaderStartTime = 0;

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.recommendationsLoaded = false;
    this.alreadyEntered = false;

    this.addToCartInstance = new AddToCart(this.element);
    this.bindEvents();
    this.renderCartItemsNumber();
  }


  bindEvents() {
    if (window.theme.listener == "false") {
      if (this.options["showRecommendations"] && !this.alreadyEntered) {
        this.loadRecommendations();
      }
      this.onProductAddedListener = this.onProductAdded.bind(this);
      this.onSidecartOpen = this.onSidecartOpen.bind(this);
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".CartItem__QuantitySelector",
        this.updateItemQuantity.bind(this)
      );
      window.theme.listener = "true";
    }
  }

  showRecommendationsLoader() {
    if (this.loader) {
      this.loader.classList.add("is-visible");
      this.loaderStartTime = Date.now();
    }
  }

  hideRecommendationsLoader() {
    if (!this.loader) return;
    const elapsed = Date.now() - this.loaderStartTime;
    const remaining = 600 - elapsed;
    if (remaining > 0) {
      setTimeout(() => this.loader.classList.remove("is-visible"), remaining);
    } else {
      this.loader.classList.remove("is-visible");
    }
  }

  onSidecartOpen() {
    this.isOpen = true;
    if (this.options["showRecommendations"] && !this.alreadyEntered) {
      this.loadRecommendations();
    }
    this.alreadyEntered = true;
  }

  async updateItemQuantity(event, target) {
  event.preventDefault();
  const cartItem = target.closest(".cartItem");
  const itemLoader = cartItem.querySelector(".itemLoader");

  if (itemLoader) itemLoader.classList.add("is-visible");

  let quantity;
  if (target.tagName === "INPUT") {
    quantity = Math.max(parseInt(target.value, 10) || 0, 0);
  } else {
    quantity = parseInt(target.getAttribute("data-quantity"), 10);
  }

  const payload = {
    id: target.getAttribute("data-line-id"),
    quantity: quantity,
  };

  const isRemove = quantity === 0; 

  if (isRemove) {
    cartItem.classList.add("removing");
    const id = cartItem.dataset.id;
    if (this.cartIds) {
      this.cartIds = this.cartIds.filter((item) => item !== id);
    }
    const nextItem = cartItem.nextElementSibling;
    const height = cartItem.offsetHeight;
    document.documentElement.style.setProperty("--repositioning_value", `${height}px`);
    setTimeout(() => {
      cartItem.remove();
      if (nextItem) {
        nextItem.classList.add("repo--top");
        setTimeout(() => nextItem.classList.remove("repo--top"), 350);
      }
    }, 350);

    this.showRecommendationsLoader();
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Network response was not ok");

    const data = await response.json();

    if (data.item_count === 0) {
      await this.renderCart(false, false);
    } else if (isRemove && data.item_count > 0) {
      this.options.productId = data.items[data.items.length - 1].product_id;
      await this.renderCart(false, false, false, null);
    } else if (!isRemove && data.item_count > 0) {
      await this.renderCart(target.getAttribute("data-id"), true);
    }
  } catch (error) {
    // Error updating item quantity
  } finally {
    if (itemLoader) itemLoader.classList.remove("is-visible");

    if (isRemove) {
      this.hideRecommendationsLoader();
    }
  }
}


  onProductAdded(event) {
    let details = event?.detail || false;
    this.showRecommendationsLoader();

    this.renderCart(false, false, true, details)
      .then(() => {
        if (!this.isOpen) {
          this.isOpen = true;
          if (this.options["showRecommendations"]) {
            this.loadRecommendations();
          }
          this.alreadyEntered = true;
          this.drawer.openDrawer(null, false);
        }
      })
      .finally(() => this.hideRecommendationsLoader());
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = "100%";
    var _this = this;
    return fetch(`${window.Shopify.routes.root}?section_id=main-cart_drawer`, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      return content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange, productAdd, productAddEvent, updateCount);
      });
    });
  }

  recheckHeights() {
    const footerEl = this.element.querySelector(".cart-drawer__footer");
    const footerHeightCart = footerEl?.offsetHeight || 0;
    document.documentElement.style.setProperty("--sidecart-footer-height", `${footerHeightCart}px`);
  }

  replaceContent(html, lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    if (!updateCount) {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";
      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const newOptions = JSON.parse(tempElement.querySelector("#cart-drawer").getAttribute("data-settings"));
    this.options = newOptions;
    const itemCount = newOptions.itemCount;

    window.theme.cartCount = parseInt(itemCount);
    const badge = document.querySelector(".cart-count, .cart__count");
    if (badge) {
      badge.textContent = itemCount;
      if (parseInt(itemCount) > 0) {
        badge.classList.remove("cart-count--empty");
      } else {
        badge.classList.add("cart-count--empty");
      }
    }

    const contentEl = this.element.querySelector(".cart-drawer__content");
    if (contentEl) {
      contentEl.innerHTML = tempElement.querySelector(".cart-drawer__content").innerHTML;

      if (parseInt(itemCount) === 0) {
        contentEl.classList.add("drawer-content--empty");

        // hide shipping bar
        const shippingBar = this.element.querySelector(".cart-drawer__shipping-progress-bar");
        if (shippingBar) shippingBar.style.display = "none";

        // reset + trigger empty CTA animation
        const emptyCTA = contentEl.querySelector(".cart-drawer__cta.animatedContent");
        if (emptyCTA) {
          emptyCTA.removeAttribute("data-loaded");
          emptyCTA.style.opacity = "0";
          emptyCTA.style.transform = "translateX(30px)";
          requestAnimationFrame(() => {
            if (window.theme.enableAnimations) {
              new RevolutionAnimation().elementFromRight([emptyCTA]);
            } else {
              emptyCTA.style.opacity = "1";
              emptyCTA.style.transform = "none";
            }
          });
        }
      } else {
        contentEl.classList.remove("drawer-content--empty");
        contentEl.style.overflowY = "auto";
      }
      
      // Reapply body scroll lock after content replacement
      this.reapplyScrollLock();
    }

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }

    if (lineNumber) {
      this.updateCartItem(lineNumber, tempElement);
    } else {
      this.replaceCartContent(tempElement, productAdd);
    }

    this.updateCartFooter(tempElement);
    this.updateShippingBar(tempElement);
    this.recheckHeights();

    setTimeout(() => {
      if (this.options.showRecommendations && this.isOpen) {
        this.loadRecommendations();
      }
    }, 200);


    this.renderCartItemsNumber();
  }

  updateCartItem(lineNumber, tempElement) {
    const cleanLineNumber = lineNumber.startsWith("#") ? lineNumber.substring(1) : lineNumber;
    const cartItemParent = this.element.querySelector(`#${cleanLineNumber}`);
    const newCartItemInfo = tempElement.querySelector(`#${cleanLineNumber} .cartItem--Informations`);
    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent.querySelector(".itemLoader").classList.remove("is-visible");
    }
    if (newCartItemInfo) {
      cartItemParent.replaceChild(newCartItemInfo, cartItemParent.querySelector(".cartItem--Informations"));
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    if (!cartWrapper) return;

    let itemToAdd = null;
    if (productAddEvent && productAddEvent.variants?.length > 0) {
      const variantToFind = productAddEvent.variants[0];
      itemToAdd = tempElement.querySelector(`#CartItem-${variantToFind}`);
    }
    if (!itemToAdd) {
      itemToAdd = tempElement.querySelector('[id^="CartItem-"]');
    }
    if (!itemToAdd) return;

    const cleanItemId = itemToAdd.id.startsWith("#") ? itemToAdd.id.substring(1) : itemToAdd.id;
    if (cartWrapper.querySelector(`#${cleanItemId}`)) {
      this.updateCartItem(cleanItemId, tempElement);
    } else {
      const firstItem = cartWrapper.firstElementChild;
      const height = this.calculateDetachedElement(itemToAdd);
      if (height > 0) {
        document.documentElement.style.setProperty("--repositioning_value", `${height}px`);
        if (firstItem) firstItem.classList.add("repo--bottom");
        setTimeout(() => {
          cartWrapper.prepend(itemToAdd);
          itemToAdd.classList.add("repo--adding");
          if (firstItem) firstItem.classList.remove("repo--bottom");
          setTimeout(() => itemToAdd.classList.remove("repo--adding"), 350);
        }, 350);
      }
    }
  }

  calculateDetachedElement(element) {
    if (!element || !element.nodeType) return 0;
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "100%";
    detachedContainer.style.top = "-9999px";

    const clonedElement = element.cloneNode(true);
    detachedContainer.appendChild(clonedElement);
    this.element.appendChild(detachedContainer);
    const newItemHeight = clonedElement.offsetHeight + 4;
    this.element.removeChild(detachedContainer);
    return newItemHeight;
  }

  updateShippingBar(tempElement) {
    const newShippingBar = tempElement.querySelector(".cart-drawer__shipping-progress-bar");
    if (newShippingBar) {
      const currentShippingBar = this.element.querySelector(".cart-drawer__shipping-progress-bar");
      if (currentShippingBar) {
        let percent = newShippingBar.dataset.percent;
        if (percent > 100) percent = 100;
        currentShippingBar.dataset.percent = percent;
        currentShippingBar.style.width = `${percent}%`;
        if (percent == 100) {
          currentShippingBar.classList.add("done");
          currentShippingBar.classList.remove("active");
        } else {
          currentShippingBar.classList.remove("done");
          currentShippingBar.classList.add("active");
        }
        this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
          tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
      }
    }
  }

  updateCartFooter(tempElement) {
    const wrapper = this.element.querySelector(".cart-drawer__wrapper");
    if (!wrapper) return;
    const oldFooter = this.element.querySelector(".cart-drawer__footer");
    const newFooter = tempElement.querySelector(".cart-drawer__footer");
    if (this.options.itemCount > 0 && newFooter) {
      const clonedFooter = newFooter.cloneNode(true);
      if (oldFooter && oldFooter.parentNode) {
        oldFooter.parentNode.replaceChild(clonedFooter, oldFooter);
      } else {
        wrapper.appendChild(clonedFooter);
      }
    }
    if (this.options.itemCount === 0 && oldFooter) {
      oldFooter.remove();
    }
    requestAnimationFrame(() => this.recheckHeights());
  }

  replaceCartContent(tempElement, productAdd = false) {
    const contentEl = this.element.querySelector(".cart-drawer__content");
    const currentScrollPosition = contentEl.scrollTop;
    const newContent = tempElement.querySelector(".cart-drawer__content");

    contentEl.innerHTML = newContent.innerHTML;

    if (productAdd) {
      const firstItem = contentEl.querySelector(".cartItem");
      if (firstItem) {
        firstItem.classList.add("adding");
        setTimeout(() => firstItem.classList.remove("adding"), 350);
      }
    }

    contentEl.scrollTop = currentScrollPosition;

    contentEl.style.overflowY = "auto";
    contentEl.style.webkitOverflowScrolling = "touch";
  }

  loadRecommendations() {
    let recommendationsContainer = this.element.querySelector(".cart-drawer__recommendations");
    if (this.recommendationLoading) return Promise.resolve();

    this.recommendationLoading = true;
    const productId = this.options["productId"];
    const baseUrl = window.Shopify.routes.root;
    const intent = this.options["intent"] || "complementary";
    let url = productId
      ? `${baseUrl}recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${this.element.getAttribute("product-limit")}&intent=${intent}`
      : `?section_id=helper-recommendations&intent=${intent}`;

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;
        let recommendationsHTML = container.querySelector(".cart-drawer__upsell")?.innerHTML;
        recommendationsContainer = this.element.querySelector(".cart-drawer__recommendations");

        const newFirstItem = container.querySelector(".cart-drawer__rec-item")?.dataset.id;
        const existingFirstItem = this.element.querySelector(".cart-drawer__rec-item")?.dataset.id;
        if (newFirstItem == existingFirstItem) return;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          
          // Don't create a new AddToCart instance here!
          // The cart drawer already has one (line 3824) that handles all add-to-cart buttons
          // new AddToCart(recommendationsContainer); // REMOVED - causes duplicate events
          
          recommendationsContainer.setAttribute("data-animation", "elementFromRight");
          if (window.theme.enableAnimations) new RevolutionAnimation(recommendationsContainer);
        }
      })
      .catch((error) => {
        // Failed to load recommendations
      });
  }

  initializeSwiper() {
    const swiper = new Swiper(".helper-recomm-swiper", {
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: ".cart-recommendations__scrollbar",
        draggable: true,
        snapOnRelease: true,
        hide: false,
      },
      navigation: {
        nextEl: ".cart-recommendations__swiper-button--next",
        prevEl: ".cart-recommendations__swiper-button--prev",
      },
      mousewheel: { forceToAxis: true },
    });

      // Track arrow clicks after Swiper initialization
      const prevBtn = this.element.querySelector('.cart-recommendations__swiper-button--prev');
      const nextBtn = this.element.querySelector('.cart-recommendations__swiper-button--next');
    
    if (prevBtn && typeof dataLayer !== 'undefined') {
        prevBtn.addEventListener('click', () => {
            dataLayer.push({
                event: 'cart_upsell_product_arrows',
                direction: 'previous'
            });
            console.log("dataLayer push -> cart_upsell_product_arrows: previous");
        });
    }
    
    if (nextBtn && typeof dataLayer !== 'undefined') {
        nextBtn.addEventListener('click', () => {
            dataLayer.push({
                event: 'cart_upsell_product_arrows',
                direction: 'next'
            });
            console.log("dataLayer push -> cart_upsell_product_arrows: next");
        });
    }

    const navContainer = this.element.querySelector(".cart-recommendations__swiper-button-container");

    const updateNavVisibility = () => {
      if (!navContainer) return;
      if (swiper.slides.length > 1) {
        navContainer.style.display = "flex";
      } else {
        navContainer.style.display = "none";
      }
    };

    swiper.on("init", updateNavVisibility);
    swiper.on("update resize observerUpdate", updateNavVisibility);

    requestAnimationFrame(() => {
      swiper.update();
    });
  }

  async getCartItems() {
    try {
      const response = await fetch("/cart.js", {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Failed to fetch cart");
      return await response.json();
    } catch (err) {
      return null;
    }
  }

  async renderCartItemsNumber() {
    const cartData = await this.getCartItems();
    if (!cartData) return;
    const container = document.querySelector(".cart-items-number");
    if (container) container.textContent = `${cartData.item_count}`;
  }

  reapplyScrollLock() {
    if (!this.isOpen) return;
    
    // Re-apply scroll lock using the drawer instance
    if (this.drawer && this.drawer.lockBodyScroll) {
      this.drawer.lockBodyScroll();
    }
  }
}

customElements.define("cart-drawer", cartDrawer);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const cartMode = document.body.dataset.cartMode || "drawer";

    if (cartMode === "drawer") {
      new AddToCart(this.element);
    } else {
      this.delegate = new Delegate(this.element);
      this.delegate.on("submit", "form[action*='/cart']", e => {
      });
    }
  }
}
customElements.define("featured-collection", FeaturedCollection);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: "-250px 0px 200px 0px" }
    );
  }

  connectedCallback() {
    this.intersectionObserver.observe(this);

    const cartMode = document.body.dataset.cartMode || "drawer";
    if (cartMode === "drawer") {
      new AddToCart(this.element);
    }
  }

  async handleIntersection(entries, observer) {
    const entry = entries?.[0];
    if (!entry?.isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset?.url;
    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);

      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector(".product-recommendation");
      if (!recommendations || !recommendations.innerHTML.trim()) {
        return;
      }

      this.innerHTML = recommendations.innerHTML;

      const cartMode = document.body.dataset.cartMode || "drawer";
      if (cartMode === "drawer") {
        new AddToCart(this.element);
      }

    } catch (error) {
      // Error loading carousel content
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.swiperElement = this.element.querySelector("swiper-init");

    this.initTextAnimations();
    this.bindEvents();
  }

  bindEvents() {
    this.swiperElement?.addEventListener('swiper:initialized', () => {
      this.carousel = this.swiperElement.getSwiper();
      this.swiperInstance = this.carousel?.swiperElement;
      
      this.swiperInstance.on("slideChange", () => {
        this.initTextAnimations();
      });

      // Disable pointer events during swipe transitions
      this.swiperInstance.on("slideChangeTransitionStart", () => {
        this.disableVideoInteraction();
      });

      this.swiperInstance.on("slideChangeTransitionEnd", () => {
        this.enableVideoInteraction();
      });
    });

    this.delegateElement.on('click', '.quote-block_media-container', (e) => {
      this.handleVideoLinkClick(e);
    });
  }

  disableVideoInteraction() {
    const videoContainers = this.element.querySelectorAll('.quote-block_media-container');
    videoContainers.forEach(container => {
      container.style.pointerEvents = 'none';
    });
  }

  enableVideoInteraction() {
    const videoContainers = this.element.querySelectorAll('.quote-block_media-container');
    videoContainers.forEach(container => {
      container.style.pointerEvents = 'auto';
    });
  }

  handleVideoLinkClick(e) {
    const controlBar = this.element.querySelector(".vjs-control-bar");
    const bigPlayButton = this.element.querySelector(".vjs-big-play-button");

    if (
      (controlBar && controlBar.contains(e.target)) ||
      (bigPlayButton && bigPlayButton.contains(e.target))
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  initTextAnimations() {
    const animatedElements = this.element.querySelectorAll(
      ".animate-heading, .fade-in-element, .slide-in, .fade-in"
    );
    animatedElements.forEach(el => {
      el.classList.remove("animate-heading", "first-heading", "slide-in", "fade-in", "fade-in-element");
    });

    const textWrappers = this.element.querySelectorAll('.quote-block_text-container');
    if (!textWrappers.length) return;

    // Check if animations are disabled via the data attribute set in liquid template
    const animationsDisabled = this.element.hasAttribute('data-animations-disabled');
    
    if (animationsDisabled) {
      // If animations are disabled, make all elements visible immediately
      textWrappers.forEach((textWrapper) => {
        const allElements = Array.from(textWrapper.children);
        allElements.forEach(element => {
          element.style.opacity = '1';
          element.style.transform = 'none';
        });
      });
      return;
    }

    // Animations are enabled - proceed with normal animation setup
    const animationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const textWrapper = entry.target;
            const mainHeading = textWrapper.querySelector('.heading-block');
            const otherElements = Array.from(textWrapper.children)
              .filter(child => child !== mainHeading);

            if (mainHeading) {
              mainHeading.classList.add('slide-in');
            }
            otherElements.forEach(element => element.classList.add('fade-in'));

            animationObserver.unobserve(textWrapper);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -20px 0px',
      }
    );

    textWrappers.forEach((textWrapper) => {
      const mainHeading = textWrapper.querySelector('.heading-block');
      if (!mainHeading) return;

      const otherElements = Array.from(textWrapper.children)
        .filter(child => child !== mainHeading);

      mainHeading.classList.add('animate-heading', 'first-heading');
      otherElements.forEach(element => element.classList.add('fade-in-element'));

      animationObserver.observe(textWrapper);
    });
  }
}

customElements.define("quote-section", QuoteSection)

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.responsive = new Responsive(true, false);

    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.carouselElement = this.element.querySelector('[data-swiper-settings]');
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute('data-section-settings')
    );

    this.fullWidthMediaContent = this.element.querySelector(
      '.full-width-media_content'
    );
    this.ticking = false;
    this.scrollAnimation = this.options.scrollAnimation || 'none';

    this.MAX_MARGIN = 32;
    this.MAX_BORDER_RADIUS = 8;
    this.MAX_SCROLL = 300;
    this.MAX_SCALE_REDUCTION = 0.05;
  }

  connectedCallback() {




    if (this.options.animateTextButtons) this.initTextAnimations();
  }



applyScrollEffect(progress) {
  switch (this.scrollAnimation) {
    case 'spacing_rounded':
      this.applySpacingRoundedEffect(progress);
      break;
    case 'zoom_out':
      this.applyZoomOutEffect(progress);
      break;
  }
}
  applySpacingRoundedEffect(progress) {
    const currentMargin = progress * this.MAX_MARGIN;
    const currentBorderRadius = progress * this.MAX_BORDER_RADIUS;

    if (this.fullWidthMediaContent) {
      this.fullWidthMediaContent.style.setProperty(
        '--banner-margin-left-right-dynamic',
        `${currentMargin}px`
      );

      if(!this.options.roundedCorners){
        this.fullWidthMediaContent.style.setProperty(
        '--banner-border-radius-dynamic',
        `${currentBorderRadius}px`
      );}
    }
  }

  applyZoomOutEffect(progress) {
    const scale = 1.05 - progress * this.MAX_SCALE_REDUCTION;

    if (this.fullWidthMediaContent) {
      this.fullWidthMediaContent.style.setProperty(
        '--banner-scale',
        scale.toString()
      );
    }
  }

  resetScrollEffects() {
    if (this.fullWidthMediaContent) {
      this.fullWidthMediaContent.style.setProperty(
        '--banner-margin-left-right-dynamic',
        '0px'
      );
      this.fullWidthMediaContent.style.setProperty(
        '--banner-border-radius-dynamic',
        '0px'
      );
      this.fullWidthMediaContent.style.setProperty('--banner-scale-x', '1');
      this.fullWidthMediaContent.style.setProperty('--banner-scale-y', '1');
    }
  }

 

   initTextAnimations() {
  const textWrapper = this.element.querySelector(
    '.group-text-button__block-wrapper'
  );
  if (!textWrapper) return;

  const firstHeading = textWrapper.querySelector('h1, h2, h3, h4, h5, h6');
  if (!firstHeading) return;

  const headingContainer = firstHeading.closest('.heading-block');

  const words = firstHeading.textContent.trim().split(/\s+/);
  firstHeading.innerHTML = words
    .map((word) => `<span class="word-slide u-${firstHeading.tagName.toLowerCase()}">${word}</span>`)
    .join(" ");

  const otherElements = [];
  const allChildren = Array.from(textWrapper.children);
  allChildren.forEach((child) => {
    if (child !== headingContainer) {
      otherElements.push(child);
    }
  });

  if (headingContainer) {
    headingContainer.classList.add('banner-animate-heading', 'banner-first-heading');
  }

  otherElements.forEach((element) => {
    element.classList.add('fade-in-element');
  });

  const animationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const wordSpans = firstHeading.querySelectorAll('.word-slide');
          wordSpans.forEach((span, index) => {
            span.classList.add('animate');
          });

          otherElements.forEach((element) => {
            element.classList.add('fade-in');
          });

          animationObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -20px 0px',
    }
  );

  animationObserver.observe(textWrapper);
}

}
customElements.define('banner-hero', Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.prevOffset = window.scrollY;
    this.announcementBar = document.querySelector(".announcement-bar");

    this.handleScroll = this.handleScroll.bind(this); // Bind once for add/removeEventListener
    this.scrollRafId = null; // For throttling scroll updates
    this.resizeRafId = null; // For throttling resize updates
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item) => {
        new RevolutionSelectbox(item);
      });
    }

   
 

    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    // Set announcement bar height immediately to prevent header jump
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      const annHeight = announcementBar.clientHeight;
      document.documentElement.style.setProperty(
        '--announcement-dynamic-height',
        `${annHeight}px`
      );
      
      // Set initial announcement-height-fixed based on visibility
      const annBarHidden = announcementBar.classList.contains('ann-bar-hidden') || 
                          announcementBar.classList.contains('ann-bar-scrolled');
      if (annBarHidden) {
        document.documentElement.style.setProperty('--announcement-height-fixed', '0px');
        this.element.classList.remove('ann-bar--visible');
      } else {
        document.documentElement.style.setProperty('--announcement-height-fixed', `${annHeight}px`);
        this.element.classList.add('ann-bar--visible');
      }
    }

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);

    this.initCartCount();
    this.bindEvents();
    this.handleScroll();
  }

  disconnectedCallback() {
    // Clean up GlobalScrollListener
    if (this.scrollListenerRemover) {
      this.scrollListenerRemover.removeScrollListener();
    } else {
      window.removeEventListener("scroll", this.handleScroll);
    }
    window.removeEventListener("resize", this.updateVisibleHeight.bind(this));
    this.delegateBody.off("menu:close", this.closeMenu.bind(this), true);
  }

  bindEvents() {
    // Throttle scroll events with requestAnimationFrame
    const throttledScroll = () => {
      if (this.scrollRafId) return;
      this.scrollRafId = requestAnimationFrame(() => {
        this.handleScroll();
        this.scrollRafId = null;
      });
    };

    // Throttle resize events with requestAnimationFrame
    // Only listen to width changes, not height (to prevent iOS Safari bottom bar issues)
    let lastWidth = window.innerWidth;
    const throttledResize = () => {
      if (this.resizeRafId) return;
      this.resizeRafId = requestAnimationFrame(() => {
        const currentWidth = window.innerWidth;
        // Only update if width actually changed (not just height from iOS Safari toolbar)
        if (Math.abs(currentWidth - lastWidth) > 10) {
          this.updateVisibleHeight();
          lastWidth = currentWidth;
        }
        this.resizeRafId = null;
      });
    };

    // Use GlobalScrollListener for better performance
    if (window.scrollListener) {
      this.scrollListenerRemover = window.scrollListener.addScrollListener(this, throttledScroll);
    } else {
      window.addEventListener("scroll", throttledScroll, { passive: true });
    }
    window.addEventListener("resize", throttledResize, { passive: true });

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("mouseleave", "[aria-submenu]", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", "[aria-singlemenu]", this.closeMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-singleMenu], .header__link--main", this.closeMenu.bind(this), true);
    this.delegateBody.on("cart-drawer:open", this.closeAllMenus.bind(this));
    this.delegateBody.on("desktop-menus:close", this.closeAllMenus.bind(this));

    // Close desktop menu when hovering over specific header elements
    this.delegateElement.on("mouseenter", ".header__logo, .header__logo--wrapper, .header-cart-btn, .header-search-btn, .header-acc-btn", this.closeAllMenus.bind(this));
    
    // Close desktop menu when hovering over utility section
    this.delegateElement.on("mouseenter", ".header__links--wrapper", this.closeAllMenus.bind(this));
    
    // Simple and reliable hover-based menu closing
    this.delegateBody.on("mouseenter", "*", (event) => {
      const hasOpenMenu = this.element.querySelector('[aria-expanded="true"]');
      if (!hasOpenMenu) return;

      // Define what should keep the menu open
      const keepMenuOpen = event.target.closest('#header') ||
                          event.target.closest('.desktop-menu__dropdown-wrapper') ||
                          event.target.closest('[aria-hasMenu="true"]') ||
                          event.target.closest('[aria-expanded="true"]');
      
      // Close if not hovering over menu-related elements
      if (!keepMenuOpen) {
        this.closeAllMenus();
      }
    });

    // Click outside to close
    this.delegateBody.on("click", "*", (event) => {
      const hasOpenMenu = this.element.querySelector('[aria-expanded="true"]');
      if (!hasOpenMenu) return;

      const keepMenuOpen = event.target.closest('#header') ||
                          event.target.closest('.desktop-menu__dropdown-wrapper');
      
      if (!keepMenuOpen) {
        this.closeAllMenus();
      }
    });

    // Prevent dropdown interactions from closing the desktop menu
    this.delegateElement.on("click", ".desktop-menu__dropdown-wrapper .RevolutionSelectbox", (event) => {
      event.stopPropagation();
    });
    
    this.delegateElement.on("click", ".desktop-menu__dropdown-wrapper .selectbox-dropdown", (event) => {
      event.stopPropagation();
    });

 

    this.delegateElement.on("mouseleave", "header-component", () => {
      const mainMenu = document.querySelector("main-menu-dropdown");
      const isMobileMenu = mainMenu && mainMenu.getAttribute("aria-hidden") === "false";
      
      // Check if any desktop menu dropdowns are open
      const hasOpenDesktopMenu = this.element.querySelector('[aria-expanded="true"]');

      if (this.element.dataset.transparent !== "true") return;

     
    });
  }

  handleScroll() {
    const isAtTop = window.scrollY === 0;

    // No need to manage header classes anymore - JavaScript in announcement bar handles the CSS variable

    if (this.element.dataset.transparent !== "true") return;
    
    // Check if any desktop menu dropdowns are open
    const hasOpenDesktopMenu = this.element.querySelector('[aria-expanded="true"]');
    

  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      visibleHeight = Math.max(visibleHeight, 0);
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );

      const mobileMenuHeight =
        document.querySelector(".mobile-menu").offsetHeight;

      document.documentElement.style.setProperty(
        "--mobile-menu-dynamic-height",
        `${mobileMenuHeight}px`
      );

      this.element.classList.remove('header--ann-bar-hidden');
    }, 550);
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

 

  openMenu(event, target) {
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    if (event.type === "mouseenter" && target !== event.target) return;

    this.updateMenuPosition(target);

    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    this.prepareDesktopMenuForOpening(target);

    // Dispatch custom event for HeaderTransparencyController
    document.body.dispatchEvent(new CustomEvent("desktop-menu:open", { bubbles: true }));

    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );

    document.documentElement.style.setProperty(
      '--body-padding-right',
      `${document.body.style.paddingRight}`
    );
  }

  prepareDesktopMenuForOpening(target) {
  const drawerElement = target.querySelector('.desktop-menu__dropdown-wrapper');

  drawerElement.style.display = 'flex';
  drawerElement.classList.add('menu-preparing');

  drawerElement.style.clipPath = "polygon(0 0, 100% 0, 100% 0, 0 0)";
  drawerElement.style.opacity = "0";
  drawerElement.style.visibility = "hidden";
  drawerElement.offsetHeight;

  requestAnimationFrame(() => {
    target.setAttribute("aria-expanded", "true");
    drawerElement.style.clipPath = "";
    drawerElement.style.opacity = "";
    drawerElement.style.visibility = "";
  });
}

  closeMenu(event, target) {
    // Simple close logic for mouseleave events
    if (event.type === "mouseleave" && target !== event.target) return;

    // Close the specific menu
    const allOpen = this.element.querySelectorAll('.header__link--desk[aria-expanded="true"]');
    allOpen.forEach((item) => {
      item.setAttribute("aria-expanded", "false");
      
   
    });
    
    bodyScrollLock.clearAllBodyScrollLocks();
  }

closeAllMenus() {  
  const allOpen = this.element.querySelectorAll('.header__link--desk[aria-expanded="true"]');
  const hasOpenMenus = allOpen.length > 0;
  
  allOpen.forEach((item) => {
    item.setAttribute("aria-expanded", "false");
    
    const dropdown = item.querySelector('.desktop-menu__dropdown-wrapper');
    if (dropdown) {
      // Close any open internal dropdowns using the global Dropdown class
      allDropdowns.closeAllDropdowns(dropdown);
      
      // Wait a bit longer for internal dropdowns to close before hiding desktop menu
      setTimeout(() => {
        dropdown.style.display = 'none';
        dropdown.classList.remove('menu-preparing');
      }, 500); // Increased from 300ms to 500ms
    }
  });
  
  // Dispatch custom event for HeaderTransparencyController if there were open menus
  if (hasOpenMenus) {
    document.body.dispatchEvent(new CustomEvent("desktop-menu:closed", { bubbles: true }));
  }
  
  // Clear body scroll lock when closing all menus
  bodyScrollLock.clearAllBodyScrollLocks();
  

}

  initCartCount() {
    const badge = this.element.querySelector(".cart-count");
    if (badge) {
      const itemCount = badge.textContent.trim();
      if (parseInt(itemCount) > 0) {
        badge.classList.remove('cart-count--empty');
      } else {
        badge.classList.add('cart-count--empty');
      }
    }
  }
}

customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item) => {
        new RevolutionSelectbox(item);
      });
    }

  this.sidebarMenu = new Drawer(this.element, {
    onClose: () => {
      this.element.setAttribute('aria-expanded', 'false');

      setTimeout(() => {
        this.element.setAttribute('aria-hidden', 'true');
      }, 500);

      const header = document.querySelector('header-component');
    
      bodyScrollLock.clearAllBodyScrollLocks();
      this.element.querySelector('#quickSearch')?.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
      );
      this.hideThirdLevel();
    },
    onOpen: () => {
      this.element.setAttribute('aria-expanded', 'false');
      this.element.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        this.element.setAttribute('aria-expanded', 'true');
      }, 1);

      const header = document.querySelector('header-component');
    
    }
  });

    this.drawerContent    = this.element.querySelector('.Drawer--Content');
    this.tabContents      = this.element.querySelector('.mobile-menu__tab-contents');
    this.imageLinksGroup  = this.element.querySelector('.mobile-menu__image-link--group');

    this.thirdLevelEl     = this.element.querySelector('.mobile-menu__third-level');
    this.thirdLevelTitle  = this.element.querySelector('.mobile-menu__third-level-title');
    this.thirdLevelBody   = this.element.querySelector('.mobile-menu__third-level-body');

    if (this.imageLinksGroup && this.thirdLevelBody) {
      this.imageLinksGroupClone = this.imageLinksGroup.cloneNode(true);
      this.imageLinksGroupClone.classList.add('image-links--clone');
      this.thirdLevelBody.appendChild(this.imageLinksGroupClone);
    }

    this.checkEmptyGroups();
    this.bindEvents();

    const activeTab = this.element.querySelector('.mobile-menu__tab.is-active');
    if (activeTab) {
      const targetId = activeTab.dataset.tabTarget;
      const handle = (targetId?.replace(/^tab-/, '') || '').toLowerCase();
      this.filterImageLinksByHandle(handle);
    }
  }

  bindEvents() {
    document.addEventListener("sidebar-drawer:open", () => {
  
    });

    this.delegateElement.on("click", ".mobile-menu__tab", this.onTabClick.bind(this));
    this.delegateElement.on("click", ".mobile-menu__expand-button", this.onExpandButtonClick.bind(this));
    this.delegateElement.on("click", ".mobile-menu__third-level-back", () => {
      this.hideThirdLevel();
      if (this.drawerContent) this.drawerContent.scrollTop = 0;
    });
  }

  onTabClick(e, target) {
    const allTabs = this.element.querySelectorAll(".mobile-menu__tab");
    const allContents = this.element.querySelectorAll(".mobile-menu__tab-content");
    const targetId = target.dataset.tabTarget;

    allTabs.forEach(t => t.classList.remove("is-active"));
    target.classList.add("is-active");

    allContents.forEach(c => c.classList.remove("is-active"));
    this.element.querySelector(`#${targetId}`)?.classList.add("is-active");

    const handle = (targetId?.replace(/^tab-/, '') || '').toLowerCase();
    this.filterImageLinksByHandle(handle);

    this.hideThirdLevel();
    if (this.drawerContent) this.drawerContent.scrollTop = 0;
  }

  onExpandButtonClick(e, btn) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.thirdLevelEl) return;

    const parent = btn.closest('.mobile-menu__link--level-two');
    if (!parent) return;

    const sourceId = parent.getAttribute('data-submenu-target');
    const title = parent.getAttribute('data-submenu-title') ||
                  parent.querySelector('.mobile-menu__link-text')?.textContent?.trim() || '';
    if (!sourceId) return;

    const cssEscape = (str) => (window.CSS && CSS.escape) ? CSS.escape(str) : String(str).replace(/"/g, '\\"');
    const source = this.element.querySelector(`#${cssEscape(sourceId)}`);
    if (!source) return;

    const activeTopTab = this.element.querySelector('.mobile-menu__tab.is-active');
    const topTabTitle = activeTopTab?.textContent?.trim() || '';
    this.thirdLevelTitle.textContent = topTabTitle ? `${topTabTitle} - ${title}` : title;

    this.thirdLevelBody
      .querySelectorAll(':scope > :not(.mobile-menu__image-link--group)')
      .forEach(n => n.remove());

    const tmp = document.createElement('div');
    tmp.innerHTML = source.innerHTML;
    [...tmp.children].forEach(child => this.thirdLevelBody.insertBefore(child, this.imageLinksGroupClone || null));

    if (this.drawerContent) this.drawerContent.scrollTop = 0;
    if (this.thirdLevelEl) this.thirdLevelEl.scrollTop = 0;
    if (this.thirdLevelBody) this.thirdLevelBody.scrollTop = 0;

    this.thirdLevelEl.classList.add('is-active');
    this.thirdLevelEl.setAttribute('aria-hidden', 'false');
    parent.setAttribute('aria-expanded', 'true');
    this.drawerContent?.classList.add('third-open');

    const thirdHandle = (parent.getAttribute('data-submenu-handle') || '').toLowerCase();
    if (thirdHandle) {
      this.filterImageLinksByHandle(thirdHandle);
    }

    // Track menu interaction
  if (btn.hasAttribute('data-gtm-event') && typeof dataLayer !== 'undefined') {
    const menuItem = btn.dataset.gtmMenuItem || btn.innerText;
    dataLayer.push({
      event: 'menu_interaction',
      menu_item: menuItem,
      menu_location: btn.dataset.gtmMenuLocation || 'header'
    });
  }
  }

  hideThirdLevel() {
    if (this.thirdLevelEl) {
      this.thirdLevelEl.classList.remove('is-active');
      this.thirdLevelEl.setAttribute('aria-hidden', 'true');
      this.thirdLevelEl.scrollTop = 0;
      if (this.thirdLevelBody) {
        this.thirdLevelBody.scrollTop = 0;
        this.thirdLevelBody.querySelectorAll(':scope > :not(.mobile-menu__image-link--group)').forEach(n => n.remove());
      }
    }
    if (this.drawerContent) {
      this.drawerContent.classList.remove('third-open');
      this.drawerContent.scrollTop = 0;
    }
    this.element.querySelectorAll('.mobile-menu__link--level-two[aria-expanded="true"]').forEach(a => {
      a.setAttribute('aria-expanded', 'false');
    });

    const activeTab = this.element.querySelector('.mobile-menu__tab.is-active');
    const targetId = activeTab?.dataset.tabTarget;
    const topHandle = (targetId?.replace(/^tab-/, '') || '').toLowerCase();
    if (topHandle) {
      this.filterImageLinksByHandle(topHandle);
    }
  }

  filterImageLinksByHandle(handle) {
    const raw = (this.imageLinksGroup?.getAttribute('data-image-link-top') || '').toLowerCase();
    const reverseHandles = raw.split(',').map(h => h.trim()).filter(Boolean);
    if (this.tabContents) {
      this.tabContents.classList.toggle('is-reversed', reverseHandles.includes(handle));
    }

    this._filterGroupByHandle(this.imageLinksGroup, handle);
    this._filterGroupByHandle(this.imageLinksGroupClone, handle);
  }

  _filterGroupByHandle(groupEl, handle) {
    if (!groupEl) return;

    const items = groupEl.querySelectorAll('.mobile-menu__image-link');
    let visibleCount = 0;

    items.forEach((item) => {
      const rawTargets = (item.getAttribute('data-target') || '').toLowerCase().trim();
      if (!rawTargets) {
        item.style.display = '';
        visibleCount++;
        return;
      }
      const targets = rawTargets.split(',').map(t => t.trim()).filter(Boolean);
      const match = targets.includes('*') || targets.includes('all') || targets.includes(handle);
      item.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    groupEl.style.display = visibleCount > 0 ? '' : 'none';
  }

  checkEmptyGroups() {
    this.element.querySelectorAll('.mobile-menu__product-link--group').forEach(group => {
      if (!group.querySelector('.mobile-menu__item')) {
        group.style.display = 'none';
      }
    });

    const imgGroup = this.element.querySelector('.mobile-menu__image-link--group');
    if (imgGroup) {
      const hasAny = imgGroup.querySelector('.mobile-menu__image-link');
      if (!hasAny) imgGroup.style.display = 'none';
    }
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options["play_in_view_mob_hover_desk"]) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);
      
      this.element.addEventListener("mouseenter", this.onMouseEnterListener);
      this.element.addEventListener("mouseleave", this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    
    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.options["muted"]) {
        this.videoPlayer.muted("true");
      }
      this.videoPlayer.play();
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    
    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.videoPlayer.el_.classList.contains("vjs-playing")) {
        this.videoPlayer.pause();
      }
    }
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    const isMobile = responsive.matchesBreakpoint("pocket");
    

    
    if (event.detail.currentIndex == this.elementPosition) {
      // Active slide - initialize or reinitialize video
      if (this.element.getAttribute("loaded")) {
        // Already loaded - on desktop, always reinitialize for fresh controls
        if (!isMobile && this.videoPlayer) {
          this.reinitializeVideoPlayer();
        } else if (!this.videoPlayer) {
          this.checkLoaded();
        }
      } else {
        // First time loading
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        this.checkLoaded();
      }
      
      // Handle autoplay if enabled
      if ((this.options["play_in_view"]) || (this.options["play_in_view_mob_hover_desk"] && isMobile)) {
        setTimeout(() => {
          if (this.videoPlayer) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }, 200);
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      // Not active slide - pause if playing
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
        ? "video/vimeo"
        : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options["controls"]
      ? {
          children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "CustomControlSpacer",
            "MuteToggle",
            "fullscreenToggle"
          ]
        }
      : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("fullscreenchange", function () {
      if (_this.videoPlayer.isFullscreen()) {
        _this._scrollY = window.scrollY;
        document.body.style.overflow = "hidden";
        document.body.style.top = `-${_this._scrollY}px`;
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, _this._scrollY || 0);
      }
    });

    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      // Bind hover events for desktop behavior
      _this.bindHoverEvents();

      // Force controls to be interactive on desktop
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (_this.trueObserver == false && (_this.options["play_in_view_mob_hover_desk"] || _this.options["play_in_view"])) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    } else {
      // Controls are disabled - remove manual interactions but keep automatic behavior
      
      // Disable click interactions completely
      this.videoPlayer.off('click');
      this.videoPlayer.off('touchstart');
      
      // Hide controls completely
      this.videoPlayer.controls(false);
      
      // Keep hover/mouseover functionality for desktop autoplay but disable manual clicking
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        // Don't disable pointer events completely - we need hover to work
        // videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
        
        // Add a custom click handler that does nothing to prevent any manual control
        videoEl.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
        
        videoEl.addEventListener('touchstart', function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint("pocket");
    
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && this.videoPlayer && isMobile) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        this.videoPlayer.dispose();
        this.videoPlayer = null;
      } catch (e) {
        this.videoPlayer = null; // Force null even if dispose fails
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;
    
    // Only enable controls if they are supposed to be enabled
    if (this.options["controls"]) {
      // Force controls to be enabled
      this.videoPlayer.controls(true);
      
      // The main issue was CSS pointer-events, but we can still ensure controls are clickable
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        // Make sure text track display doesn't block clicks
        const textTrackDisplay = this.element.querySelector('.vjs-text-track-display');
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = 'none';
        }
      }
    } else {
      // Make sure controls stay disabled
      this.videoPlayer.controls(false);
      
      // Ensure video is non-interactive
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
      }
    }
  }

  reinitializeVideoPlayer() {

    this.disposeVideoPlayer();
    
    // Clear the loaded attribute so video can be reinitialized
    this.element.removeAttribute('loaded');
    this.element.removeAttribute('data-loaded');
    
    // Remove existing video holder completely
    const existingHolder = this.element.querySelector('.videoHolder');
    if (existingHolder) {
      existingHolder.remove();
    }
    
    // Force a fresh start
    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}
customElements.define("video-component", VideoComponent);


/* ---------------------------
   FormValidator CLASS
---------------------------- */
class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;
    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;
    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;
    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();
      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      if (this.options.validateOnInput) {
        input.addEventListener('input', () => this.handleInputChange(input));
      }
      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }
      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }
    this.updateErrorOutput();
    if (this.options.buttonSelector) this.updateButtonState();
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;
    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      if (!field.value.trim()) return;
      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') errors.push(result);
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
          errors.push(`Please enter a valid email address`);
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else {
      const fieldContainer = input.closest(this.options.fieldSelector);
      if (fieldContainer?.classList.contains(this.options.errorClass)) {
        const isValid = this.isFieldValid(input);
        if (isValid) fieldContainer.classList.remove(this.options.errorClass);
      }
    }
    this.updateErrorOutput();
    if (this.options.buttonSelector) this.updateButtonState();
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else {
      this.validateField(input, false);
    }
    this.updateErrorOutput();
    if (this.options.buttonSelector) this.updateButtonState();
  }

  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer?.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field);
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) fieldContainer.classList.remove(this.options.errorClass);
      else fieldContainer.classList.add(this.options.errorClass);
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) this.updateButtonState();
  }

  isFieldValid(field) {
    if (field.hasAttribute('required') && !field.value.trim()) return false;
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) return false;
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') return false;
      return !!result;
    }
    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;
    allFields.forEach(field => {
      if (!this.validateField(field, silent)) isFormValid = false;
    });
    if (!silent) this.updateErrorOutput();
    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;
    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);
    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => field.classList.remove(this.options.errorClass));
    if (this.options.errorOutputSelector) this.outputErrors([]);
  }

  showAllErrors() {
    return this.validateForm(false);
  }

  getFormData() {
    return Object.fromEntries(new FormData(this.form).entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    return new Date(dateString) > new Date();
  }
}

/* ---------------------------
   FooterComponent CLASS
---------------------------- */
class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footer = document.querySelector("footer");
    this.footerVisibleClass = "footer--visible";

    // Delegate pattern
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // Form validator & bindings
    this.validator = null;

    // Keep your original responsive behavior
    const breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint === "phone" || breakpoint === "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }
    // Removed initScrollEffect() call as method doesn't exist
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.footer.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });

    this.initFormValidation();
    this.bindEvents();
  }

  bindEvents() {
    // Handle button click submission
    this.delegateElement.on("click", "[data-role='footer-newsletter-submit']", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      await this.handleFormSubmission();
    });

    // Handle Enter key press on email input
    this.delegateElement.on("keydown", "#klaviyoEmailFooter", async (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        await this.handleFormSubmission();
      }
    });
  }

  async handleFormSubmission() {
    // Mark form as submitted to show validation errors
    this.validator.markSubmitted();
    
    if (!this.validator.validateForm(false)) {
      return;
    }

    const email = this.element.querySelector("#klaviyoEmailFooter")?.value.trim();
    const listId = window.klaviyoListId;
    const publicKey = window.klaviyoPublicKey;

    if (!email || !listId || !publicKey) return;

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                properties: {
                  market_country: this.element.dataset.marketCountry || ''
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: listId } }
        }
      }
    };

    try {
      await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          revision: "2024-06-15"
        },
        body: JSON.stringify(payload),
        keepalive: true
      });
      
      const successMessage = this.element.querySelector(".footer__newsletter-form--success");
      const formWrapper = this.element.querySelector(".footer__newsletter-form-inputs");
      const submitButton = this.element.querySelector("[data-role='footer-newsletter-submit']");

      if (formWrapper) formWrapper.style.display = "none";
      if (submitButton) submitButton.style.display = "none";
      if (successMessage) successMessage.style.display = "";
      
      this.validator.clearErrors();
    } catch (error) {
      // Klaviyo subscription error
    }
  }

  initFormValidation() {
    const form = this.element.querySelector('#footerForm');
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: '[data-role="footer-newsletter-submit"]',
      validateOnBlur: true,
      validateOnInput: false,
      fieldErrorSelector: ".input-validation",
      showErrorsOnSubmitOnly: true,
      errorOutputSelector: ".input-validation"
    });
  }
}

customElements.define("footer-component", FooterComponent);





class FooterSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.parallaxSlot = null;
    this.parallaxLayer = null;
    this.parallaxActive = false;
    this.parallaxRAF = null;
    this.boundScroll = null;
    this.boundResize = null;
    this.parallaxRange = 0;
    this.parallaxRangeStart = 0;
    this.footerStart = 0;
    this.footerHeight = 0;
    this.parallaxHeight = 0;
    this.prefersReducedMotion = false;
    this.parallaxBaseHeight = 0;
    this.wrapperElement = null;
    this.footerElement = null;
    this.clipBuffer = 0;
    this.isCoarsePointer = false;
    this.isIOS = false;
    this.footerObserver = null;
    this.footerVisible = false;
    this.lastClipTop = null;
    this.lastClipBottom = null;

    this.bindEvents();
  }

  connectedCallback() {
    this.setupParallax();
    this.observeFooter();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='footer-action']",
      this.handleFooterAction.bind(this)
    );
  }

  handleFooterAction(event) {
    event.preventDefault();
  }

  setupParallax() {
    if (typeof window === "undefined") return;

    if (window.matchMedia) {
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    }

    if (typeof navigator !== 'undefined') {
      this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    }

    this.footerElement = this.element.querySelector('.footer');
    this.wrapperElement = this.element.querySelector('.footer__wrapper') || this.wrapperElement;
    this.updateClipBuffer();

    if (this.prefersReducedMotion) {
      if (!this.wrapperElement) {
        this.wrapperElement = this.element.querySelector('.footer__wrapper');
      }
      this.stopParallax(true);
      this.parallaxSlot = null;
      this.parallaxLayer = null;
      return;
    }

    const parallaxSlot = this.element.querySelector('.footer__bg-slot');
    if (!parallaxSlot) return;

    this.parallaxSlot = parallaxSlot;
    this.parallaxLayer = parallaxSlot.querySelector('.footer__bg-layer') || parallaxSlot;
    this.wrapperElement = this.element.querySelector('.footer__wrapper');
  this.lastClipTop = null;
  this.lastClipBottom = null;

    if (!this.boundResize) {
      this.boundResize = () => {
        this.refreshParallaxMetrics();
        if (this.parallaxActive) {
          this.handleParallaxScroll();
          return;
        }
        this.updateParallaxClip(true);
      };
      window.addEventListener('resize', this.boundResize, { passive: true });
    }

    this.refreshParallaxMetrics();
    this.updateParallaxClip(true);
  }

  refreshParallaxMetrics() {
    if (typeof window === "undefined" || !this.parallaxSlot) return;

    this.updateClipBuffer();

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const rect = this.element.getBoundingClientRect();

    this.footerStart = rect.top + scrollY;
    this.footerHeight = this.element.offsetHeight || 0;
    this.parallaxHeight = this.parallaxSlot.offsetHeight || 0;
    const layerHeight = this.parallaxLayer ? this.parallaxLayer.offsetHeight : 0;
    this.parallaxBaseHeight = layerHeight || this.parallaxSlot.offsetHeight || 0;

    const viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    this.parallaxRangeStart = this.footerStart - viewport;
    this.parallaxRange = this.footerHeight + viewport;

    if (this.parallaxRange <= 0) {
      this.parallaxRange = 1;
    }

    this.updateParallaxClip(true);
  }

  startParallax() {
    if (typeof window === "undefined") return;
    if (this.prefersReducedMotion) return;
    if (!this.parallaxSlot || !this.parallaxLayer || this.parallaxActive) return;

    if (!this.wrapperElement) {
      this.wrapperElement = this.element.querySelector('.footer__wrapper');
    }

    this.parallaxActive = true;
    this.refreshParallaxMetrics();

    if (!this.boundScroll) {
      this.boundScroll = this.handleParallaxScroll.bind(this);
      window.addEventListener('scroll', this.boundScroll, { passive: true });
    }

    this.handleParallaxScroll();
  }

  stopParallax(resetClip = false) {
    if (!this.parallaxActive) {
      if (resetClip && this.boundScroll) {
        window.removeEventListener('scroll', this.boundScroll);
        this.boundScroll = null;
      }
      if (resetClip) {
        this.resetParallaxClip();
      }
      this.updateParallax(false);
      this.handleParallaxScroll();
      return;
    }

    this.parallaxActive = false;

    if (resetClip && this.boundScroll) {
      window.removeEventListener('scroll', this.boundScroll);
      this.boundScroll = null;
    }

    if (this.parallaxRAF) {
      window.cancelAnimationFrame(this.parallaxRAF);
      this.parallaxRAF = null;
    }

    if (this.parallaxLayer) {
      this.parallaxLayer.style.setProperty('--footer-parallax-translate', '0px');
      this.parallaxLayer.style.setProperty('--footer-parallax-scale', '1');
    }

    if (this.parallaxSlot) {
      this.parallaxSlot.style.setProperty('--footer-parallax-progress', '0');
    }

    if (resetClip) {
      this.resetParallaxClip();
    }

    this.updateParallax(false);
    this.handleParallaxScroll();
  }

  handleParallaxScroll() {
    if (typeof window === "undefined") return;
    if (this.parallaxRAF) return;

    const applyTransforms = this.parallaxActive;
    this.parallaxRAF = window.requestAnimationFrame(() => this.updateParallax(applyTransforms));
  }

  updateParallax(applyTransforms = true) {
    this.parallaxRAF = null;

    if (typeof window === "undefined" || !this.parallaxSlot) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (!this.parallaxRange || !Number.isFinite(this.parallaxRange)) {
      this.refreshParallaxMetrics();
    }

    if (!applyTransforms || !this.parallaxLayer) {
      this.updateParallaxClip(false);
      return;
    }

    const range = this.parallaxRange || 1;
    const start = this.parallaxRangeStart || 0;

    let progress = (scrollY - start) / range;
    progress = Math.max(0, Math.min(progress, 1));

    const slotHeight = this.parallaxHeight || this.parallaxSlot.offsetHeight || 0;
    const baseHeight = this.parallaxBaseHeight || slotHeight;
    const scale = 1 + progress * 0.1;
    const desiredTranslate = -slotHeight * 0.35 * progress;
    const scaledHeight = baseHeight * scale;
    const maxOffset = Math.max(0, (scaledHeight - slotHeight) / 2);
    const translate = Math.max(-maxOffset, desiredTranslate);

    this.parallaxSlot.style.setProperty('--footer-parallax-progress', progress.toFixed(4));
    this.parallaxLayer.style.setProperty('--footer-parallax-translate', `${translate.toFixed(2)}px`);
    this.parallaxLayer.style.setProperty('--footer-parallax-scale', scale.toFixed(4));

    this.updateParallaxClip(false);
  }

  updateClipBuffer() {
    if (typeof window === "undefined") return;

    const bufferTarget = this.footerElement || this.wrapperElement || this.element;
    if (!bufferTarget) {
      this.clipBuffer = 0;
      return;
    }

    try {
      const computed = window.getComputedStyle(bufferTarget);
      if (!computed) {
        this.clipBuffer = 0;
        return;
      }

      const rawBuffer = computed.getPropertyValue('--footer-parallax-clip-buffer');
      const parsedBuffer = rawBuffer ? parseFloat(rawBuffer) : 0;
      this.clipBuffer = Number.isFinite(parsedBuffer) ? parsedBuffer : 0;
    } catch (error) {
      this.clipBuffer = 0;
    }
  }

  updateParallaxClip(force = false) {
    if (!this.wrapperElement || !this.parallaxSlot) return;

    const slotRect = this.parallaxSlot.getBoundingClientRect();
    const wrapperRect = this.wrapperElement.getBoundingClientRect();

    const baseBuffer = Number.isFinite(this.clipBuffer) ? Math.max(0, this.clipBuffer) : 0;
    const coarseBoost = this.isCoarsePointer ? 1.25 : 1;
    const iosBoost = this.isIOS ? 1.35 : 1;

    const topExtraBase = baseBuffer > 0 ? Math.max(4, baseBuffer * 0.6) : 4;
    const bottomExtraBase = Math.max(12, baseBuffer + 12);

    const topExtra = Math.max(topExtraBase, this.isIOS ? 8 : topExtraBase) * iosBoost;
    const bottomExtra = Math.max(bottomExtraBase * coarseBoost * iosBoost, 18);

    const clipTopDiff = Math.max(0, slotRect.top - wrapperRect.top);
    const clipBottomDiff = Math.max(0, wrapperRect.bottom - slotRect.bottom);

    let clipTop = clipTopDiff + topExtra;
    let clipBottom = clipBottomDiff + bottomExtra;

    clipTop = Number.isFinite(clipTop) ? Math.max(0, clipTop) : 0;
    clipBottom = Number.isFinite(clipBottom) ? Math.max(0, clipBottom) : 0;

    const hasMeaningfulChange =
      force ||
      this.lastClipTop === null ||
      this.lastClipBottom === null ||
      Math.abs(clipTop - this.lastClipTop) > 0.5 ||
      Math.abs(clipBottom - this.lastClipBottom) > 0.5;

    if (!hasMeaningfulChange) {
      return;
    }

    this.lastClipTop = clipTop;
    this.lastClipBottom = clipBottom;

    this.wrapperElement.style.setProperty('--footer-parallax-clip-top', `${clipTop.toFixed(2)}px`);
    this.wrapperElement.style.setProperty('--footer-parallax-clip-bottom', `${clipBottom.toFixed(2)}px`);
  }

  resetParallaxClip() {
    if (!this.wrapperElement) return;
    const baseBuffer = Number.isFinite(this.clipBuffer) ? Math.max(0, this.clipBuffer) : 0;
    const coarseBoost = this.isCoarsePointer ? 1.25 : 1;
    const iosBoost = this.isIOS ? 1.35 : 1;

    const topExtraBase = baseBuffer > 0 ? Math.max(4, baseBuffer * 0.6) : 4;
    const bottomExtraBase = Math.max(12, baseBuffer + 12);

    const topExtra = Math.max(topExtraBase, this.isIOS ? 8 : topExtraBase) * iosBoost;
    const bottomExtra = Math.max(bottomExtraBase * coarseBoost * iosBoost, 18);

    this.wrapperElement.style.setProperty('--footer-parallax-clip-top', `${topExtra.toFixed(2)}px`);
    this.wrapperElement.style.setProperty('--footer-parallax-clip-bottom', `${bottomExtra.toFixed(2)}px`);
    this.lastClipTop = topExtra;
    this.lastClipBottom = bottomExtra;
  }

  observeFooter() {
    const footer = this.element.querySelector('.footer');
    const overlay = this.element.querySelector('.footer__page-overlay');
    const wrapper = this.element.querySelector(".footer__wrapper");
    
    if (!this.parallaxSlot) {
      this.setupParallax();
    }

    if (!footer || !overlay || !wrapper) return;

    // Add animation classes for CSS transitions
    wrapper.classList.add('footer__wrapper--animated', 'footer__wrapper--hidden');
    overlay.classList.add('footer__page-overlay--animated', 'footer__page-overlay--hidden');

    // Use Intersection Observer for better performance than scroll events
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -140px 0px',
      threshold: [0, 0.2, 0.4, 0.6, 1]
    };

    this.footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const intersectionRatio = entry.intersectionRatio || 0;
        const isVisible = entry.isIntersecting || intersectionRatio > 0;

        const rootBounds = entry.rootBounds || {
          top: 0,
          bottom: window.innerHeight || document.documentElement.clientHeight || 0
        };
        const fullyAbove = entry.boundingClientRect.bottom <= rootBounds.top;
        const fullyBelow = entry.boundingClientRect.top >= rootBounds.bottom;

        if (isVisible) {
          if (!this.footerVisible && intersectionRatio >= 0.15) {
            wrapper.classList.remove('footer__wrapper--hidden');
            wrapper.classList.add('footer__wrapper--visible');
            overlay.classList.remove('footer__page-overlay--hidden');
            overlay.classList.add('footer__page-overlay--visible');
            this.footerVisible = true;
            this.updateParallaxClip(true);
          }

          if (!this.parallaxActive) {
            this.startParallax();
          }
          return;
        }

        if (this.footerVisible && (fullyAbove || fullyBelow)) {
          wrapper.classList.remove('footer__wrapper--visible');
          wrapper.classList.add('footer__wrapper--hidden');
          overlay.classList.remove('footer__page-overlay--visible');
          overlay.classList.add('footer__page-overlay--hidden');
          this.footerVisible = false;
          this.stopParallax();
        }
      });
    }, observerOptions);

    // Start observing the footer
    this.footerObserver.observe(footer);
  }

  disconnectedCallback() {
    // Clean up Intersection Observer
    if (this.footerObserver) {
      this.footerObserver.disconnect();
      this.footerObserver = null;
    }

    this.stopParallax(true);

    if (typeof window !== "undefined" && this.boundResize) {
      window.removeEventListener('resize', this.boundResize);
      this.boundResize = null;
    }
  }

}

customElements.define("footer-section", FooterSection);






class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    
    // Safely parse section settings
    try {
      const sectionSettings = this.element.getAttribute("data-section-settings");
      this.options = sectionSettings ? JSON.parse(sectionSettings) : {};
    } catch (error) {
      this.options = {};
    }

    this.changeImageQuality();
    new AddToCart(this.element);
  }

  connectedCallback() {
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");
    this.tintElement = this.element.querySelector('.ProductSlider--Tint');
    this.wrapperElement = this.element.querySelector('.ProductSlider--Wrapper');
    this.productInfoWrapper = document.querySelector('.product-info__wrapper');
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");
    this.secondImageElement = this.element.querySelector(".Product--SecondImageImg");

    // Build array of product images from swiper slides
    this.buildProductImagesArray();

    if (this.element.querySelector(".notify-me__overlay")) {
      this.notifyMeOverlayElement = this.element.querySelector(".notify-me__overlay");
    }

    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];

    if (slides.length <= 1) {
      const buttons = this.element.querySelectorAll('#productSwiperElement .pdp_swiperButton');
      buttons.forEach(btn => btn.style.display = 'none');
    }

    // Wait for swiper initialization before setting up zoom - check if carousel element exists
    if (this.carouselElement) {
      this.carouselElement.addEventListener('swiper:initialized', (e) => {
        this.carousel = this.carouselElement;
        
        // Add slide change listener to emit legacy event for video components
        if (e.detail && e.detail.swiper && e.detail.swiper.swiperElement) {
          const swiperInstance = e.detail.swiper.swiperElement;
          
          // Store reference to thumbnail swiper
          this.thumbSwiperInstance = e.detail.swiper.thumbSwiper;
          
        swiperInstance.on('slideChange', () => {
          // Get the real index (leftmost visible slide)
          const realIndex = this.getRealThumbnailIndex(swiperInstance);
          
          // Manually sync active state to only the leftmost thumbnail
          this.syncThumbnailActiveState(realIndex);
          
          // Scroll thumbnail swiper to keep active thumbnail visible
          this.scrollThumbnailToActive(realIndex);
          
          window.dispatchEvent(
            new CustomEvent("swiper:slide-changed", {
              bubbles: true,
              detail: {
                currentIndex: swiperInstance.activeIndex,
                element: this.carousel,
              },
            })
          );
        });
        
        // Initial sync on load - run multiple times to ensure it sticks
        const initialIndex = this.getRealThumbnailIndex(swiperInstance);
        this.syncThumbnailActiveState(initialIndex);
        this.scrollThumbnailToActive(initialIndex);
        
        // Force sync again after a short delay
        setTimeout(() => {
          this.syncThumbnailActiveState(initialIndex);
        }, 50);
        
        setTimeout(() => {
          this.syncThumbnailActiveState(initialIndex);
        }, 200);
        
        // Setup MutationObserver to enforce single active thumbnail
        this.setupThumbnailActiveObserver(swiperInstance);
        
        // Override Swiper's thumbs active state updates
        // Use a slight delay to let Swiper update first, then enforce single active thumbnail
        if (this.thumbSwiperInstance) {
          this.thumbSwiperInstance.on('slideChange', () => {
            setTimeout(() => {
              const currentIndex = this.getRealThumbnailIndex(swiperInstance);
              this.syncThumbnailActiveState(currentIndex);
            }, 10);
          });
        }
        
        // Setup thumbnail preloading
        this.setupThumbnailPreloading(swiperInstance);
        }
        
        if (this.options["enable_zoom"]) {
          new RevolutionImageZoom(this.element, this.carousel);
        }
      });
    }

    // Swiper's thumbs module handles thumbnail clicks automatically via slideToClickedSlide option

    // Fallback for non-zoom case
    if (!this.options["enable_zoom"]) {
      this.carousel = this.carouselElement;
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc");
      // Also check for sticky ATC outside the main wrapper
      if (!this.stickyAtcWrapper) {
        this.stickyAtcWrapper = document.querySelector(".product-module__sticky-atc");
      }
      document.body.classList.add('has-sticky');
    } else {
      document.body.classList.remove('has-sticky');
    }

    const uspGroup = this.element.querySelector('.pdp_usp-group');
    if (uspGroup && !uspGroup.querySelector('div')) {
      uspGroup.style.display = 'none';
    }
    this.isAutomaticDropdownOpen = false;
    this.bindEvents();
    this.initScrollTintObserver();
    this.appendPriceSpans();
    this.updatePriceButtonATC();
    requestAnimationFrame(() => this.openFirstFaqDropdowns());
    
    // Initial calculation of Product--Wrapper min-height
    requestAnimationFrame(() => this.updateProductWrapperHeight());


    document.addEventListener("variant:price-updated", () => {
      this.updatePriceButtonATC();
    });

    // Listen for variant changes to sync sticky ATC
    document.addEventListener("variant:changed", () => {
      this.syncStickyAtcButtons();
    });

    // Listen for price updates
    document.addEventListener("variant:price-updated", () => {
      this.syncStickyAtcButtons();
    });

    // Listen for any button state changes
    this.element.addEventListener("product:button-state-changed", () => {
      this.syncStickyAtcButtons();
    });
    
    // Initial sync of sticky ATC buttons
    this.syncStickyAtcButtons();

    // Set up mutation observer to watch for changes to main ATC buttons
    if (this.stickyAtcWrapper && this.mainAtc) {
      this.setupAtcButtonObserver();
    }

    // Additional delayed sync to catch any async updates
    setTimeout(() => {
      this.syncStickyAtcButtons();
    }, 500);

    // Periodic sync to ensure buttons stay in sync
    if (this.stickyAtcWrapper) {
      this.syncInterval = setInterval(() => {
        this.syncStickyAtcButtons();
      }, 2000);
    }
  }

  // Method to manually trigger sync (can be called from external scripts)
  forceSyncStickyAtc() {
    this.syncStickyAtcButtons();
  }

  // Clean up interval when component is destroyed
  disconnectedCallback() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }
  }

  setupAtcButtonObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldSync = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.classList.contains('product__atc-button') || 
              target.classList.contains('product-module__product-atc-notify')) {
            shouldSync = true;
          }
        } else if (mutation.type === 'childList') {
          // Check if button text content changed
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE || 
                (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('ButtonText'))) {
              shouldSync = true;
            }
          });
        }
      });
      
      if (shouldSync) {
        this.syncStickyAtcButtons();
      }
    });

    // Observe the main ATC area for changes
    observer.observe(this.mainAtc, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'class']
    });
  }

  syncStickyAtcButtons() {
    if (!this.stickyAtcWrapper) return;

    // Find main ATC buttons in the product info section
    const mainAtcButton = this.element.querySelector('.product-info__actions .product__atc-button');
    const mainNotifyButton = this.element.querySelector('.product-info__actions .product-module__product-atc-notify, .product-info__actions [data-action="notify-open"]');
    
    // Find sticky ATC buttons
    const stickyAtcButton = this.stickyAtcWrapper.querySelector('.product-module__product-atc--sticky');
    const stickyNotifyButton = this.stickyAtcWrapper.querySelector('.product-module__product-atc-notify');

    if (mainAtcButton && stickyAtcButton) {
      // Check if main button is hidden or disabled
      const isMainAtcHidden = mainAtcButton.classList.contains('hideBtn') || 
                              mainAtcButton.hasAttribute('disabled') || 
                              mainAtcButton.style.display === 'none';

      if (isMainAtcHidden) {
        stickyAtcButton.setAttribute('disabled', 'disabled');
        stickyAtcButton.classList.add('hideBtn');
      } else {
        stickyAtcButton.removeAttribute('disabled');
        stickyAtcButton.classList.remove('hideBtn');
      }

      // Sync button text
      const mainButtonText = mainAtcButton.querySelector('.ButtonText:not(.button-total-price)');
      const stickyButtonText = stickyAtcButton.querySelector('.ButtonText:not(.button-total-price)');
      
      if (mainButtonText && stickyButtonText) {
        stickyButtonText.textContent = mainButtonText.textContent;
      }

      // Sync total price
      const mainPriceSpan = mainAtcButton.querySelector('.button-total-price');
      const stickyPriceSpan = stickyAtcButton.querySelector('.button-total-price');
      
      if (mainPriceSpan && stickyPriceSpan) {
        stickyPriceSpan.textContent = mainPriceSpan.textContent;
      }
    }

    // Sync notify me buttons - show sticky notify when main notify is visible
    if (mainNotifyButton && stickyNotifyButton) {
      const isMainNotifyVisible = !mainNotifyButton.classList.contains('hideBtn') && 
                                  mainNotifyButton.style.display !== 'none';

      if (isMainNotifyVisible) {
        stickyNotifyButton.classList.remove('hideBtn');
      } else {
        stickyNotifyButton.classList.add('hideBtn');
      }
    }

    // If main ATC is hidden, show sticky notify (and vice versa)
    if (mainAtcButton && stickyAtcButton && stickyNotifyButton) {
      const isMainAtcVisible = !mainAtcButton.classList.contains('hideBtn') && 
                               !mainAtcButton.hasAttribute('disabled') && 
                               mainAtcButton.style.display !== 'none';

      if (isMainAtcVisible) {
        stickyAtcButton.classList.remove('hideBtn');
        stickyNotifyButton.classList.add('hideBtn');
      } else {
        stickyAtcButton.classList.add('hideBtn');
        stickyNotifyButton.classList.remove('hideBtn');
      }
    }
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      ".pdp-connected-product-card",
      this.selectConnectedProductCard.bind(this)
    );

    // ADD: Direct dropdown event handling for ProductElement
    this.domDelegate.on(
      "click",
      "[data-action='toggle-dropdown'], .info__dropdown-button",
      this.handleDropdownToggle.bind(this)
    );

    //Notify me 
    this.domDelegate.on(
      "click",
      '[data-action="notify-me"]',
      this.openNotifyMe.bind(this)
    );

    this.domDelegate.on(
      "click",
      '.notify-me__close-btn[data-action="close-modal"]',
      this.closeNotifyMe.bind(this)
    );

    this.delegateBody.on(
      "click",
      '.notify-me__overlay.is-visible',
      this.closeNotifyMe.bind(this)
    );

    this.domDelegate.on("click", e => {
      const target = e.target;
      if (
        target.closest(".pdp-addon-product-card") ||
        target.matches("input.pdp-addon-product-card__checkbox") ||
        target.matches("input.pdp-accessory-product-card__checkbox") ||
        target.matches("label.SelectboxCircle") ||
        target.matches("div.Selectbox") ||
        target.matches("label.SelectboxLabelNormal") ||
        target.matches(".product-qty__btn") ||
        target.matches("[data-qty-plus]") ||
        target.matches("[data-qty-minus]")
      ) {
        this.updatePriceButtonATC();
      }
    });

    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    // Sync sticky ATC when variant changes
    this.domDelegate.on("variant:changed", () => {
      setTimeout(() => this.syncStickyAtcButtons(), 100);
    });

    if (this.stickyAtcWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
      
      // Add event delegation for sticky ATC buttons
      const stickyDelegate = new Delegate(this.stickyAtcWrapper);
      
      // Handle sticky add to cart button clicks
      stickyDelegate.on("click", ".product-module__product-atc--sticky", (event) => {
        event.preventDefault();
        const mainAtcButton = this.element.querySelector('.product-info__actions .product__atc-button');
        if (mainAtcButton && !mainAtcButton.hasAttribute('disabled')) {
          mainAtcButton.click();
        }
      });
      
      // Handle sticky notify me button clicks
      stickyDelegate.on("click", ".product-module__product-atc-notify", (event) => {
        event.preventDefault();
        const mainNotifyButton = this.element.querySelector('.product-info__actions .product-module__product-atc-notify');
        if (mainNotifyButton) {
          mainNotifyButton.click();
        }
      });
    }
    if (this.options["sticky_atc"] && this.stickyAtcWrapper) {
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      window.addEventListener("DOMContentLoaded", this.showStickyAtc.bind(this));
    }

    // Add resize listener for Product--Wrapper min-height update (desktop only)
    if (responsive && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.updateProductWrapperHeight.bind(this));
    } else {
      window.addEventListener('resize', this.updateProductWrapperHeight.bind(this));
    }
  }

  updateProductWrapperHeight() {
    // Only run on desktop (min-width: 1025px)
    if (window.innerWidth < 1025) return;

    const productWrapper = document.querySelector('.Product--Wrapper');
    const productInfoWrapper = document.querySelector('.product-info__wrapper');

    if (!productWrapper || !productInfoWrapper) return;

    // Get the height of the product-info__wrapper
    const infoWrapperHeight = productInfoWrapper.offsetHeight;

    // Set min-height of Product--Wrapper to infoWrapperHeight + 48px
    const minHeight = infoWrapperHeight + 48;
    productWrapper.style.minHeight = `${minHeight}px`;
  }

  openNotifyMe(e) {
    e.preventDefault();
    // First try to find a properly closed popup
    let notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="true"]');
    
    // If not found, find any popup and force reset it first
    if (!notifyMePopUp) {
      notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper');
      if (notifyMePopUp) {
        // Force reset the popup state
        notifyMePopUp.setAttribute('aria-hidden', 'true');
        notifyMePopUp.setAttribute('aria-visible', 'false');
        notifyMePopUp.querySelector('.notify-me__heading--success').style.display = "none";
        notifyMePopUp.querySelector('.notify-me__success-msg').style.display = 'none';
        notifyMePopUp.querySelector('.notify-me__heading').style.display = "flex";
        notifyMePopUp.querySelector('.notify-me__popup-content').style.display = 'flex';
        notifyMePopUp.querySelector('.notify-me__input').value = "";
      }
    }
    
    if (notifyMePopUp) {
      //add choosen variants
      let form = this.element.querySelector('.pm__atc-form--notify-me');
      let inputID = form.querySelector('input[name="id"]');
      let variantINFO = inputID.getAttribute('value');
      notifyMePopUp.setAttribute('variant-value', `${variantINFO}`);

      notifyMePopUp.setAttribute('aria-hidden', 'false');
      
      // Force reflow before animating
      notifyMePopUp.offsetHeight;
      
      requestAnimationFrame(() => {
        notifyMePopUp.setAttribute('aria-visible', 'true');
      });

      this.notifyMeOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    }
  }

  closeNotifyMe() {
    const notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="false"]');
    if (notifyMePopUp) {
      
      notifyMePopUp.setAttribute('aria-visible', 'false');

      const resetPopupState = () => {
        notifyMePopUp.setAttribute('aria-hidden', 'true');
        notifyMePopUp.querySelector('.notify-me__heading--success').style.display = "none";
        notifyMePopUp.querySelector('.notify-me__success-msg').style.display = 'none';
        notifyMePopUp.querySelector('.notify-me__heading').style.display = "flex";
        notifyMePopUp.querySelector('.notify-me__popup-content').style.display = 'flex';
        notifyMePopUp.querySelector('.notify-me__input').value = "";
      };

      const handleTransitionEnd = (event) => {
        if (event.propertyName === 'clip-path' || event.propertyName === '-webkit-clip-path') {
          resetPopupState();
        }
      };

      // Add transition end listener
      notifyMePopUp.addEventListener('transitionend', handleTransitionEnd, { once: true });

      // Safety timeout to ensure reset happens
      setTimeout(() => {
        if (notifyMePopUp.getAttribute('aria-hidden') !== 'true') {
          resetPopupState();
        }
      }, 500);

      this.notifyMeOverlayElement.classList.remove("is-visible");
      bodyScrollLock.clearAllBodyScrollLocks();

    }
  }

  openFirstFaqDropdowns() {
    this.isAutomaticDropdownOpen = true; // Set flag before automatic opens
    document.querySelectorAll("faq-group").forEach((group) => {
      const btn = group.querySelector(
        "[data-action=toggle-dropdown], [data-action=toggle-desktop-dropdown], [data-action=toggle-mobile-dropdown], .info__dropdown-button"
      );
      if (!btn) return;
      if (btn.getAttribute("aria-expanded") === "true") return;
      btn.click();
    });

    // Clear flag after automatic opens complete
    setTimeout(() => {
      this.isAutomaticDropdownOpen = false;
    }, 100);
  }

  updateImage(event) {
    let imageID = this.options.variant_image_id;
    if (event?.detail?.new_image) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
      slideElement
    );

    // Use SwiperInit API
    if (this.carousel && this.carousel.selectSlide) {
      this.carousel.selectSlide(realIndex);
      // Manually sync active state and scroll
      this.syncThumbnailActiveState(realIndex);
      this.scrollThumbnailToActive(realIndex);
    }
  }



  getRealThumbnailIndex(swiperInstance) {
    // When showing multiple slides per view (e.g., 2 on desktop),
    // return the index of the leftmost visible slide
    if (!swiperInstance) return 0;
    
    // Get the active index
    let realIndex = swiperInstance.activeIndex || 0;
    
    // If loop is enabled, use realIndex property
    if (swiperInstance.params.loop && typeof swiperInstance.realIndex !== 'undefined') {
      realIndex = swiperInstance.realIndex;
    }
    
    return realIndex;
  }

  syncThumbnailActiveState(targetIndex) {
    // Manually control thumbnail active state to only show the leftmost slide as active
    // This is needed because Swiper's thumbs module activates all visible slides when showing multiple per view
    
    // Pause observer while we make changes to avoid infinite loop
    if (this.thumbnailActiveObserver) {
      this.thumbnailActiveObserver.disconnect();
    }
    
    const allThumbnails = this.element.querySelectorAll(".ProductSlider--Thumb");
    
    allThumbnails.forEach((thumb, index) => {
      // Remove all active classes
      thumb.classList.remove('swiper-slide-thumb-active', 'swiper-slide-active');
      
      // Add active class only to the target index (leftmost visible slide)
      if (index === targetIndex) {
        thumb.classList.add('swiper-slide-thumb-active');
        thumb.classList.add('swiper-slide-active');
      }
    });
    
    // Reconnect observer
    if (this.thumbnailActiveObserver) {
      allThumbnails.forEach(thumb => {
        this.thumbnailActiveObserver.observe(thumb, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
  }

  setupThumbnailActiveObserver(swiperInstance) {
    // Setup a MutationObserver to enforce single active thumbnail
    // This catches when Swiper tries to add active classes to multiple thumbnails
    if (!this.carouselElementThumbs) return;
    
    const callback = (mutations) => {
      // Debounce to avoid excessive calls
      if (this.thumbnailSyncTimeout) return;
      
      this.thumbnailSyncTimeout = setTimeout(() => {
        const currentIndex = this.getRealThumbnailIndex(swiperInstance);
        this.syncThumbnailActiveState(currentIndex);
        this.thumbnailSyncTimeout = null;
      }, 5);
    };
    
    this.thumbnailActiveObserver = new MutationObserver(callback);
    
    // Observe each thumbnail for class changes
    const allThumbnails = this.element.querySelectorAll(".ProductSlider--Thumb");
    allThumbnails.forEach(thumb => {
      this.thumbnailActiveObserver.observe(thumb, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  scrollThumbnailToActive(activeIndex) {
    // Scroll the thumbnail swiper to keep the active thumbnail visible
  if (this.thumbSwiperInstance && typeof this.thumbSwiperInstance.slideTo === 'function') {
      // Calculate if the active slide is outside the visible range
      const slidesPerView = this.thumbSwiperInstance.params.slidesPerView || 6;
      const currentIndex = this.thumbSwiperInstance.activeIndex || 0;
      
      // Calculate the target index to scroll to
      // We want to center the active slide when possible
      let targetIndex = activeIndex;
      
      // If activeIndex is beyond the visible range, scroll to show it
      if (activeIndex >= slidesPerView) {
        // Keep some slides visible before the active one
        targetIndex = activeIndex - Math.floor(slidesPerView / 2);
        if (targetIndex < 0) targetIndex = 0;
      } else {
        targetIndex = 0;
      }
      
      // Smoothly scroll to the target thumbnail
      this.thumbSwiperInstance.slideTo(targetIndex, 300);
    }
  }

  setupThumbnailPreloading(swiperInstance) {
    if (!this.carouselElementThumbs) return;
    
    // Get all thumbnail images
    const thumbnailImages = this.carouselElementThumbs.querySelectorAll('.ProductThumb--Image');
    
    // Preload initial set of thumbnails (first 6 are already loaded, preload next 3)
    this.preloadThumbnailImages(6, 9);
    
    // Create intersection observer for lazy loading
    this.setupThumbnailObserver(thumbnailImages);
    
    // Listen to main swiper slide changes to preload upcoming thumbnails
    if (swiperInstance) {
      swiperInstance.on('slideChange', () => {
        const currentIndex = swiperInstance.activeIndex || 0;
        // Preload 3 thumbnails ahead
        this.preloadThumbnailImages(currentIndex + 1, currentIndex + 4);
      });
    }
  }

  setupThumbnailObserver(thumbnailImages) {
    if (!thumbnailImages || thumbnailImages.length === 0) return;
    
    // Create intersection observer with larger root margin to preload before visible
    const observerOptions = {
      root: null,
      rootMargin: '50px', // Start loading 50px before entering viewport
      threshold: 0
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const thumbSrc = img.getAttribute('data-thumb-src');
          
          if (thumbSrc && !img.src) {
            img.src = thumbSrc;
            img.removeAttribute('data-thumb-src');
          }
          
          observer.unobserve(img);
        }
      });
    }, observerOptions);
    
    // Observe all thumbnail images that have data-thumb-src
    thumbnailImages.forEach(img => {
      if (img.hasAttribute('data-thumb-src')) {
        observer.observe(img);
      }
    });
    
    // Store observer for cleanup
    this.thumbnailObserver = observer;
  }

  preloadThumbnailImages(startIndex, endIndex) {
    if (!this.carouselElementThumbs) return;
    
    const thumbnailImages = this.carouselElementThumbs.querySelectorAll('.ProductThumb--Image');
    
    for (let i = startIndex; i < endIndex && i < thumbnailImages.length; i++) {
      const img = thumbnailImages[i];
      const thumbSrc = img.getAttribute('data-thumb-src');
      
      if (thumbSrc && !img.src) {
        // Preload the image
        const preloadImg = new Image();
        preloadImg.src = thumbSrc;
        
        // Once loaded, update the actual thumbnail
        preloadImg.onload = () => {
          if (img.getAttribute('data-thumb-src') === thumbSrc) {
            img.src = thumbSrc;
            img.removeAttribute('data-thumb-src');
          }
        };
      }
    }
  }

  buildProductImagesArray() {
    this.productImages = [];
    
    // Get all swiper slides that contain images
    const slides = this.carouselElement?.querySelectorAll('.swiper-slide .ProductSlider--Image') || [];
    
    slides.forEach((img, index) => {
      // Get the best available image source
      let imageSrc = img.getAttribute('data-original-src') || 
                     img.getAttribute('data-src') || 
                     img.src;
      
      // Convert template URL to high quality if needed
      if (imageSrc.includes('{width}x')) {
        imageSrc = imageSrc.replace('{width}x', '1200x');
      }
      
      const imageData = {
        src: imageSrc,
        alt: img.alt,
        index: index
      };
      this.productImages.push(imageData);
    });
  }

  updateSecondImage(currentIndex) {
    if (!this.secondImageElement || !this.productImages || this.productImages.length === 0) {
      return;
    }

    let nextIndex;
    
    if (this.productImages.length === 1) {
      // If only one image, show the same image
      nextIndex = 0;
    } else {
      // Calculate next image index (loop back to 0 if at the end)
      nextIndex = (currentIndex + 1) % this.productImages.length;
    }

    const nextImage = this.productImages[nextIndex];
    if (nextImage) {
      // Update the second image
      this.secondImageElement.src = nextImage.src;
      this.secondImageElement.alt = nextImage.alt;
    }
  }

  initScrollTintObserver() {
    // Only run on desktop (min-width: 1025px) where product-info__wrapper overlaps the slider
    if (window.innerWidth < 1025) return;
    
    if (!this.wrapperElement || !this.tintElement || !this.productInfoWrapper) return;

    // Aggressive throttling to prevent flashing during fast scroll
    // Safari needs even more aggressive throttling
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.tintRafId = null;
    this.tintLastUpdate = 0;
    this.tintMinInterval = isSafari ? 150 : 100; // Safari: 150ms, Others: 100ms
    this.tintScrollTimeout = null;
    this.tintFinalUpdateTimeout = null;
    
    this.tintScrollHandler = () => {
      if (this.tintRafId) return;
      
      const now = performance.now();
      const timeSinceLastUpdate = now - this.tintLastUpdate;
      
      // Skip if we updated too recently
      if (timeSinceLastUpdate < this.tintMinInterval) {
        // Schedule final update after scroll stops
        clearTimeout(this.tintFinalUpdateTimeout);
        this.tintFinalUpdateTimeout = setTimeout(() => {
          this.updateTintOpacity();
        }, 200);
        return;
      }
      
      // Disable transition during scroll for Safari
      if (isSafari) {
        this.tintElement.style.transition = 'none';
      }
      
      this.tintRafId = requestAnimationFrame(() => {
        this.updateTintOpacity();
        this.tintLastUpdate = performance.now();
        this.tintRafId = null;
        
        // Re-enable transition after scroll stops (Safari only)
        if (isSafari) {
          clearTimeout(this.tintScrollTimeout);
          this.tintScrollTimeout = setTimeout(() => {
            this.tintElement.style.transition = '';
          }, 200);
        }
        
        // Schedule final update to ensure correct opacity when scroll stops
        clearTimeout(this.tintFinalUpdateTimeout);
        this.tintFinalUpdateTimeout = setTimeout(() => {
          this.updateTintOpacity();
        }, 200);
      });
    };

    // Use GlobalScrollListener for better performance
    if (window.scrollListener) {
      this.tintScrollListenerRemover = window.scrollListener.addScrollListener(this, this.tintScrollHandler);
    } else {
      window.addEventListener('scroll', this.tintScrollHandler, { passive: true });
    }
    window.addEventListener('resize', this.tintScrollHandler, { passive: true });

    this.updateTintOpacity();
  }

  selectConnectedProductCard(event) {
    const clickedCard = event.target.closest(".pdp-connected-product-card");
    if (!clickedCard) return;

    const allCards = this.element.querySelectorAll(".pdp-connected-product-card");
    allCards.forEach(card => card.classList.remove("pdp-connected-product-card--selected"));

    clickedCard.classList.add("pdp-connected-product-card--selected");
  }

  updateTintOpacity() {
    // Only run on desktop (min-width: 1025px)
    if (window.innerWidth < 1025) {
      // Ensure tint is hidden on mobile
      if (this.tintElement) {
        this.tintElement.style.opacity = '0';
      }
      return;
    }
    
    if (!this.wrapperElement || !this.tintElement || !this.productInfoWrapper) return;
    
    const wrapperRect = this.wrapperElement.getBoundingClientRect();
    const infoRect = this.productInfoWrapper.getBoundingClientRect();

    const overlapTop = Math.max(wrapperRect.top, infoRect.top);
    const overlapBottom = Math.min(wrapperRect.bottom, infoRect.bottom);
    const overlapHeight = Math.max(0, overlapBottom - overlapTop);

    const wrapperHeight = wrapperRect.height;
    const overlapRatio = Math.min(overlapHeight / wrapperHeight, 1);
    const scaledOpacity = Math.max(0, Math.min(overlapRatio * 2, 1));
    const newOpacity = scaledOpacity.toFixed(2);

    // Only update if opacity actually changed to prevent unnecessary repaints
    // Safari needs larger threshold to prevent flashing
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const threshold = isSafari ? 0.03 : 0.01;
    const currentOpacity = parseFloat(this.tintElement.style.opacity) || 0;
    
    if (Math.abs(currentOpacity - parseFloat(newOpacity)) > threshold) {
      this.tintElement.style.opacity = newOpacity;
    }
  }

  calculateTotalPrice() {
    let total = 0;

    const mainPriceEl = this.element.querySelector('[data-price].product-info__price--value');
    if (mainPriceEl) {
      const price = parseFloat(mainPriceEl.getAttribute("data-price"));
      total += isNaN(price) ? 0 : price;
    }

    const checkedAddons = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked[data-price]');
    checkedAddons.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      total += price;
    });

    const checkedAccessories = this.element.querySelectorAll('.pdp-accessory-product-card__checkbox:checked[data-price]');
    checkedAccessories.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      const productId = input.getAttribute("data-productid");
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      total += price * qty;
    });

    const pageQtyInput = this.element.querySelector('input[name="quantity"]');
    const pageQty = pageQtyInput ? Math.max(1, parseInt(pageQtyInput.value, 10) || 1) : 1;

    return total * pageQty;
  }

  appendPriceSpans() {
    const isPreorder = String(this.element.dataset.preorder).toLowerCase() === "true";
    if (isPreorder) return;

    this.element.querySelectorAll(".product__atc-button").forEach(button => {
      if (button.hasAttribute("disabled")) return;
      if (button.querySelector('.button-total-price')) return;

      const span = document.createElement("span");
      span.className = "ButtonText button-total-price u-pb1";
      span.setAttribute("data-money-convertible", "");

      const total = this.calculateTotalPrice();
      span.textContent = ` - ${Shopify.formatMoney(total, window.theme.moneyFormat)}`;

      button.insertBefore(span, button.children[1] || null);
    });
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice();
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll(".product__atc-button .button-total-price").forEach(span => {
      const button = span.closest(".product__atc-button");
      if (button && button.hasAttribute("disabled")) return;
      span.textContent = ` - ${formatted}`;
    });

    // Also update sticky ATC price
    if (this.stickyAtcWrapper) {
      const stickyPriceSpan = this.stickyAtcWrapper.querySelector(".product-module__product-atc--sticky .button-total-price");
      if (stickyPriceSpan) {
        stickyPriceSpan.textContent = ` - ${formatted}`;
      }
    }

    // Sync sticky buttons after price update
    this.syncStickyAtcButtons();
  }

  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  showStickyAtc() {
    if (this.hideSticky || !this.stickyAtcWrapper) return;

    // Prevent creating multiple observers
    if (this.stickyObserversInitialized) return;
    this.stickyObserversInitialized = true;

    const options = { root: null, threshold: 0 };
    const footer = document.querySelector("footer");
    
    if (!footer || !this.mainAtc) return;

    // Debounce timer for rapid scroll changes with slight delay
    let stickyUpdateTimeout = null;
    let stickyDebounceTimer = null;

    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Clear any pending updates
        if (stickyUpdateTimeout) cancelAnimationFrame(stickyUpdateTimeout);
        if (stickyDebounceTimer) clearTimeout(stickyDebounceTimer);
        
        // Add small delay to prevent rapid toggling during fast scrolls
        stickyDebounceTimer = setTimeout(() => {
          // Use requestAnimationFrame to batch DOM changes and prevent layout jumps
          stickyUpdateTimeout = requestAnimationFrame(() => {
            if (entry.isIntersecting) {
              this.mainAtcVisible = true;
              this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
              document.body.classList.remove("has-sticky");
            } else {
              this.mainAtcVisible = false;
              if (!this.footerVisible) {
                this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
                document.body.classList.add("has-sticky");
              }
            }
            stickyUpdateTimeout = null;
          });
        }, 50); // 50ms debounce to prevent rapid toggling
      });
    }, options);

    let footerUpdateTimeout = null;
    let footerDebounceTimer = null;

    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.footerVisible = entry.isIntersecting;

        // Clear any pending updates
        if (footerUpdateTimeout) cancelAnimationFrame(footerUpdateTimeout);
        if (footerDebounceTimer) clearTimeout(footerDebounceTimer);

        // Add small delay to prevent rapid toggling during fast scrolls
        footerDebounceTimer = setTimeout(() => {
          // Use requestAnimationFrame to batch DOM changes and prevent layout jumps
          footerUpdateTimeout = requestAnimationFrame(() => {
            if (this.footerVisible) {
              this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
              document.body.classList.remove("has-sticky");
            } else if (!this.mainAtcVisible) {
              this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
              document.body.classList.add("has-sticky");
            }
            footerUpdateTimeout = null;
          });
        }, 50); // 50ms debounce to prevent rapid toggling
      });
    }, { 
      root: null, 
      threshold: 0,
      rootMargin: "50px 0px 0px 0px" // Trigger earlier to prevent jump on iOS
    });

    // Start observing immediately
    atcObserver.observe(this.mainAtc);
    footerObserver.observe(footer);
  }

  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal.getAttribute("data-src").replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }

  handleDropdownToggle(event, target) {
    event.preventDefault();
    event.stopPropagation(); // Prevent global dropdown handler from also firing

    const targetEl = event.target.closest('[data-action="toggle-dropdown"]');
    
    // Only track if it's a user interaction (not automatic opening)
    if (!this.isAutomaticDropdownOpen && typeof dataLayer !== 'undefined' && targetEl?.dataset.gtmEvent === 'product_tabs') {
        const tabTitle = targetEl.dataset.gtmFaqTitle || 
                        targetEl.querySelector('.info__dropdown-button--text')?.textContent || 
                        targetEl.innerText;
        
        dataLayer.push({
            event: 'product_dropdown',
            dropdown_tab: tabTitle
        });
        console.log("dataLayer push -> product_dropdown:", tabTitle);
    }
    
    
    const mainDropdown = target.closest(".Dropdown");
    if (!mainDropdown) return;
    
    const dropdownButton = mainDropdown.querySelector(".Dropdown--Button");
    const dropdownContent = mainDropdown.querySelector(".Dropdown--Content");
    
    if (!dropdownButton || !dropdownContent) return;
    
    const isOpen = dropdownButton.getAttribute("aria-expanded") === "true";
    
    // First, close ALL dropdowns
    this.element.querySelectorAll(".Dropdown").forEach((dropdown) => {
      const otherButton = dropdown.querySelector(".Dropdown--Button");
      const otherContent = dropdown.querySelector(".Dropdown--Content");
      if (otherButton && otherContent && otherButton.getAttribute("aria-expanded") === "true") {
        // Remove any existing transitionend listeners to prevent duplicates
        const existingHandler = otherContent._hideAfterTransition;
        if (existingHandler) {
          otherContent.removeEventListener("transitionend", existingHandler);
        }
        
        // Clear any existing timeout
        if (otherContent._hideTimeout) {
          clearTimeout(otherContent._hideTimeout);
        }
        
        // Start the slide up animation first
        new RevolutionAnimation(otherContent, "true").slideUp();
        
        // Set aria-hidden and aria-expanded AFTER animation completes
        const hideAfterTransition = function(e) {
          if (e.propertyName === "height") {
            dropdown.setAttribute("aria-expanded", "false");
            otherButton.setAttribute("aria-expanded", "false");
            otherContent.setAttribute("aria-hidden", "true");
            otherContent.removeEventListener("transitionend", hideAfterTransition);
            delete otherContent._hideAfterTransition;
            if (otherContent._hideTimeout) {
              clearTimeout(otherContent._hideTimeout);
              delete otherContent._hideTimeout;
            }
          }
        };
        
        // Store reference to the handler so we can remove it if needed
        otherContent._hideAfterTransition = hideAfterTransition;
        otherContent.addEventListener("transitionend", hideAfterTransition);
        
        // Fallback timeout in case transitionend doesn't fire (300ms matches the CSS transition)
        otherContent._hideTimeout = setTimeout(() => {
          dropdown.setAttribute("aria-expanded", "false");
          otherButton.setAttribute("aria-expanded", "false");
          otherContent.setAttribute("aria-hidden", "true");
          otherContent.removeEventListener("transitionend", hideAfterTransition);
          delete otherContent._hideAfterTransition;
          delete otherContent._hideTimeout;
        }, 350);
      }
    });
    
    // If the clicked dropdown was closed, open it
    if (!isOpen) {
      dropdownButton.setAttribute("aria-expanded", "true");
      dropdownContent.setAttribute("aria-hidden", "false");
      new RevolutionAnimation(dropdownContent, "true").slideDown();
    }
    // If it was open, it's already closed by the loop above
  }

  disconnectedCallback() {
    // Clean up GlobalScrollListener
    if (this.tintScrollListenerRemover) {
      this.tintScrollListenerRemover.removeScrollListener();
    }
  }
}

customElements.define("product-component", ProductElement);

class ProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.delegate = new Delegate(this);
  }

  connectedCallback() {
    this.inputSelector = 'input[name="quantity"]';

    this.delegate.on("click", "[data-qty-plus]", () => {
      const input = this.querySelector(this.inputSelector);
      if (!input) return;
      input.value = this.cap(String(this.toInt(input.value || "1") + 1));
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("click", "[data-qty-minus]", () => {
      const input = this.querySelector(this.inputSelector);
      if (!input) return;
      const n = Math.max(1, this.toInt(input.value || "1") - 1);
      input.value = this.cap(String(n));
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("keydown", this.inputSelector, (e) => {
      const allowedCtrl = ["Backspace","Delete","ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Home","End","Tab"];
      const isCtrl = e.ctrlKey || e.metaKey || e.altKey;
      const isDigit = /^[0-9]$/.test(e.key);
      if (isCtrl && (["a","c","v","x"].includes(e.key.toLowerCase()))) return;
      if (allowedCtrl.includes(e.key)) return;
      if (isDigit) {
        const input = e.target;
        const selLen = input.selectionEnd - input.selectionStart;
        const digits = (input.value || "").replace(/\D+/g, "");
        if (digits.length - selLen >= 2) { e.preventDefault(); return; }
        return;
      }
      e.preventDefault();
    });

    this.delegate.on("paste", this.inputSelector, (e) => {
      e.preventDefault();
      const input = e.target;
      const text = (e.clipboardData || window.clipboardData).getData("text") || "";
      let digits = text.replace(/\D+/g, "").slice(0, 2);
      if (digits === "") return;
      const start = input.selectionStart, end = input.selectionEnd;
      const v = (input.value || "");
      let next = (v.slice(0, start) + digits + v.slice(end)).replace(/\D+/g, "").slice(0,2);
      next = this.cap(next);
      input.value = next;
      const caret = Math.min(start + digits.length, next.length);
      input.setSelectionRange(caret, caret);
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("input", this.inputSelector, (e) => {
      const input = e.target;
      // dozvoli prazno dok tipka
      let digits = (input.value || "").replace(/\D+/g, "").slice(0,2);
      input.value = digits;
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("blur", this.inputSelector, (e) => {
      const input = e.target;
      input.value = this.sanitize(input.value, false); // resetira na min 1
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("change", this.inputSelector, (e) => {
      const input = e.target;
      input.value = this.sanitize(input.value, false); // resetira na min 1
      this.updateBtnState();
      this.emit();
    });

    this.delegate.on("wheel", this.inputSelector, (e) => {
      e.target.blur();
    });

    const input = this.querySelector(this.inputSelector);
    if (input) {
      input.value = this.sanitize(input.value || "1", false);
      this.updateBtnState();
    }
  }

  toInt(v) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 1;
  }

  cap(v) {
    const n = this.toInt(v);
    return String(Math.min(99, Math.max(1, n)));
  }

  sanitize(v, allowEmpty) {
    const digits = String(v ?? "").replace(/\D+/g, "").slice(0,2);
    if (allowEmpty && digits === "") return "";
    return this.cap(digits || "1");
  }

  updateBtnState() {
    const input = this.querySelector(this.inputSelector);
    const minus = this.querySelector("[data-qty-minus]");
    const plus = this.querySelector("[data-qty-plus]");
    if (!input) return;

    const value = this.toInt(input.value || "1");

    if (minus) {
      const atMin = value <= 1;
      minus.classList.toggle("product-qty__btn--disabled", atMin);
      minus.disabled = atMin;
    }

    if (plus) {
      const atMax = value >= 99;
      plus.classList.toggle("product-qty__btn--disabled", atMax);
      plus.disabled = atMax;
    }
  }

  emit() {
    this.dispatchEvent(new CustomEvent("qty:updated", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("variant:price-updated"));
  }
}

customElements.define("product-quantity", ProductQuantity);

class KlaviyoPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.initKlaviyoTrigger();
  }

  initKlaviyoTrigger() {
    const button = this.querySelector('.product-module__product-atc-notify');
    const formId = this.dataset.formId; // get the ID passed from Liquid

    if (button && formId) {
      button.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    }
  }
}

customElements.define('klaviyo-popup', KlaviyoPopup);

class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this; // reference to our element
  }

  connectedCallback() {
    // Keep this minimal: just init, observe resize, bind events, do initial layout
    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  /**
   * If you have a custom responsive utility, use that;
   * otherwise, fall back to window resize
   */
  observeResize() {
    if (typeof responsive !== "undefined" && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize.bind(this));
    } else {
      window.addEventListener("resize", this.handleResize.bind(this));
    }
  }

  /**
   * Use your original approach (Delegate) to bind show-more / show-less
   */
  bindEvents() {
    // We attach delegate to the wrapper (or this.element) - your choice
    this.delegateElement = new Delegate(this.selectBoxWrapper);

    // Show more
    this.delegateElement.on(
      "click",
      '[data-action="show-more"]',
      this.showAllVariants.bind(this)
    );

    // Show less
    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLessVariants.bind(this)
    );
  }

  /**
   * Main layout logic: measure how many variants fit in one row,
   * ensuring the + x more button (if needed) is also in the same row.
   */
  calculateLayout() {
    if (!this.selectBoxWrapper) return;

    // Temporarily show everything so we can measure
    this.variants.forEach((variant) => {
      variant.style.display = ""; // revert to default (inline-block/flex)
    });
    // Show plus, hide minus for measurement
    if (this.plusButton) this.plusButton.style.display = "";
    if (this.minusButton) this.minusButton.style.display = "none";

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    // If no variants, just hide plus/minus
    if (this.totalVariants === 0) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
      return;
    }

    // Measure a single variant's width (use first variant as a reference)
    const singleVariantWidth = this.variants[0].offsetWidth;
    // Gap (if you have margin, measure it via getComputedStyle; here we assume 4px)
    const variantGap = 8;

    // Measure plus button width
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;
    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    // Figure out how many variants we can fit in one row
    for (let i = 0; i < this.variants.length; i++) {
      // Width for this variant (plus gap if it's not the first)
      const widthNeeded = variantGap + singleVariantWidth;

      // If there's another variant *after* this one,
      // we must reserve space for the plus button in THIS row.
      const stillMoreVariantsRemain = (i < this.variants.length - 1);
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;


      // Check if this variant + plus button (if more remain) fits
      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;

      } else {
        // As soon as we can't fit the next variant + button, we stop
        break;
      }
    }

    // If all variants fit, hide plus/minus
    if (itemsInFirstRow >= this.totalVariants) {
      // Show all
      this.variants.forEach((variant) => {
        variant.style.display = "";
      });
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
    } else {
      // We show only itemsInFirstRow
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? "" : "none";
      });

      // Show plus button with the correct count
      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = "";
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      // Hide minus button initially
      if (this.minusButton) {
        this.minusButton.style.display = "none";
      }
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  /**
   * Show all items, hide plus button, show minus button
   */
  showAllVariants(event, target) {
    // Show all variants
    this.variants.forEach((variant) => {
      variant.style.display = "";
    });
    // Hide plus button
    if (this.plusButton) {
      this.plusButton.style.display = "none";
    }
    // Show minus with updated text
    if (this.minusButton) {
      this.minusButton.innerText = `- ${this.remaining} less`;
      this.minusButton.style.display = "";
    }
  }

  /**
   * Collapse items back to what fits in one row
   */
  showLessVariants(event, target) {
    this.calculateLayout();
  }
}

customElements.define("variant-selectbox", VariantSelectBox);

var selectedVariant = null;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.atcButtons = document.querySelectorAll(".product__atc-button");
    this.stickyAtcWrapper = document.querySelector(".pdp-sticky-product-atc");
    this.notifyButtons = document.querySelectorAll(".product-module__product-atc-notify");

    this.notifyStickyAddButton = document.querySelector(".product-module__product-atc");

    this.regularPrice = document.querySelector("product-component .product-info__price--regular span");
    this.compareAtPrice = document.querySelector("product-component .product-info__price--compare");

    this.regularPriceSticky = document.querySelector(".product-module__sticky-atc product-info__price--regular span");
    this.compareAtPriceSticky = document.querySelector(".product-module__sticky-atc .product-info__price--compare");

    this.pricesWrapper = document.querySelector(".product-info__price");

    this.bindEvents();
  }

  bindEvents() {
    this.onVariantChange();

    this.delegateElement.on('click', '.VariantSelect--circle .SelectboxIcon', this.onColorIconClick.bind(this));
    this.delegateElement.on('change', 'select, input', this.onVariantChange.bind(this));
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
    this.delegateElement.on('click', '.quantity-btn.increase, .quantity-btn.decrease', () => {
      this.initAccessoryStateSync();
    });
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.product-info__actions .product__atc-button').click();
  }

  onColorIconClick(e) {
    const label = e.target.closest('.SelectboxIcon');
    if (!label) return;

    const selectbox = label.closest('.Selectbox');
    if (selectbox && selectbox.classList.contains('variant--disabled')) return;

    this.element.querySelectorAll('.VariantSelect--circle .SelectboxIcon.variant--selected')
      .forEach(el => el.classList.remove('variant--selected'));

    label.classList.add('variant--selected');

    const inputId = label.getAttribute('for');
    const input = inputId ? this.element.querySelector(`#${CSS.escape(inputId)}`) : null;
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.updateSelectedVariantLabels();

    this.toggleAddButton();
    this.sendVariantGTMEvent();
    this.updateAvailability();
    this.updatePriceElements(this.regularPrice, this.compareAtPrice);
    if (this.stickyAtcWrapper) this.updatePriceElements(this.regularPriceSticky, this.compareAtPriceSticky);
    document.dispatchEvent(new CustomEvent("variant:price-updated"));
    this.updateLowestPrice();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateAvailability() {
    let availableSuccessDiv = document.querySelector(".availability-success__wrapper");
    let availableErrorDiv = document.querySelector(".availability-error__wrapper")

    this.currentVariant = this.updateMasterId();

    if (this.currentVariant.available) {
      availableSuccessDiv.setAttribute("aria-hidden", false);
      availableErrorDiv.setAttribute("aria-hidden", true);
    } else {
      availableSuccessDiv.setAttribute("aria-hidden", true);
      availableErrorDiv.setAttribute("aria-hidden", false);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    selectedVariant = this.currentVariant;

    return this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  sendVariantGTMEvent() {
    document.dispatchEvent(
      new CustomEvent("variant:changed:gtm", {
        bubbles: true,
        detail: {
          title: selectedVariant.title,
          sku: selectedVariant.sku,
          price: selectedVariant.price,
        }
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updatePriceElements(regularPriceElement, compareAtPriceElement) {
    if (regularPriceElement) {
      const p = this.currentVariant.price;
      regularPriceElement.innerHTML = Shopify.formatMoney(p, window.theme.moneyFormat);
      regularPriceElement.setAttribute('data-price', p);
    }

    const p = this.currentVariant.price;
    const cp = this.currentVariant.compare_at_price;
    const showCompare = typeof cp === 'number' && cp > p;

    if (compareAtPriceElement) {
      if (showCompare) {
        compareAtPriceElement.innerHTML = Shopify.formatMoney(cp, window.theme.moneyFormat);
        compareAtPriceElement.setAttribute('data-price', cp);
        compareAtPriceElement.style.display = 'block';

        if (regularPriceElement) {
          regularPriceElement.style.color = 'var(--alert_error)';
        }
      } else {
        compareAtPriceElement.innerText = '';
        compareAtPriceElement.removeAttribute('data-price');
        compareAtPriceElement.style.display = 'none';

        if (regularPriceElement) {
          regularPriceElement.style.removeProperty('color');
        }
      }
    } else {
      const compareAtPriceEl = this.element.querySelector(".product-info__price--compare");
      if (compareAtPriceEl) {
        if (showCompare) {
          compareAtPriceEl.textContent = Shopify.formatMoney(cp, window.theme.moneyFormat);
          compareAtPriceEl.setAttribute('data-price', cp);
          compareAtPriceEl.style.display = 'block';

          if (regularPriceElement) {
            regularPriceElement.style.color = 'var(--alert_error)';
          }
        } else {
          compareAtPriceEl.textContent = '';
          compareAtPriceEl.removeAttribute('data-price');
          compareAtPriceEl.style.display = 'none';

          if (regularPriceElement) {
            regularPriceElement.style.removeProperty('color');
          }
        }
      }
    }
  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(".product-info__price--lowest span");
    const lowestPriceDiv = document.querySelectorAll(".product-info__price--lowest");

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(lowestPrice * 100, window.theme.moneyFormat);
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = "flex";
        });

        if (lowestPrice == 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        this.toggleAddButton();
      });
  }

  toggleAddButton() {
    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });

    const addButton = document.querySelectorAll(".product__atc-button");
    if (!addButton) return;

    const isPreorder = String(this.dataset.preorder).toLowerCase() === "true";

    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });
    } else {
      addButton.forEach((button) => {
        button.dataset.action = "add-to-cart";
        if (button.classList.contains("product-module__product-atc--sticky")) {
          button.dataset.action = "click-atc";
        }

        button.classList.remove("hideBtn");

        const addToCartTxt = button.querySelectorAll(
          ".product__atc-button .ButtonText:not(.button-total-price)"
        );
        addToCartTxt.forEach((txt) => {
          txt.textContent = isPreorder
            ? window.variantStrings.preOrder
            : window.variantStrings.addToCart;
        });
      });
    }

    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "flex"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // --- NEW: ažuriranje teksta u .variant_selected-* spanovima ---
  updateSelectedVariantLabels() {
    const groups = this.element.querySelectorAll('.VariantSelect');
    groups.forEach(group => {
      const span = group.querySelector('label [class^="variant_selected-"]');
      if (!span) return;

      const checkedRadio = group.querySelector('input[type="radio"]:checked');
      const selectEl = group.querySelector('select');
      let valueText = '';

      if (checkedRadio) {
        valueText = checkedRadio.value || '';
      } else if (selectEl) {
        valueText = selectEl.selectedOptions?.[0]?.text || selectEl.value || '';
      }

      if (valueText) {
        span.textContent = valueText;
      }
    });
  }
}
customElements.define("variant-selects", VariantSelects);

class AccessoryProductQuantity extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.input = this.element.querySelector(".quantity-input");
    this.decreaseBtn = this.element.querySelector(".quantity-btn.decrease");
    this.increaseBtn = this.element.querySelector(".quantity-btn.increase");
    this.priceElement = this.element.querySelector(".pdp-accessory-product-card--price");

    this.initPriceSync();
    this.initAccessoryStateSync();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.quantity-btn.increase', this.onIncreaseClick.bind(this));
    this.delegateElement.on('click', '.quantity-btn.decrease', this.onDecreaseClick.bind(this));
    this.delegateElement.on('change', '.pdp-accessory-product-card__checkbox', this.updateAccessoryState.bind(this));
    this.delegateElement.on('input', '.quantity-input', this.updateAccessoryState.bind(this));
  }

  initPriceSync() {
    if (!this.input || !this.priceElement || !this.increaseBtn || !this.decreaseBtn) return;

    const base = parseFloat(this.priceElement.dataset.basePrice);
    if (isNaN(base)) return;
    this.basePrice = base;

    this.updatePrice();
  }

  initAccessoryStateSync() {
    const checkbox = this.closest('.pdp-accessory-product-card')?.querySelector('.pdp-accessory-product-card__checkbox');
    const rightElement = this.element.querySelector('.pdp-accessory-product-card--right');
    const quantityInput = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-input');
    const decreaseButton = this.closest('.pdp-accessory-product-card')?.querySelector('.quantity-btn.decrease');

    if (checkbox && rightElement && quantityInput && decreaseButton) {
      const updateState = () => {
        rightElement.classList.toggle('pdp_accessory-disabled', !checkbox.checked);

        (checkbox.checked && parseInt(quantityInput.value, 10) === 1)
          ? decreaseButton.classList.add('decrease--disabled')
          : decreaseButton.classList.remove('decrease--disabled');
      };

      this.updateAccessoryState = updateState;
      updateState();
    }
  }

  onIncreaseClick(event) {
    let value = Number(this.input.value);
    const max = parseInt(this.input.max);

    if (value < max) {
      this.input.value = value + 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  onDecreaseClick(event) {
    let value = Number(this.input.value);
    const min = parseInt(this.input.min);

    if (value > min) {
      this.input.value = value - 1;
      this.updatePrice();
      this.triggerQuantityInputEvent();
    }
  }

  updatePrice() {
    const min = parseInt(this.input.min);
    const max = parseInt(this.input.max);
    let quantity = Math.min(Math.max(parseInt(this.input.value) || 0, min), max);
    this.input.value = quantity;

    const total = this.basePrice * quantity;
    this.priceElement.textContent = `+ ${Shopify.formatMoney(total, window.theme.moneyFormat)}`;

    this.dispatchEvent(new CustomEvent("quantity:changed", { bubbles: true }));
  }

  triggerQuantityInputEvent() {
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('accessory-product-quantity', AccessoryProductQuantity);

class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "submit",
      '.notify-me__popup-inputs',
      this.submitNotifyMe.bind(this));

  }

  submitNotifyMe(e) {
    e.preventDefault();
    const emailInput = this.element.querySelector('.notify-me__input');
    const emailTxt = emailInput.value.trim();
    const alertErr = this.element.querySelector('.notify-me__popup-content .AlertError');

    //validation for email
    if (emailTxt === "" || !emailTxt.includes("@")) {
      // Invalid email format
      alertErr.style.display = "block";
      setTimeout(() => {
        alertErr.style.display = "none";
      }, 3000);

      return;
    } else {
      alertErr.style.display = "none";
    }

    //Send request to API
    this.handleKlaviyoAPI(emailTxt);
  }

  async handleKlaviyoAPI(myEmail) {
    let elementWithId = this.element.querySelector('.notify-me__popup-wrapper');

    if (elementWithId) {

      let variantID = elementWithId.getAttribute('variant-value');

      //Klaviyo API data
      const data = {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: myEmail
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantID}`
            }
          }
        }
      };


      const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.key}`;

      const shopifyResponse = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
          "revision": "2024-06-15"
        },
        body: JSON.stringify({ data }),
      });

      if (!shopifyResponse.ok) {
        throw new Error(`Failed to capture email on Shopify: ${shopifyResponse.statusText}`);
      }
      // Handle success on Shopify (e.g., show a success message to the user)
      elementWithId.setAttribute('notify-me-success', 'true');
      elementWithId.querySelector('.notify-me__popup-content').style.display = "none";
      elementWithId.querySelector('.notify-me__heading').style.display = "none";

      setTimeout(() => {
        elementWithId.querySelector('.notify-me__heading--success').style.display = "flex";
        elementWithId.querySelector('.notify-me__success-msg').style.display = "flex";
      }, 500);

      
    } else {
      return;
    }

  }

}
customElements.define("notify-me-popup", NotifyMePopup);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.filterSearchBars = this.element.querySelectorAll('.collection__grid-header');
    this.openProductBtn = this.element.querySelector('#productBtn');
    this.openArticleBtn = this.element.querySelector('#articleBtn');
    this.toggleButtons = this.element.querySelector('.main-search__buttons-wrapper');

    // Prevent-blink state
    this.hasDefinitiveCounts = false;                 // flips true after async count fetch finishes (or times out)
    this.lastCounts = { products: null, articles: null }; // caches fetched counts

    if (this.element && this.delegateElement) {
      new AddToCart(this.element);
      this.handleTypeRedirect();
      this.bindEvents();
    }
  }

  handleTypeRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentType = urlParams.get('type');
    const query = urlParams.get('q');

    if (query && !currentType) {
      const totalProducts = parseInt(this.element.dataset.totalProducts) || 0;
      const totalArticles = parseInt(this.element.dataset.totalArticles) || 0;

      const targetType = totalProducts > 0 ? 'product' : 'article';

      urlParams.set('type', targetType);
      urlParams.set('page', '1');
      if (!urlParams.has('options[prefix]')) {
        urlParams.set('options[prefix]', 'last');
      }

      const newUrl = window.location.pathname + '?' + urlParams.toString();
      window.location.replace(newUrl);
    }
  }

  bindEvents() {
    window.addEventListener("load", this.handleMainSearchWithPagination.bind(this));
  }

  async handleMainSearchWithPagination() {
    const params = new URLSearchParams(window.location.search);
    const currentType = params.get('type');
    const page = parseInt(params.get('page')) || 1;

    this.articlePagination = this.element.querySelector('.pagination-container--article');
    this.productPagination = this.element.querySelector('.pagination-container--product');

    try {
      if (currentType === 'article') {
        this.articlePage = page;
        this.productPage = 1;
        await this.fetchProductsOnly(false);
        this.openArticleBtn?.classList.add('active');
        this.openProductBtn?.classList.remove('active');
      } else if (currentType === 'product') {
        this.productPage = page;
        this.articlePage = 1;
        await this.fetchArticlesOnly(false);
        this.openProductBtn?.classList.add('active');
        this.openArticleBtn?.classList.remove('active');
      } else {
        this.productPage = page;
        this.articlePage = page;
        await Promise.all([
          this.fetchArticlesOnly(true),
          this.fetchProductsOnly(true)
        ]);
        this.openProductBtn?.classList.add('active');
        this.openArticleBtn?.classList.remove('active');
      }

      this.delegateElement.on("click", '[data-action="toggle-products"]', this.showProducts.bind(this));
      this.delegateElement.on("click", '[data-action="toggle-articles"]', this.showArticles.bind(this));

      // Instant text updates (no visibility toggling yet)
      this.updateButtonCountsInstant();

      // Set initial header visibility based on current type
      this.updateHeaderVisibility();

      if (this.element) this.element.style.opacity = '1';
    } catch (error) {
      this.hideButtonLoaders();
      if (this.element) this.element.style.opacity = '1';
    }
  }

  updateButtonCountsInstant() {
    const initialProductCount = parseInt(this.element.dataset.totalProducts) || 0;
    const initialArticleCount = parseInt(this.element.dataset.totalArticles) || 0;

    // Update labels only (don’t hide/show yet to avoid blink)
    this.updateButtonText(initialProductCount, initialArticleCount, /* definitive */ false);

    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');

    if (query) {
      this.showButtonLoaders();
      this.updateButtonCountsWithTimeout();
    } else {
      this.hideButtonLoaders();
    }
  }

  showButtonLoaders() {
    this.toggleButtonLoaders(true);
  }
  hideButtonLoaders() {
    this.toggleButtonLoaders(false);
  }
  toggleButtonLoaders(show) {
    const loaders = this.element.querySelectorAll('#productBtn .itemLoader, #articleBtn .itemLoader');
    loaders.forEach(loader => loader.classList.toggle('is-visible', show));
  }

  async updateButtonCountsWithTimeout() {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    if (!query) {
      this.hideButtonLoaders();
      return;
    }

    try {
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout')), 1000)
      );
      const fetchPromise = this.updateButtonCounts();
      await Promise.race([fetchPromise, timeoutPromise]);
    } catch (error) {
      // Count update error or timeout
    } finally {
      // From here on, treat counts as definitive to avoid later flicker
      this.hasDefinitiveCounts = true;
      this.hideButtonLoaders();

      const p = this.lastCounts.products ?? (parseInt(this.element.dataset.totalProducts) || 0);
      const a = this.lastCounts.articles ?? (parseInt(this.element.dataset.totalArticles) || 0);
      this.updateButtonText(p, a, /* definitive */ true);
    }
  }

  async updateButtonCounts() {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    if (!query) return;

    try {
      const results = await Promise.allSettled([
        this.fetchSearchCountFast(query, 'product'),
        this.fetchSearchCountFast(query, 'article')
      ]);

      const productCount = results[0].status === 'fulfilled' ? results[0].value : 0;
      const articleCount = results[1].status === 'fulfilled' ? results[1].value : 0;

      // Store fetched counts; visibility handled by caller
      this.lastCounts = { products: productCount, articles: articleCount };
    } catch (error) {
      // Error updating button counts
    }
  }

  updateButtonText(productCount, articleCount, definitive = false) {
    const productBtn = this.element.querySelector('#productBtn');
    const articleBtn = this.element.querySelector('#articleBtn');
    const toggleWrapper = this.element.querySelector('.main-search__toggle-buttons');
    const filterBar = this.element.querySelector('.filters-bar__number-of-products');

    // Update labels only
    if (productBtn) this.updateButtonLabel(productBtn, productCount);
    if (articleBtn) this.updateButtonLabel(articleBtn, articleCount);

    // Only once counts are definitive do we toggle visibility (prevents blink)
    if (definitive) {
      if (productBtn) productBtn.style.display = productCount > 0 ? '' : 'none';
      if (articleBtn) articleBtn.style.display = articleCount > 0 ? '' : 'none';

      if (toggleWrapper) {
        toggleWrapper.style.display = (productCount === 0 && articleCount === 0) ? 'none' : '';
      }
    }

    if (filterBar) {
      // Keep “Products” label consistent with your locale if needed
      filterBar.innerHTML = `${productCount} Products`;
    }

    this.updateHeaderVisibility();
    if (this.toggleButtons) this.toggleButtons.style.opacity = '1';
  }

  updateButtonLabel(button, count) {
    const textEl = button.querySelector('.ButtonText');
    if (!textEl) return;

    // replace an existing "(number)" or append if missing
    if (/\(\d+\)/.test(textEl.textContent)) {
      textEl.textContent = textEl.textContent.replace(/\(\d+\)/, `(${count})`);
    } else {
      textEl.textContent = `${textEl.textContent.trim()} (${count})`;
    }
  }

  updateHeaderVisibility() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentType = urlParams.get('type') || 'product';
    const gridHeader = this.element.querySelector('.collection__grid-header');

    if (!gridHeader) return;
    gridHeader.style.display = currentType === 'product' ? '' : 'none';
  }

  async fetchSearchCountFast(query, type) {
    try {
      const searchUrl = `${window.location.pathname}?q=${encodeURIComponent(query)}&type=${type}&page=1`;
      const response = await fetch(searchUrl, {
        method: 'GET',
        cache: 'no-cache',
        priority: 'high'
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();

      // Fast regex read of data attributes
      const dataAttrPattern = type === 'product'
        ? /data-total-products="(\d+)"/
        : /data-total-articles="(\d+)"/;

      const match = html.match(dataAttrPattern);
      if (match && match[1]) return parseInt(match[1]);

      // Fallback: DOM parse
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const searchComponent = doc.querySelector('search-component');
      if (searchComponent) {
        if (type === 'product') {
          const v = searchComponent.dataset.totalProducts;
          if (v) return parseInt(v);
        } else {
          const v = searchComponent.dataset.totalArticles;
          if (v) return parseInt(v);
        }
      }

      return 0;
    } catch (error) {
      return 0;
    }
  }

  async fetchArticlesOnly(initial) {
    const url = new URL(window.location.href);
    url.searchParams.set('type', 'article');
    url.searchParams.set('page', '1');

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const container = this.element.querySelector('.Search--Result.Article--Result');
      const results = doc.querySelector('.Search--Result.Article--Result');
      const oldPagination = document.querySelector('.true-pagination');
      this.articlePagination = doc.querySelector('.pagination-container--article');

      if (container && results) {
        if (!container.querySelector('.mainSearch--contentCard')) {
          container.innerHTML = results.innerHTML;
        } else if (oldPagination && this.articlePagination && initial) {
          oldPagination.innerHTML = this.articlePagination.outerHTML;
        }
      }

      this.updateResultNumber(doc, true);
      this.updateHeaderVisibility();
    } catch (error) {
      // Error fetching articles
    }
  }

  async fetchProductsOnly(initial) {
    const url = new URL(window.location.href);
    url.searchParams.set('type', 'product');
    url.searchParams.set('page', '1');

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newFilterBarWrapper = doc.querySelector(".collection__grid-header");
      const newResults = doc.querySelector('#mainCollectionHolder');
      const newProductPagination = doc.querySelector('.pagination-container--product');

      const container = this.element.querySelector('#mainCollectionHolder');
      const oldPagination = document.querySelector('.true-pagination');
      this.productPagination = newProductPagination;

      if (newFilterBarWrapper) {
        const currentFilterBarWrapper = this.element.querySelector(".filter-bar--wrapper");
        if (currentFilterBarWrapper) {
          currentFilterBarWrapper.innerHTML = newFilterBarWrapper.innerHTML;
        }
      }

      if (container && newResults) {
        if (!container.querySelector('.main-search__product')) {
          container.innerHTML = newResults.innerHTML;
        }
      }

      if (oldPagination && newProductPagination && initial) {
        oldPagination.innerHTML = newProductPagination.outerHTML;
      }

      this.updateResultNumber(doc, false);
      this.updateHeaderVisibility();
    } catch (error) {
      // Error fetching products
    }
  }

  updateResultNumber(_doc, _article) {
    // counts handled centrally via updateButtonText; keep opacity consistent
    if (this.toggleButtons) this.toggleButtons.style.opacity = '1';
  }

  showProducts(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set('type', 'product');
    url.searchParams.set('page', this.productPage || 1);
    window.location.href = url.toString();
  }

  showArticles(e) {
    e.preventDefault();
    const url = new URL(window.location.href);

    // Remove any active product filters when switching to articles
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    });

    url.searchParams.set('type', 'article');
    url.searchParams.set('page', this.articlePage || 1);
    window.location.href = url.toString();
  }
}

customElements.define("search-component", Search);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.isOpen = false;
    this.searchResultsElement = this.element.querySelector(".search-bar__results-wrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".search-bar__clear");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    this.headerTransparent = false;

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      var carousel = this.searchResultsElement.querySelector("[data-swiper-settings]");
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;
    var timer = null;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  // Safe scroll lock wrappers
  enableScroll(el) {
    if (typeof bodyScrollLock !== 'undefined' && el) {
      bodyScrollLock.enableBodyScroll(el, bodyScrollLockOptions);
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  disableScroll(el) {
    if (typeof bodyScrollLock !== 'undefined' && el) {
      bodyScrollLock.disableBodyScroll(el, bodyScrollLockOptions);
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

  mountSearch() {
    if (!this.element.classList.contains('is-mounted')) {
      this.element.classList.add('is-mounted');
      this.element.style.display = "block";
      void this.element.offsetWidth;
    }
  }

  unmountSearch() {
    this.element.classList.remove('is-mounted');
    this.element.style.display = "none";
  }

  openSearch(event) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    if (!this.element) return;

    this.mountSearch();

    // GTM tracking for search icon click
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: 'search',
        action: 'open_search_bar'
      });
      console.log("dataLayer push -> search");
    }

    requestAnimationFrame(() => {
      this.element.setAttribute("aria-hidden", "false");
      this.element.classList.add("is-visible");

      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.pageOverlayElement.classList.add("overlay-over-header");
      }

      // Dispatch custom event for HeaderTransparencyController
      document.body.dispatchEvent(new CustomEvent("search:open", { bubbles: true }));

      const search = document.querySelector("#quickSearch");
      if (search) {
        search.setAttribute("aria-hidden", "false");
      }

      this.pageOverlayElement.classList.add("is-visible");

      // Apply scroll lock
      const scrollableEl = this.element.querySelector("[data-scrollable]");
      if (scrollableEl) {
        this.disableScroll(scrollableEl);

        requestAnimationFrame(() => {
          const paddingValue = document.body.style.paddingRight || '0px';
          document.documentElement.style.setProperty('--body-padding-right', paddingValue);
        });
      }

      setTimeout(() => {
        this.searchInputElement?.focus();
      }, 120);

      this.isOpen = true;

      if (this.pageOverlayElement) {
        this.closeListener = this.closeSearch.bind(this);
        this.pageOverlayElement.addEventListener("click", this.closeListener);
      }
    });
  }

  closeSearch(event) {
    if (event) event.preventDefault();
    if (!this.isOpen) return;

    // Set false immediately to prevent re-entry
    this.isOpen = false;

    this.enableScroll(this.element.querySelector("[data-scrollable]"));
    document.documentElement.style.setProperty('--body-padding-right', '0px');

    if (this.pageOverlayElement && this.closeListener) {
      this.pageOverlayElement.removeEventListener("click", this.closeListener);
      this.closeListener = null;
    }

    const cleanup = () => {
      this.element.setAttribute("aria-hidden", "true");
      this.unmountSearch();
      this.resetSearch();
      document.body.dispatchEvent(new CustomEvent("search:closed", { bubbles: true }));
    };

    this.element.classList.remove("is-visible");
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.classList.remove("overlay-over-header");

    // Check if there's actually a CSS transition to wait for
    const style = window.getComputedStyle(this.element);
    const duration = parseFloat(style.transitionDuration) || 0;

    if (duration > 0) {
      let fired = false;
      const onEnd = () => {
        if (fired) return;
        fired = true;
        this.element.removeEventListener("transitionend", onEnd);
        clearTimeout(fallback);
        cleanup();
      };
      // Fallback in case transitionend never fires
      const fallback = setTimeout(onEnd, (duration * 1000) + 100);
      this.element.addEventListener("transitionend", onEnd);
    } else {
      // No transition — close immediately
      cleanup();
    }
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search-bar__results-wrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");

    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".search-bar__input");
      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });

      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(".predictive-search__queries");
      const currentRecentQueris = this.element.querySelector("#predictive-search--recent-searches");

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      if (suggestedQueries) {
        if (currentRecentQueris) currentRecentQueris.remove();
        if (currentSuggestedQueries) currentSuggestedQueries.remove();

        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) return; // aborted
      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    const currentSuggestedQueries = this.element.querySelector(".predictive-search__queries");
    if (currentSuggestedQueries) currentSuggestedQueries.remove();

    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }
      try {
        localStorage.setItem("searchTerms", JSON.stringify(searchTerm.slice(0, 10)));
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search-bar__recent-results");
    if (items.length > 0 && elementToAdd) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });
      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector("#predictive-search--recent-searches")?.style && (this.querySelector("#predictive-search--recent-searches").style.display = "none");
    }
  }
}

customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) {
      // Use GlobalScrollListener for better performance
      if (window.scrollListener) {
        this.scrollListenerRemover = window.scrollListener.addScrollListener(this, this.stickyLinksTopPadding);
      } else {
        document.addEventListener("scroll", this.stickyLinksTopPadding);
      }
    }
  }

  disconnectedCallback() {
    // Clean up GlobalScrollListener
    if (this.scrollListenerRemover) {
      this.scrollListenerRemover.removeScrollListener();
    }
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll(".RevolutionSelectbox").forEach((box) => new RevolutionSelectbox(box));
  }
}
customElements.define("localization-modal", LocalizationModal);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));

  }

    accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  toggleRecovery(event) {
  event.preventDefault();

  const id = event.target.dataset.id;

    const titleParent = event.target.closest('[data-title]');
    const newTitle = titleParent ? titleParent.dataset.title : '';
    this.setDrawerTitle(newTitle);


  // Toggle visibility between login and recovery forms
  if (id === 'recover') {
    this.element.querySelector('#recover').setAttribute('aria-visible', 'true');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
  } else {
    this.element.querySelector('#recover').setAttribute('aria-visible', 'false');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
  }
}





  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    // Find the recovery button from the form container instead of event target
    const recoveryButton = this.element.querySelector('[data-action="submit-recovery"]');
    const buttonText = recoveryButton ? recoveryButton.querySelector(".ButtonText") : null;
    const loader = recoveryButton ? recoveryButton.querySelector(".itemLoader") : null;

    if (buttonText) buttonText.style.visibility = "hidden";
    if (loader) loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      const recoverError = this.element.querySelector("#recover .accountDrawer--ErrorSpace");
      const recoverSuccess = this.element.querySelector("#recover .accountDrawer--SuccessSpace");
      if (responseText.includes("account__recover-email-error")) {
        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {
        recoverError.classList.remove("is-visible");

        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      if (buttonText) buttonText.style.visibility = "visible";
      if (loader) loader.classList.remove("is-visible");
    } catch (error) {
      // Error during recovery request
    }
  }




  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
      const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");
      const generalError = this.element.querySelector('#register .drawer__errors');

   


      if (responseText.indexOf("registerErrors") !== -1) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        const emailErrorElement = tempDiv.querySelector("#RegisterForm-email-error");
        const emailInput = this.element.querySelector("#RegisterForm-email");
        const emailField = emailInput.closest(".field");

        if (emailErrorElement) {

          registerEmailError.setAttribute("aria-hidden", "false");
          registerEmailError.innerHTML = "";

          // Decode HTML entities before setting innerHTML
          const htmlContent = emailErrorElement.innerHTML;
          const decodedContent = this.decodeHtmlEntities(htmlContent);
          registerEmailError.innerHTML = decodedContent;
          
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "true");

           emailField.classList.add("input--error");
    
        } else {
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
          registerEmailError.setAttribute("aria-hidden", "true");

          emailField.classList.remove("input--error");
        }

        const passwordErrorElement = tempDiv.querySelector("#RegisterForm-password-error");
        const passwordInput = this.element.querySelector("#RegisterForm-password");
        const passwordField = passwordInput.closest(".field");
        if (passwordErrorElement) {
          registerPasswordError.setAttribute("aria-hidden", "false");
          registerPasswordError.style.display = "block";
          registerPasswordError.innerHTML = "";
          registerPasswordError.innerHTML = tempDiv.querySelector("#RegisterForm-password-error").innerHTML;
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "true");

          passwordField.classList.add("input--error");
        } else {
          registerPasswordError.setAttribute("aria-hidden", "true");
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
           passwordField.classList.remove("input--error");
        }

        const generalErrorNew = tempDiv.querySelector("#account__register-email-error");
        if (generalErrorNew) {

          generalError.setAttribute("aria-hidden", "false");
          generalError.style.display = "block";
          generalError.innerHTML = "";
          generalError.innerHTML = generalErrorNew.innerHTML;
        }

      } else {
        registerPasswordError.setAttribute("aria-hidden", "true");
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        registerEmailError.setAttribute("aria-hidden", "true");
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");

    } catch (error) {
      // Error during registration request
    }
  }





  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    // Find the login button from the form container instead of event target
    const loginButton = this.element.querySelector('[data-action="submit-login"]');
    const buttonText = loginButton ? loginButton.querySelector(".ButtonText") : null;
    const loader = loginButton ? loginButton.querySelector(".itemLoader") : null;

    if (buttonText) buttonText.style.visibility = "hidden";
    if (loader) loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
      
          const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
          loginError.innerHTML = "";
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;
          loginError.innerHTML =
            tempDiv.querySelector(".AlertError").innerHTML;
          loginError.classList.add("is-visible");

          // find the closest wrapper with class "field"
          const fieldErr = loginError.closest('.field');
          if (fieldErr) {
            fieldErr.classList.add('input--error');
          }
      } else {
        location.href = window.routes.account_url;
      }

      if (buttonText) buttonText.style.visibility = "visible";
      if (loader) loader.classList.remove("is-visible");
    } catch (error) {
      // Error during login request
    }
  }
// 🆕 Reusable drawer title setter
  setDrawerTitle(title) {
    const titleElement = this.element.querySelector('.acc-drawer__title');
    if (titleElement && title) {
      titleElement.textContent = title;
    }
  }

  // Helper method to decode HTML entities
  decodeHtmlEntities(text) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const titleToSet = event.target.dataset.title;

    this.setDrawerTitle(titleToSet);

    const allTabs = this.element.querySelectorAll('.acc-drawer__tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');
  
  

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');    
    this.element.dispatchEvent(new CustomEvent("desktop-menus:close", { bubbles: true }));

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
     
      }
  }

}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
      new Popup(this.element, true);
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute("data-swiper-dynamic");
    this.isDynamicOnce = this.element.hasAttribute("data-swiper-dynamic-once");
    this.isHorizontalFadeDesktop = this.element.hasAttribute(
      "data-swiper-fade-horizontal-desktop"
    );
    this.isHorizontalFadeMobile = this.element.hasAttribute(
      "data-swiper-fade-horizontal-mobile"
    );
    this.isHorizontalFade = this.element.hasAttribute(
      "data-swiper-fade-horizontal"
    );
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute("data-swiper-mobile")) {
      return "mobile";
    } else if (this.element.hasAttribute("data-swiper-desktop")) {
      return "desktop";
    } else if (this.element.hasAttribute("data-swiper-tablet")) {
      return "tablet";
    } else {
      return "universal";
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener(
      "breakpoint:changed",
      this.handleBreakpointChange
    );

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute("data-swiper-manual")) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener(
      "breakpoint:changed",
      this.handleBreakpointChange
    );
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold =
      parseFloat(this.element.getAttribute("data-swiper-dynamic-threshold")) ||
      0.1;

    // Get root margin from attribute or use default
    const rootMargin =
      this.element.getAttribute("data-swiper-dynamic-margin") || "50px";

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      {
        threshold: threshold,
        rootMargin: rootMargin,
      }
    );

    this.intersectionObserver.observe(this.element);
  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    // Add "content-fade" class here
    this.element.classList.add("content-fade");
    const fadeContainer = this.element;

    const update = () =>
      this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on("slideChange", update);
    swiperInstance.on("resize", update);
    swiperInstance.on("progress", update);
    swiperInstance.on("touchMove", update);

    window.addEventListener("resize", update);
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove("fade-left", "fade-right", "fade-both-horizontal");

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add("fade-both-horizontal");
    } else if (!atStart) {
      c.add("fade-left");
    } else if (!atEnd) {
      c.add("fade-right");
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case "mobile":
        return ["phone", "pocket"].includes(currentBreakpoint);
      case "desktop":
        return ["desktop", "lap_and_up", "desktop_wide"].includes(
          currentBreakpoint
        );
      case "tablet":
        return ["tablet", "tablet_and_up"].includes(currentBreakpoint);
      case "universal":
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute("data-swiper-thumb");
      const thumbElement = thumbSelector
        ? document.querySelector(thumbSelector)
        : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (
        this.isHorizontalFadeDesktop &&
        responsive.matchesBreakpoint("lap_and_up")
      ) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (
        this.isHorizontalFadeMobile &&
        (currentBreakpoint === "phone" || currentBreakpoint === "pocket")
      ) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(
        new CustomEvent("swiper:initialized", {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce,
            swiper: this.swiper,
          },
        })
      );

    
    } catch (error) {
      // Failed to initialize swiper
    }
  }

  destroy() {
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(
        new CustomEvent("swiper:destroyed", {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce,
          },
        })
      );
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener(
        "swiper:initialized",
        () => {
          if (this.swiper && this.swiper.selectCell) {
            this.swiper.selectCell(index);
          }
        },
        { once: true }
      );
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return "dynamic";
    if (this.isDynamicOnce) return "dynamic-once";
    return "static";
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll("swiper-init").forEach((element) => {
      element.initSwiper();
    });
  }
}
customElements.define("swiper-init", SwiperInit);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.announcementBar = document.querySelector('.announcement-bar');

    // Cache the bar height to avoid recalculations on scroll
    this.cachedHeight = null;
    
    this.updateVisibleHeight();
    this.transitionSpeed = this.element.getAttribute('data-settings');
    this.animWrapper = this.element.querySelector(
      '.announcement-bar__anim-wrapper'
    );
    this.original = this.element.querySelector(
      '.announcement-bar__duplicate-wrapper'
    );

    let children = Array.from(this.original.children);

    children = children.filter(
      (child, index, self) =>
        index ===
        self.findIndex((c) => c.textContent.trim() === child.textContent.trim())
    );

    this.original.innerHTML = '';
    children.forEach((child) =>
      this.original.appendChild(child.cloneNode(true))
    );

    this.firstLoad = true;

    // Simple scroll-based class toggle
    this.lastScrollY = window.scrollY;
    this.scrollThreshold = 10; // Minimum scroll distance to trigger class change
    
    // Initialize state tracking (will be properly set in _initScrollListener and _checkInitialScrollState)
    this.desiredState = 'visible';
    this.currentState = 'visible';
    
    // Cooldown to prevent rapid state changes (prevents flickering)
    this.lastStateChangeTime = 0;
    this.stateChangeCooldown = 300; // Minimum time between state changes in ms
    
    // Header element for adding scrolled class
    this.header = document.querySelector('#header');
    
    this._observeIntersection();
    this.bindEvents();
    this._initScrollListener();
    this._bindTransitionEvents();
  }

  _observeIntersection() {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Ne ažuriramo CSS varijablu ovde jer se kontroliše u scroll handler-u
          // ovo je samo za praćenje preseka announcement bar-a sa viewport-om
        });
      },
      {
        root: null,
        threshold: Array.from({ length: 51 }, (_, i) => i / 50),
      }
    );
    this.intersectionObserver.observe(this);
  }

  connectedCallback() {
    // Cache the height once on initialization
    this.cachedHeight = this.element.clientHeight;
    
    // Set initial announcement-height-fixed based on visibility
    const isHidden = this.element.classList.contains('ann-bar-hidden') || 
                     this.element.classList.contains('ann-bar-scrolled');
    if (isHidden) {
      document.documentElement.style.setProperty('--announcement-height-fixed', '0px');
      if (this.header) this.header.classList.remove('ann-bar--visible');
    } else {
      document.documentElement.style.setProperty('--announcement-height-fixed', this.cachedHeight + 'px');
      if (this.header) this.header.classList.add('ann-bar--visible');
    }
    
    this.heightUpdatePending = false; // Flag to prevent rapid height updates
    this.updateVisibleHeight();
    
    // Check initial scroll position and apply header--scrolled if needed
    // This runs in connectedCallback to ensure header element exists in DOM
    this._checkInitialScrollState();

    const target = this.element;
 
if (target) {
  // Watch for attribute changes like class or style
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        // Class changed, monitoring for future use if needed
      }
    });
  });

  observer.observe(target, {
    attributes: true, // watch for attribute changes
    attributeFilter: ["class", "style"] // only care about class or style
  });

  // Also listen directly for when transitions actually start
 
}

  }

  _initScrollListener() {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this._handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Use GlobalScrollListener for better performance
    if (window.scrollListener) {
      this.scrollListenerRemover = window.scrollListener.addScrollListener(this, handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }
  }

  _handleScroll() {
    const currentScrollY = window.scrollY;
    const scrollDifference = currentScrollY - this.lastScrollY;

    // Only react to significant scroll movements
    if (Math.abs(scrollDifference) < this.scrollThreshold) {
      return;
    }
    
    // Check if we're near the bottom of the page with a larger buffer to prevent flicker
    // Account for the announcement bar height in the calculation
    const bottomBuffer = 200 + (this.cachedHeight || 0);
    const isNearBottom = (window.innerHeight + currentScrollY) >= (document.documentElement.scrollHeight - bottomBuffer);
    
    // Don't trigger ANY animations when near bottom to prevent bouncing/flickering
    if (isNearBottom) {
      // Keep the current state, don't change anything
      return;
    }

    // Determine the desired state based on scroll position
    let newDesiredState;
    if (currentScrollY <= 30) {
      newDesiredState = 'visible';
    } else if (scrollDifference > 0) {
      newDesiredState = 'hidden';
    } else if (scrollDifference < 0) {
      newDesiredState = 'visible';
    }

    // Only apply transition if the desired state has changed
    if (newDesiredState && newDesiredState !== this.desiredState) {
      // Check if enough time has passed since the last state change
      const now = Date.now();
      if (now - this.lastStateChangeTime >= this.stateChangeCooldown) {
        this.desiredState = newDesiredState;
        this.lastStateChangeTime = now;
        this._applyState(newDesiredState);
      }
    }

    this.lastScrollY = currentScrollY;
  }

  _applyState(targetState) {
    // Apply the desired state immediately
    if (targetState === 'visible') {
      // Show the announcement bar
      if (!this.heightUpdatePending && this.element.classList.contains('ann-bar-scrolled')) {
        this.heightUpdatePending = true;
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--announcement-dynamic-height', `${this.cachedHeight}px`);
          // Set announcement-height-fixed to actual height (header moves down)
          document.documentElement.style.setProperty('--announcement-height-fixed', `${this.cachedHeight}px`);
          // Add class for border-radius styling
          if (this.header) this.header.classList.add('ann-bar--visible');
          setTimeout(() => { this.heightUpdatePending = false; }, 100);
        });
      }
      
      // First remove display none, then animate back
      if (this.element.classList.contains('ann-bar-hidden')) {
        this.element.classList.remove('ann-bar-hidden');
        requestAnimationFrame(() => {
          this.element.classList.remove('ann-bar-scrolled');
        });
      } else {
        this.element.classList.remove('ann-bar-scrolled');
      }
      this.currentState = 'visible';
      
    } else if (targetState === 'hidden') {
      // Hide the announcement bar
      this.element.classList.add('ann-bar-scrolled');
      this.currentState = 'hidden';
      
      // Set announcement-height-fixed to 0 (header moves up to top)
      document.documentElement.style.setProperty('--announcement-height-fixed', '0px');
      // Remove class for border-radius styling
      if (this.header) this.header.classList.remove('ann-bar--visible');
    }
    
    // After transition completes, verify we're in the correct state
    setTimeout(() => {
      this._ensureCorrectState();
    }, 750);
  }

  _ensureCorrectState() {
    // Double-check the state matches what it should be
    // This ensures we don't get stuck in the wrong state
    if (this.desiredState === 'visible' && this.element.classList.contains('ann-bar-scrolled')) {
      // We should be visible but we're hidden - fix it
      this.element.classList.remove('ann-bar-hidden');
      this.element.classList.remove('ann-bar-scrolled');
      if (this.header) {
        this.header.classList.remove('header--scrolled');
      }
    } else if (this.desiredState === 'hidden' && !this.element.classList.contains('ann-bar-scrolled')) {
      // We should be hidden but we're visible - fix it
      this.element.classList.add('ann-bar-scrolled');
    }
  }

  _bindTransitionEvents() {
    this.element.addEventListener('transitionend', (event) => {
      // Only handle transitions on the announcement bar element itself
      if (event.target === this.element) {
        if (this.element.classList.contains('ann-bar-scrolled')) {
          // After hide animation completes, add hidden class for click-through
          this.element.classList.add('ann-bar-hidden');
          // Update height smoothly AFTER the visual transition completes
          // Use a small delay to ensure smooth transition
          setTimeout(() => {
            requestAnimationFrame(() => {
              document.documentElement.style.setProperty('--announcement-dynamic-height', '0px');
              this.heightUpdatePending = false;
            });
          }, 50);
          // Add scrolled class to header
          if (this.header) {
            this.header.classList.add('header--scrolled');
          }
        } else {
          // When showing, update height first, then remove hidden class
          requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--announcement-dynamic-height', `${this.cachedHeight}px`);
            this.heightUpdatePending = false;
          });
          this.element.classList.remove('ann-bar-hidden');
          // Remove scrolled class from header
          if (this.header) {
            this.header.classList.remove('header--scrolled');
          }
        }
      }
    });
  }

  _checkInitialScrollState() {
    // If page is loaded already scrolled down (beyond threshold)
    if (window.scrollY > 30) {
      const applyScrolledState = () => {
        // Re-query header in case it wasn't available earlier (it comes after announcement bar in DOM)
        const header = document.querySelector('#header');
        if (header) {
          // Set the initial desired state to hidden
          this.desiredState = 'hidden';
          this.currentState = 'hidden';
          
          // Add the scrolled classes immediately without animation
          this.element.classList.add('ann-bar-scrolled', 'ann-bar-hidden');
          header.classList.add('header--scrolled');
          // Update both announcement heights to 0 since it's hidden
          document.documentElement.style.setProperty('--announcement-dynamic-height', '0px');
          document.documentElement.style.setProperty('--announcement-height-fixed', '0px');
          // Remove border-radius styling class
          header.classList.remove('ann-bar--visible');
        } else {
          // Header not yet in DOM, try again on next frame
          requestAnimationFrame(applyScrolledState);
        }
      };
      
      // Use requestAnimationFrame to ensure DOM is fully parsed
      requestAnimationFrame(applyScrolledState);
    }
  }

  bindEvents() {
    this.handleBreakpointChange();

    this.element.addEventListener('mouseenter', this.pauseAnimation.bind(this));
    this.element.addEventListener(
      'mouseleave',
      this.resumeAnimation.bind(this)
    );
  }

  pauseAnimation() {
    if (this.animation) {
      this.animation.pause();
    }
  }

  resumeAnimation() {
    if (this.animation) {
      this.animation.play();
    }
  }



  updateVisibleHeight() {
    // Postavlja initial visinu samo ako announcement bar nije sakriven
    if (!this.element.classList.contains('ann-bar-hidden')) {
      const visibleHeight = this.element.clientHeight;
      // Cache the height for reuse
      this.cachedHeight = visibleHeight;
      document.documentElement.style.setProperty(
        '--announcement-dynamic-height',
        `${visibleHeight}px`
      );
    }
  }

  handleBreakpointChange() {
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.mobile = false;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach(
          (block, i) => (block.style.display = 'block')
        );
        this.original.style.justifyContent = 'space-between';
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => {
          if (i != 0) block.style.display = 'none';
        });
        this.original.style.justifyContent = 'center';
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => {
      if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild);
    });
    this.originalNew =
      this.element.offsetWidth -
      parseInt(getComputedStyle(this.element).paddingLeft) * 2;
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    if (this.original != null) {
      const duplicate = this.original.cloneNode(true),
        spaceDiv = document.createElement('div');
      spaceDiv.style.flexShrink = 0;
      if (this.original.children.length == 1) {
        var duplicate2 = duplicate.cloneNode(true);
        var spaceDiv2 = spaceDiv.cloneNode(true);
      }

      var originalWidth = (originalWidth = this.original.offsetWidth);
      if (this.originalNew) originalWidth = this.originalNew;

      if (this.mobile) {
        if (this.original.children.length >= 2) {
          duplicate.style.width =
            originalWidth * this.original.children.length -
            window.innerWidth +
            'px';
          this.original.style.width =
            originalWidth * this.original.children.length -
            window.innerWidth +
            'px';
          this.animWrapper.style.width =
            2 *
              (originalWidth * this.original.children.length -
                window.innerWidth) +
            'px';
        } else {
          duplicate.style.width = 'fit-content';
          if (duplicate2) duplicate2.style.width = 'fit-content';
          this.original.style.width = 'fit-content';
          const originalWidthAfter = this.original.offsetWidth;
          setTimeout(() => {
            this.animWrapper.style.width = 2 * originalWidthAfter + 400 + 'px';
          }, 0);
        }

        if (this.original.children.length >= 2)
          this.spaceDivWidth = this.getDistanceBetweenBlocks(
            this.original.children[0],
            this.original.children[1]
          );
        else this.spaceDivWidth = 200;
      } else {
        if (this.original.children.length >= 2)
          this.spaceDivWidth = this.getDistanceBetweenBlocks(
            this.original.children[0],
            this.original.children[1]
          );
        else this.spaceDivWidth = 0;

        duplicate.style.width = originalWidth + 'px';
        this.original.style.width = originalWidth + 'px';
        this.animWrapper.style.width =
          2 * originalWidth + this.spaceDivWidth + 'px';
      }

      spaceDiv.style.width = this.spaceDivWidth + 'px';
      if (spaceDiv2) {
        spaceDiv2.style.width = this.spaceDivWidth + 'px';
      }

      this.animWrapper.style.position = 'absolute';
      if (this.mobile && this.firstLoad)
        this.animWrapper.style.transform = `translateX(${
          this.spaceDivWidth / 2
        }px)`;

      this.element.style.height = this.animWrapper.offsetHeight + 'px';

      this.animWrapper.appendChild(spaceDiv);
      this.animWrapper.appendChild(duplicate);
      if (this.original.children.length == 1 && this.mobile) {
        this.animWrapper.appendChild(spaceDiv2);
        this.animWrapper.appendChild(duplicate2);
      }

      setTimeout(() => {
        this.startAnimating();
      }, 100);
    }
  }

  startAnimating() {
    var translate = 0;
    this.mobile && this.firstLoad
      ? (translate = this.spaceDivWidth / 2)
      : (translate = 0);
    this.firstLoad = false;

    this.animation = this.animWrapper.animate(
      [
        { transform: `translateX(${translate}px)` },
        { transform: `translateX(calc(-50% - ${this.spaceDivWidth / 2}px))` },
      ],
      {
        duration: parseInt(this.transitionSpeed) * 1000,
        iterations: Infinity,
        fill: 'forwards',
        easing: 'linear',
      }
    );
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return (
      blockTwo.getBoundingClientRect().left -
      blockOne.getBoundingClientRect().right
    );
  }

  disconnectedCallback() {
    // Clean up GlobalScrollListener
    if (this.scrollListenerRemover) {
      this.scrollListenerRemover.removeScrollListener();
    }
    // Clean up intersection observer
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}

customElements.define('announcement-bar', AnimatedAnnouncementBar);



class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.responsive = new Responsive(true, false);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.searchInput = this.element.querySelector(".faq__search-wrapper .faq--search");
    this.termsBlocks = document.querySelectorAll(".faq__block");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.initializeTabs();
  }

  connectedCallback() {
    this.bindEvents();
    if(this.options.openFirstFaq){
    setTimeout(() => {
      this.openFirstDropdown();
    }, 100);
  }
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.delegateElement.on("click", '[data-action=handle-tab-click]', this.handleTabClick.bind(this));
    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);
    this.delegateElement.on("keyup", '[data-action="search-string"]', this.onInputListener);
  }

  openFirstDropdown() {
    const firstFaqDropdown = this.element.querySelector('.faq-terms.Dropdown');
    
    if (firstFaqDropdown) {
      const button = firstFaqDropdown.querySelector('.Dropdown--Button');
      const content = firstFaqDropdown.querySelector('.Dropdown--Content');
      
      if (button && content) {
        button.setAttribute('aria-expanded', 'true');
                
        new RevolutionAnimation(content, "true").slideDown();
      }
    }
  }

  initializeTabs() {
    const firstTab = this.element.querySelector('.linklist--tab');
    const firstBlock = this.element.querySelector('.faq__block');

    if (this.element.querySelector('.faq__block[aria-hidden="true"]') && firstTab && firstBlock) {
      firstBlock.setAttribute('aria-hidden', 'false');
    }

    const parts = window.location.href.split('#');
    const idFromUrl = parts[parts.length - 1];
    if(idFromUrl && /^[A-Za-z0-9-]+$/.test(idFromUrl) && this.element.querySelector(`#${idFromUrl}`)){
      this.setTabAsActive(idFromUrl);
    }else{
    const swiperContainer = this.element.querySelector('.faq__topic-links .swiper');
    const topicsLinksDesk = this.element.querySelector('.faq__topic-links--desktop');

    if(swiperContainer) this.setFirstTabAsActive(swiperContainer);
    if(topicsLinksDesk) this.setFirstTabAsActive(topicsLinksDesk);
  }
  }

  setFirstTabAsActive(container) {
    const tabs = container.querySelectorAll('.linklist--tab');
    const hasActive = Array.from(tabs).some(tab => tab.classList.contains('is-active'));
    if (!hasActive && tabs.length > 0) {
      tabs[0].classList.add('is-active');
    }
  }

  setTabAsActive(id) {
    let found = false;
    const tabs = this.element.querySelectorAll('.linklist--tab');
    tabs.forEach(tab => {
      if(id === this.getTargetIdFromTab(tab)) {
      tab.classList.add('is-active');
      found = true;
    }
    });
    if(found) setTimeout(()=> {this.scrollToSection(this.element.querySelector(`#${id}`));}, 700);
  }

  handleSearch() {
    let searchTerm = this.searchInput.value.toLowerCase().trim();

    const noResultsContainer = this.querySelector(".faq__no-results__terms");
    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const titleElement = block.querySelector('.faq__block-header');
      const title = titleElement ? titleElement.textContent.toLowerCase() : '';
      const questions = block.querySelectorAll(".faq-section_content");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        this.toggleBlockVisibility(block, true);
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent ? questionWrapper.textContent.toLowerCase() : '';
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });

        this.toggleBlockVisibility(block, blockMatch);
      }

      if (blockMatch) hasMatch = true;
    });

    if (searchTerm === "" || !hasMatch) {
      this.resetBlockVisibility();
      this.noResultsElement.setAttribute("aria-hidden", searchTerm === "" || hasMatch ? "true" : "false");
      if (noResultsContainer) noResultsContainer.textContent = `"${searchTerm}"`;
    } else {
      this.noResultsElement.setAttribute("aria-hidden", "true");
    }
  }

  toggleBlockVisibility(block, show) {
      block.classList.toggle("is-hidden", !show);
  }

  resetBlockVisibility() {
    this.termsBlocks.forEach((block) => {
      block.querySelectorAll(".faq-section_content").forEach((content) =>
        content.classList.remove("is-hidden")
      );
    });

      this.termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
      });
  }

  getTargetIdFromTab(target){
    const href = target.getAttribute('href');
    if (!href) return null;
    const parts = href.split('#');
    return parts[parts.length - 1];
  }

  handleTabClick(event, target) {
    event.preventDefault();
    console.log('🖱️ TAB CLICKED');
    this.noResultsElement.setAttribute("aria-hidden", "true");

    const targetId = this.getTargetIdFromTab(target);
    console.log('Target ID:', targetId);
      this.handleRegularTabClick(target, targetId);
  }

  handleRegularTabClick(target, targetId) {
    if (!targetId) {
      console.log('❌ No target ID found');
      return;
    }

    const newUrl = `${window.location.pathname}#${targetId}`;
    history.pushState(null, null, newUrl);

    // Set clicked flag to prevent scroll listener from interfering
    this.element.dataset.clicked = "true";
    console.log('🚫 Scroll listener DISABLED (clicked flag = true)');

    // Remove is-active from all tabs and add only to the clicked tab
    let activatedCount = 0;
    let deactivatedCount = 0;
    this.element.querySelectorAll(".linklist--tab").forEach(tab => {
      if(this.getTargetIdFromTab(tab) == targetId) {
        tab.classList.add("is-active");
        activatedCount++;
        console.log('✅ Activated tab:', this.getTargetIdFromTab(tab));
      }
      else {
        tab.classList.remove("is-active");
        deactivatedCount++;
      }
    });
    console.log(`📊 Tabs activated: ${activatedCount}, deactivated: ${deactivatedCount}`);

    // Escape CSS selector to handle special characters like '/' in targetId
    let targetElement = null;
    try {
      const escapedTargetId = CSS.escape ? CSS.escape(targetId) : targetId.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
      targetElement = this.element.querySelector(`#${escapedTargetId}`);
    } catch (error) {
      // Fallback: try to find element by data attribute or other method
      targetElement = this.element.querySelector(`[data-tab-content="${targetId}"]`);
    }
    
    if (targetElement) {
      console.log('🎯 Scrolling to section:', targetId);
      this.scrollToSection(targetElement);
    } else {
      console.log('⚠️ Target element not found:', targetId);
    }

    // Reset clicked flag after scroll completes (smooth scroll typically takes ~500-800ms)
    setTimeout(() => {
      this.element.dataset.clicked = "false";
      console.log('✅ Scroll listener RE-ENABLED (clicked flag = false)');
    }, 1000);
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    const offset = responsive.currentBreakpoint == 'desktop' ? headerHeight + 40 : headerHeight + 80;
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  handleScroll() {
    if (this.element.dataset.clicked == "true") {
      console.log('⏸️ Scroll handler SKIPPED (clicked flag is true)');
      return;
    }
    console.log('📜 SCROLL HANDLER running...');
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");
    const threshold = 200;

    // First, remove is-active from all tabs to ensure only one is active
    let removedCount = 0;
    this.element.querySelectorAll(".linklist--tab").forEach(tab => {
      if (tab.classList.contains("is-active")) {
        removedCount++;
      }
      tab.classList.remove("is-active");
    });
    console.log(`🧹 Removed is-active from ${removedCount} tabs`);

    let activatedSections = [];
    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(0, faqSubheader.getBoundingClientRect().top);
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        const faqSection = faqSubheader.closest(".faq__block").id;
        activatedSections.push(faqSection);
        const anchorElements = this.element.querySelectorAll(`a[href="#${faqSection}"]`);
        anchorElements.forEach((item) => {
          item.classList.add("is-active");
          console.log(`✅ Scroll activated tab for section: ${faqSection} (distance: ${distanceFromTop}px)`);
        });
      }
    });
    console.log(`📊 Total sections activated by scroll: ${activatedSections.length}`, activatedSections);
  }
}

customElements.define("faq-section", FAQSection);



// Auto-initialize existing elements with animate-on-scroll attribute
class ScrollAnimationController {
  constructor() {
    this.elements = new Map();
    this.init();
  }

  init() {
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeElements());
    } else {
      this.initializeElements();
    }

    // Also initialize any dynamically added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.hasAttribute && node.hasAttribute('animate-on-scroll')) {
              this.initializeElement(node);
            }
            // Check child elements too
            const childElements = node.querySelectorAll ? node.querySelectorAll('[animate-on-scroll]') : [];
            childElements.forEach(el => this.initializeElement(el));
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initializeElements() {
    const elements = document.querySelectorAll('[animate-on-scroll]');
    elements.forEach(el => this.initializeElement(el));
  }

  initializeElement(el) {
    if (this.elements.has(el) || el.hasAttribute('disabled')) return;

    const controller = new ElementScrollAnimation(el);
    this.elements.set(el, controller);
  }
}

class ElementScrollAnimation {
  constructor(element) {
    this.element = element;
    this._raf = null;
    this._inView = false;
    this._listenersBound = false;

    this._queue = this._queue.bind(this);
    this._update = this._update.bind(this);
    this._onIO = this._onIO.bind(this);
    this._requery = this._requery.bind(this);

    this.init();
  }

  init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Animation parameters - customizable via attributes
    this.startScale = parseFloat(this.element.getAttribute('start-scale')) || 1.2;
    this.endScale = parseFloat(this.element.getAttribute('end-scale')) || 1.0;
    this.speed = parseFloat(this.element.getAttribute('speed')) || 3;

    // Target all images within this element
    this.selector = 'img';
    this._requery();

    this._io = new IntersectionObserver(this._onIO, {
      threshold: [0, 1],
      root: null,
      rootMargin: '25% 0px'
    });
    this._io.observe(this.element);

    this._queue();
  }

  destroy() {
    if (this._io) this._io.disconnect();
    if (this.delegateWindow) this.delegateWindow.destroy();
    if (this._raf) cancelAnimationFrame(this._raf);
  }

  _requery() {
    this.targets = Array.from(this.element.querySelectorAll(this.selector));
    this.targets.forEach(el => {
      el.style.transformOrigin = 'center center';
      el.style.willChange = 'transform';
    });
  }

  _onIO([entry]) {
    this._inView = entry.isIntersecting || entry.intersectionRatio > 0;

    // bind once, the first time we come into view
    if (this._inView && !this._listenersBound) {
      this.delegateWindow = new Delegate(window);
      this.delegateWindow.on('scroll', this._queue);
      this.delegateWindow.on('resize', this._queue);
      this._listenersBound = true;
    }

    if (this._inView) this._queue();
  }

  _queue() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(this._update);
  }

  _update() {
    this._raf = null;
    if (!this._inView || !this.element.isConnected || !this.targets?.length) return;

    const vh = window.innerHeight || document.documentElement.clientHeight;
    const startLine = 0.85 * vh;
    const endLine = 0;

    for (const el of this.targets) {
      const r = el.getBoundingClientRect();
      const h = r.height || 1;

      const denom = (startLine - endLine) + h;
      let t = (startLine - r.top) / denom;
      if (t < 0) t = 0; else if (t > 1) t = 1;

      // Easing and scale calculation: start big, shrink to normal
      const eased = 1 - Math.pow(1 - t, this.speed);
      const scale = this.startScale + (this.endScale - this.startScale) * eased;

      el.style.transform = `translate3d(0,0,0) scale(${scale})`;
    }
  }
}

// Initialize the scroll animation system
const scrollAnimationController = new ScrollAnimationController();

class ProductCard extends HTMLElement {
  static MAX_VISIBLE_COLORS = 4;
  static COUNT_CLASS = 'color-count-indicator u-p5';

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.handleColorSelector();
  }

  handleColorSelector() {
    const colorWrapper = this.element.querySelector(".pdp-connected-products");
    
    if (!colorWrapper) {
      return;
    }

    const colors = colorWrapper.querySelectorAll(".Selectbox--icon");
    if (!colors.length || colorWrapper.querySelector(`.${ProductCard.COUNT_CLASS}`)) {
      return;
    }

    const totalColors = colors.length;
    if (totalColors > ProductCard.MAX_VISIBLE_COLORS) {
      const excessCount = totalColors - ProductCard.MAX_VISIBLE_COLORS;
      
      colors.forEach((color, index) => {
        if (index >= ProductCard.MAX_VISIBLE_COLORS) {
          color.style.display = 'none';
        }
      });
      
      const countDiv = document.createElement("div");
      countDiv.className = ProductCard.COUNT_CLASS;
      countDiv.textContent = `+${excessCount}`;
      
      colorWrapper.appendChild(countDiv);
    }
  }
}

customElements.define("product-card", ProductCard);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.klaviyoSent = false;
    this.onSubmit = this.onSubmit.bind(this);
    
    // Get Klaviyo settings from data attributes
    this.klaviyoListId = this.element.getAttribute("data-klaviyo-list-id") || '';
    this.klaviyoPublicKey = this.element.getAttribute("data-klaviyo-public-key") || '';
    
    // Set global variables for backward compatibility (if needed)
    window.klaviyoListId = this.klaviyoListId;
    window.klaviyoPublicKey = this.klaviyoPublicKey;
  }

  hasKlaviyoCredentials() {
    return this.klaviyoListId && this.klaviyoPublicKey && 
           this.klaviyoListId.trim() !== '' && this.klaviyoPublicKey.trim() !== '';
  }

  connectedCallback() {
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      sessionStorage.setItem("newsletter-success", "true");
    }

    // Check if we should show success state immediately
    if (sessionStorage.getItem('newsletter-success') === 'true') {
      setTimeout(() => {
        this.showSuccessState();
      }, 500);
    }

    this.initSimpleValidation();
    this.bindEvents();
  }

  initSimpleValidation() {
    const emailInput = this.element.querySelector("#klaviyoEmail");
    const submitButton = this.element.querySelector("[data-role='newsletter-submit']");

    if (!emailInput || !submitButton) return;

    // Enable/disable button based on email validity
    const validateEmail = () => {
      const email = emailInput.value.trim();
      const isValid = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      
      if (isValid) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('disabled');
        submitButton.setAttribute('aria-disabled', 'false');
      } else {
        submitButton.setAttribute('disabled', 'true');
        submitButton.classList.add('disabled');
        submitButton.setAttribute('aria-disabled', 'true');
      }
      
      return isValid;
    };

    // Validate on input
    emailInput.addEventListener('input', validateEmail);
    emailInput.addEventListener('blur', validateEmail);

    // Initial validation
    validateEmail();
  }

  showError(message) {
    // Error display removed - no input-validation element
  }

  hideError() {
    // Error hiding removed - no input-validation element
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='close-modal']", this.closeNewsletter);

    const form = this.element.querySelector("#popupForm");
    if (!form) return;
    this.delegateElement.on("click", "[data-role='newsletter-submit']", this.onSubmit);
    this.delegateElement.on("submit", "#popupForm", this.onSubmit);

  }

  async onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const email = (this.element.querySelector("#klaviyoEmail")?.value || "").trim();
    
    // Simple validation
    if (!email) {
      this.showError("Please enter an email address");
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showError("Please enter a valid email address");
      return;
    }

    if (this.klaviyoSent) return;

    this.klaviyoSent = true;
    this.hideError();
    
    const btn = this.element.querySelector('[data-role="newsletter-submit"]');
    if (btn) btn.setAttribute("disabled", "disabled");

    if (this.hasKlaviyoCredentials()) {
      // Use Klaviyo API
      
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Newsletter Popup",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email,
                  properties: {
                    market_country: this.element.dataset.marketCountry || '',
                    signup_source: "newsletter_popup"
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: this.klaviyoListId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoPublicKey)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.api+json",
              "revision": "2024-10-15"
            },
            body: JSON.stringify(payload),
            keepalive: true
          }
        );

        if (!response.ok) {
          const errorBody = await response.text();
          console.error("Klaviyo subscription failed:", response.status, errorBody);
          throw new Error(`Klaviyo API error: ${response.status}`);
        }

        sessionStorage.setItem("newsletter-success", "true");
        this.showSuccessState();
      } catch (error) {
        console.error("Newsletter popup error:", error);
        this.klaviyoSent = false;
        if (btn) btn.removeAttribute("disabled");
        this.submitToShopify();
        return;
      }
    } else {
      // Use Shopify form submission
      this.submitToShopify();
      return;
    }

    // Reset the submission flag
    this.klaviyoSent = false;
  }

  submitToShopify() {
    try {
      const form = this.element.querySelector("#popupForm");
      if (!form) {
        throw new Error('Newsletter form not found');
      }

      // Set success state immediately since we'll redirect/reload
      sessionStorage.setItem("newsletter-success", "true");
      
      // Remove our event listener temporarily to allow normal submission
      this.delegateElement.off("submit", "#popupForm", this.onSubmit);
      
      // Submit the form normally - this will redirect to the return_to URL
      setTimeout(() => {
        form.submit();
      }, 100);
      
    } catch (error) {
      this.showError('Submission failed. Please try again.');
      this.klaviyoSent = false;
      
      // Re-enable the button
      const btn = this.element.querySelector('[data-role="newsletter-submit"]');
      if (btn) {
        btn.removeAttribute('disabled');
        btn.classList.remove('disabled');
        btn.setAttribute('aria-disabled', 'false');
      }
    }
  }

  clickOpen() {
    this.options.delay = 0;
    this.openNewsletter();
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;
    if (this.options.not_show_subscribed && this.options.is_subscribed) return;
    if (this.options.scroll_amount > 0) {
      // Use GlobalScrollListener for better performance
      if (window.scrollListener) {
        this.myScrollListener = window.scrollListener.addScrollListener(this, this.scrollListener);
      } else {
        document.addEventListener("scroll", this.scrollListener);
      }
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    setTimeout(() => {
      // Add delay class for smoother animation
      document.body.classList.add("newsletter-popup-open-delay");

      // Set display: flex first, then trigger animation
      this.element.style.display = "flex";
      
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
        this.element.setAttribute("aria-expanded", "true");
      });

      localStorage.setItem("popup-seen", true);

      this.delegateBody.on("keydown", this.onEsc.bind(this));
      this.delegateElement.on("click", '[data-action="close-modal"]', this.closeNewsletter);
    }, 1000 * this.options.delay);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeNewsletter(e);
    }
  }

  onTransitionEnd = (event) => {
    if (event.propertyName === "clip-path" || event.propertyName === "-webkit-clip-path") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        requestAnimationFrame(() => {
          // Hide element after animation completes for better performance
          this.element.style.display = "none";
          document.body.classList.remove("newsletter-popup-open-delay");
          this.element.removeEventListener("transitionend", this.onTransitionEnd);
        });
      }
    }
  };

  closeNewsletter = () => {
    this.element.addEventListener("transitionend", this.onTransitionEnd);
    this.element.setAttribute("aria-hidden", "true");
    this.element.setAttribute("aria-expanded", "false");
    this.element.offsetHeight;

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };



  showSuccessState() {
    const popup = this.element;
    const formBox = popup.querySelector('#popupForm');
    const success = popup.querySelector('.newsletter-success-text_wrapper');


    if (formBox) formBox.style.display = 'none';
    if (success) success.style.display = '';
  }

  disconnectedCallback() {
    // Clean up GlobalScrollListener
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  }

}
customElements.define("newsletter-popup", NewsletterPopup);

class CollectionShowcase extends HTMLElement {
  constructor() {
   super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
   
    this.bindEvents();
  }

  bindEvents(){
    // Handle clickable collection items
    this.delegateElement.on('click', '.collection-item--clickable[data-href]', this.handleCollectionItemClick.bind(this));
  }

  handleCollectionItemClick(event, target) {
    // Don't trigger if clicking on a button, link, or interactive element
    if (event.target.closest('a, button, [role="button"], input, select, textarea')) {
      return;
    }
    
    const href = target.getAttribute('data-href');
    if (href) {
      window.location.href = href;
    }
  }
}
customElements.define("collection-showcase", CollectionShowcase);


class ArticleComments extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");



    if (this.commentForm) {
      this.commentForm.addEventListener("submit", (event) => {
        this.customSubmit(event);
      });
    }

    this.bindEvents();
    
    // Only call toggleButton if the form exists
    if (this.element.querySelector(".article-comments__submit-button")) {
      this.toggleButton();
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="scroll-to-comment-form"]',
      this.scrollToCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-comment-form"]',
      this.openCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    const submitButton = this.element.querySelector(".article-comments__submit-button");
    if (submitButton) {
      if (this.buttonState === true) {
        submitButton.removeAttribute("disabled");
      } else {
        submitButton.setAttribute("disabled", true);
      }
    }
  }

  //Escaping first digit for valid querySelector
  escapeSelector(id) {
    // If id starts with a digit, escape it properly
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }


  async loadMore(event, target) {
    event.preventDefault();
    const dataHref = target.getAttribute("data-next-href");

    if (!dataHref) {
      return;
    }

    const loader = this.element.querySelector(".article-comments__load-more-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      // Add small artificial delay because Shopify takes time 
      // validating and approving new comments
      await new Promise(resolve => setTimeout(resolve, 500));

      const response = await fetch(`${window.routes.localeRootUrl}${dataHref}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const newComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      newComments.forEach((comment) => {
        const commentId = comment.getAttribute('id');
        if (!commentId) return;

        const escapedId = this.escapeSelector(commentId);
        if (!commentsContainer.querySelector(`#${escapedId}`)) {
          commentsContainer.appendChild(comment);
        }
      });

      new RevolutionAnimation(this.element);

      const newLoadMoreElement = htmlDocument.querySelector("[data-next-href]");
      const currentLoadMoreElement = this.element.querySelector(".article-comments__load-more-button");

      if (newLoadMoreElement) {
        const newHref = newLoadMoreElement.dataset.nextHref;
        if (currentLoadMoreElement) {
          currentLoadMoreElement.dataset.nextHref = newHref;
          commentsContainer.appendChild(currentLoadMoreElement);
          commentsContainer.appendChild(this.showLessButton);
        }
      } else {
        currentLoadMoreElement?.remove();
        commentsContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden');
      }

    } catch (error) {
      // Failed to load more comments
    } finally {
      loader?.classList.remove("is-visible");
    }
  }


  scrollToCommentForm(event) {
    event.preventDefault();
    const formRect = this.commentForm.getBoundingClientRect();
    const scrollOffset = 50;

    window.scrollTo({
      top: formRect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }

  openCommentForm(event) {
    event.preventDefault();
    const target = event.target;
    const commentForm = this.element.querySelector(".comment-form-wrapper");

    if (!commentForm) return;

    // Open form and scroll to it.
    target.setAttribute("data-action", "scroll-to-comment-form");
    setTimeout(() => {
      this.scrollToCommentForm(event);
    }, 300);

    commentForm.setAttribute("aria-expanded", true);
    requestAnimationFrame(() => {
      commentForm.setAttribute("aria-visible", true);
    });
  }

  customSubmit(event) {
    // Don't prevent default - let the form submit normally
    const titleInput = this.commentForm.querySelector('[name="comment[title]"]');
    const textarea = this.commentForm.querySelector('[name="comment[body]"]');
    
    if (titleInput && textarea && titleInput.value.trim()) {
      textarea.style.color = 'transparent';
      
      const titleValue = titleInput.value.trim();
      const existingText = textarea.value;

      // Only manipulate if there's a title and it's not already included
      if (titleValue && !existingText.includes(`[title] ${titleValue} [title]`)) {
        textarea.value = `[title] ${titleValue} [title]\n\n${existingText}`;
      }
    }
    
    // Let the form submit naturally - don't prevent default or manually submit
  }

  async showLess(event, target) {
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;
    const loader = this.element.querySelector(".article-comments__show-less-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(`${window.routes.localeRootUrl}${firstPageUrl}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
      commentsContainer.prepend(...firstPageComments);

      new RevolutionAnimation(this.element);

      this.showLessButton.classList.add('hidden');

      const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
      if (loadMoreButton) {
        commentsContainer.appendChild(loadMoreButton);
      }

      const containerRect = this.element.getBoundingClientRect();
      const scrollOffset = 150;

      window.scrollTo({
        top: containerRect.top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    } catch (error) {
      // Failed to load first page comments
    } finally {
      loader?.classList.remove("is-visible");
    }
  }
}

customElements.define("article-comments", ArticleComments);



class CollectionItem extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.handleCollectionItemLink();
  }

  handleCollectionItemLink() {
    const collectionItemDiv = this.element.querySelector('.collection-item');
    
    if (!collectionItemDiv) return;

    const hasButton = collectionItemDiv.querySelector('.Button, button');
    
    if (hasButton) return;

    const dataUrl = collectionItemDiv.getAttribute('data-url');
    if (!dataUrl) return;
    
    const anchorElement = document.createElement('a');
    anchorElement.href = dataUrl;
    Array.from(collectionItemDiv.attributes).forEach(attr => {
      if (attr.name !== 'data-url') {
        anchorElement.setAttribute(attr.name, attr.value);
      }
    });
    anchorElement.innerHTML = collectionItemDiv.innerHTML;

    collectionItemDiv.parentNode.replaceChild(anchorElement, collectionItemDiv);    
  }
}

customElements.define('pc-collection-item', CollectionItem);

/**
 * HeaderTransparencyController
 * 
 * Manages the Header--Transparent class based on:
 * 1. Scroll position (removes after 25px, restores when back to top)
 * 2. Drawer states (cart, sidebar, mobile menu)
 * 3. Popup states (any popup in the header area)
 * 4. Desktop menu dropdown states
 * 
 * Only restores transparency if it was initially present.
 */
class HeaderTransparencyController {
  constructor() {
    this.header = document.querySelector('header-component') || 
                  document.querySelector('header') || 
                  document.querySelector('.Header');
    
    if (!this.header) return;

    this.scrollThreshold = 25;
    this.wasInitiallyTransparent = this.header.classList.contains('Header--Transparent');
    this.isTransparent = this.wasInitiallyTransparent;
    this.isScrolledPast = false;
    
    // Track different states that should remove transparency
    this.blockingStates = {
      scroll: false,
      drawer: false,
      popup: false,
      search: false,
      desktopMenu: false,
      mobileMenu: false
    };

    this.init();
  }

  init() {
    this.setupScrollListener(); // This now calls scrollHandler() which updates transparency
    this.setupDrawerListeners();
    this.setupPopupListeners();
    this.setupSearchListeners();
    this.setupDesktopMenuListeners();
    this.setupMobileMenuListeners();
  }

  /**
   * Manages transparency based on current blocking states
   */
  updateTransparency() {
    const hasBlockingStates = Object.values(this.blockingStates).some(state => state);
    const shouldBeTransparent = this.wasInitiallyTransparent && !hasBlockingStates;

    if (shouldBeTransparent && !this.isTransparent) {
      this.header.classList.add('Header--Transparent');
      this.isTransparent = true;
    } else if (!shouldBeTransparent && this.isTransparent) {
      this.header.classList.remove('Header--Transparent');
      this.isTransparent = false;
    }
  }

  /**
   * Set up scroll listener using existing GlobalScrollListener
   */
  setupScrollListener() {
    let isFirstCall = true;
    
    const scrollHandler = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const newScrolledPast = scrollTop > this.scrollThreshold;
      
      // Always update on first call, or when state changes
      if (isFirstCall || newScrolledPast !== this.isScrolledPast) {
        isFirstCall = false;
        this.isScrolledPast = newScrolledPast;
        this.blockingStates.scroll = newScrolledPast;
        this.updateTransparency();
      }
    };

    // Use existing global scroll listener
    if (window.scrollListener) {
      this.scrollListenerRemover = window.scrollListener.addScrollListener(this, scrollHandler);
    } else {
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }
    
    // Check initial scroll position on init
    scrollHandler();
  }

  /**
   * Listen to drawer events
   */
  setupDrawerListeners() {
    // Generic drawer open/close events (covers all drawers)
    document.body.addEventListener('drawer:open', (event) => {
      this.blockingStates.drawer = true;
      this.updateTransparency();
    });

    document.body.addEventListener('drawer:closed', (event) => {
      this.blockingStates.drawer = false;
      this.updateTransparency();
    });

    // Specific drawer events (for backward compatibility)
    document.body.addEventListener('cart-drawer:open', () => {
      this.blockingStates.drawer = true;
      this.updateTransparency();
    });

    document.body.addEventListener('cart-drawer:closed', () => {
      this.blockingStates.drawer = false;
      this.updateTransparency();
    });

    document.body.addEventListener('account-drawer:open', () => {
      this.blockingStates.drawer = true;
      this.updateTransparency();
    });

    document.body.addEventListener('account-drawer:closed', () => {
      this.blockingStates.drawer = false;
      this.updateTransparency();
    });

    document.body.addEventListener('sidebar-drawer:open', () => {
      this.blockingStates.drawer = true;
      this.updateTransparency();
    });

    document.body.addEventListener('menu-drawer:closed', () => {
      this.blockingStates.drawer = false;
      this.updateTransparency();
    });

    // Generic drawer close event
    document.body.addEventListener('drawer:close-other', () => {
      this.blockingStates.drawer = false;
      this.updateTransparency();
    });
  }

  /**
   * Monitor popup states by extending existing Popup class
   */
  setupPopupListeners() {
    // Listen for custom events we'll dispatch from the Popup class
    document.body.addEventListener('header-popup:opened', () => {
      this.blockingStates.popup = true;
      this.updateTransparency();
    });

    document.body.addEventListener('header-popup:closed', () => {
      this.blockingStates.popup = false;
      this.updateTransparency();
    });

    // Also monitor for language/country modals specifically
    document.body.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('[data-action="toggle-popup"]');
      if (toggleButton) {
        const controlsId = toggleButton.getAttribute('aria-controls');
        if (controlsId && (controlsId.includes('modal-country') || controlsId.includes('modal-lang'))) {
          // Small delay to let popup state settle
          setTimeout(() => {
            const modal = document.getElementById(controlsId);
            if (modal && modal.style.display !== 'none' && !modal.hasAttribute('hidden')) {
              this.blockingStates.popup = true;
            } else {
              this.blockingStates.popup = false;
            }
            this.updateTransparency();
          }, 50);
        }
      }
    });
  }

  /**
   * Listen to search events
   */
  setupSearchListeners() {
    document.body.addEventListener('search:open', () => {
      this.blockingStates.search = true;
      this.updateTransparency();
    });

    document.body.addEventListener('search:closed', () => {
      this.blockingStates.search = false;
      this.updateTransparency();
    });
  }

  /**
   * Listen to desktop menu dropdown events
   */
  setupDesktopMenuListeners() {
    document.body.addEventListener('desktop-menu:open', () => {
      this.blockingStates.desktopMenu = true;
      this.updateTransparency();
    });

    document.body.addEventListener('desktop-menu:closed', () => {
      this.blockingStates.desktopMenu = false;
      this.updateTransparency();
    });

    document.body.addEventListener('desktop-menus:close', () => {
      this.blockingStates.desktopMenu = false;
      this.updateTransparency();
    });
  }

  /**
   * Listen to mobile menu events
   */
  setupMobileMenuListeners() {
    // Check if mobile menu is currently open on init
    const mobileMenu = document.querySelector('.mobile-menu');
    
    if (mobileMenu) {
      const isCurrentlyOpen = (mobileMenu.classList.contains('is-open') || 
                              mobileMenu.style.display === 'block') &&
                             mobileMenu.style.display !== 'none' &&
                             mobileMenu.getAttribute('aria-hidden') !== 'true';
      
      if (isCurrentlyOpen) {
        this.blockingStates.mobileMenu = true;
        this.updateTransparency();
      }

      // Watch for mobile menu state changes
      const observer = new MutationObserver(() => {
        const isOpen = (mobileMenu.classList.contains('is-open') || 
                       mobileMenu.style.display === 'block') &&
                      mobileMenu.style.display !== 'none' &&
                      mobileMenu.getAttribute('aria-hidden') !== 'true';
        
        if (isOpen !== this.blockingStates.mobileMenu) {
          this.blockingStates.mobileMenu = isOpen;
          this.updateTransparency();
        }
      });

      observer.observe(mobileMenu, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    } else {
      this.blockingStates.mobileMenu = false;
    }

    // Also listen for drawer events that might be mobile menu related
    document.body.addEventListener('drawer:close-other', () => {
      this.blockingStates.mobileMenu = false;
      this.updateTransparency();
    });
  }

  /**
   * Cleanup method
   */
  destroy() {
    if (this.scrollListenerRemover) {
      this.scrollListenerRemover.removeScrollListener();
    }
  }
}

// Initialize the controller when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.headerTransparencyController = new HeaderTransparencyController();
  });
} else {
  window.headerTransparencyController = new HeaderTransparencyController();
}